// GENERATED FILE — do not edit. Run `pnpm dict:generate`. See ADR 0003.
import type { FormDef, TabDef } from '../types.js'

export const DICTIONARY_VERSION = 2

export const forms: FormDef[] = [
  {
    "key": "company",
    "label": "Company",
    "entityType": "company",
    "tabs": [
      {
        "key": "general",
        "number": 1,
        "label": "General information",
        "shortLabel": "General",
        "coreTables": [
          "companies_general"
        ],
        "sections": [
          {
            "key": "identity",
            "label": "Corporate Data",
            "kind": "fields",
            "tab": "general",
            "order": 0,
            "fields": [
              {
                "key": "legal_company_name",
                "path": "general.identity.legal_company_name",
                "label": "Legal company name",
                "input": "text",
                "tab": "general",
                "section": "identity",
                "order": 0,
                "required": "always",
                "help": "The official registered name including any legal suffix such as Ltd or Plc.",
                "coreTable": "companies_general",
                "coreField": "legal_company_name",
                "dataType": "SingleLineText"
              },
              {
                "key": "datahub.brand_names",
                "path": "general.identity.datahub.brand_names",
                "label": "Brand or trading names",
                "input": "taglist",
                "tab": "general",
                "section": "identity",
                "order": 1,
                "required": "never",
                "help": "Names your company is commonly known by."
              },
              {
                "key": "datahub.former_names",
                "path": "general.identity.datahub.former_names",
                "label": "Former names",
                "input": "taglist",
                "tab": "general",
                "section": "identity",
                "order": 2,
                "required": "never",
                "help": "Previous registered or trading names."
              },
              {
                "key": "company_description",
                "path": "general.identity.company_description",
                "label": "Company description",
                "input": "longtext",
                "tab": "general",
                "section": "identity",
                "order": 3,
                "required": "always",
                "help": "What the company does, the markets it serves and how it makes money. Neutral and factual, present tense.",
                "maxLength": 2000,
                "coreTable": "companies_general",
                "coreField": "company_description",
                "dataType": "LongText"
              },
              {
                "key": "website_url",
                "path": "general.identity.website_url",
                "label": "Website",
                "input": "url",
                "tab": "general",
                "section": "identity",
                "order": 4,
                "required": "always",
                "coreTable": "companies_general",
                "coreField": "website_url",
                "dataType": "URL"
              },
              {
                "key": "founding_year",
                "path": "general.identity.founding_year",
                "label": "Year founded",
                "input": "year",
                "tab": "general",
                "section": "identity",
                "order": 5,
                "required": "never",
                "coreTable": "companies_general",
                "coreField": "founding_year",
                "dataType": "Number"
              },
              {
                "key": "incorporation_year",
                "path": "general.identity.incorporation_year",
                "label": "Year incorporated",
                "input": "year",
                "tab": "general",
                "section": "identity",
                "order": 6,
                "required": "never",
                "coreTable": "companies_general",
                "coreField": "incorporation_year",
                "dataType": "Number"
              },
              {
                "key": "country_of_incorporation",
                "path": "general.identity.country_of_incorporation",
                "label": "Country of incorporation",
                "input": "select",
                "tab": "general",
                "section": "identity",
                "order": 7,
                "required": "always",
                "options": [
                  {
                    "value": "nigeria",
                    "label": "Nigeria"
                  },
                  {
                    "value": "ghana",
                    "label": "Ghana"
                  },
                  {
                    "value": "senegal",
                    "label": "Senegal"
                  },
                  {
                    "value": "cote-divoire",
                    "label": "Côte d'Ivoire"
                  },
                  {
                    "value": "mali",
                    "label": "Mali"
                  },
                  {
                    "value": "benin",
                    "label": "Benin"
                  },
                  {
                    "value": "togo",
                    "label": "Togo"
                  },
                  {
                    "value": "burkina-faso",
                    "label": "Burkina Faso"
                  },
                  {
                    "value": "sierra-leone",
                    "label": "Sierra Leone"
                  },
                  {
                    "value": "liberia",
                    "label": "Liberia"
                  },
                  {
                    "value": "guinea",
                    "label": "Guinea"
                  },
                  {
                    "value": "kenya",
                    "label": "Kenya"
                  },
                  {
                    "value": "tanzania",
                    "label": "Tanzania"
                  },
                  {
                    "value": "uganda",
                    "label": "Uganda"
                  },
                  {
                    "value": "rwanda",
                    "label": "Rwanda"
                  },
                  {
                    "value": "ethiopia",
                    "label": "Ethiopia"
                  },
                  {
                    "value": "somalia",
                    "label": "Somalia"
                  },
                  {
                    "value": "burundi",
                    "label": "Burundi"
                  },
                  {
                    "value": "south-sudan",
                    "label": "South Sudan"
                  },
                  {
                    "value": "south-africa",
                    "label": "South Africa"
                  },
                  {
                    "value": "botswana",
                    "label": "Botswana"
                  },
                  {
                    "value": "namibia",
                    "label": "Namibia"
                  },
                  {
                    "value": "zambia",
                    "label": "Zambia"
                  },
                  {
                    "value": "zimbabwe",
                    "label": "Zimbabwe"
                  },
                  {
                    "value": "mozambique",
                    "label": "Mozambique"
                  },
                  {
                    "value": "malawi",
                    "label": "Malawi"
                  },
                  {
                    "value": "mauritius",
                    "label": "Mauritius"
                  },
                  {
                    "value": "egypt",
                    "label": "Egypt"
                  },
                  {
                    "value": "morocco",
                    "label": "Morocco"
                  },
                  {
                    "value": "tunisia",
                    "label": "Tunisia"
                  },
                  {
                    "value": "algeria",
                    "label": "Algeria"
                  },
                  {
                    "value": "libya",
                    "label": "Libya"
                  },
                  {
                    "value": "sudan",
                    "label": "Sudan"
                  },
                  {
                    "value": "cameroon",
                    "label": "Cameroon"
                  },
                  {
                    "value": "drc",
                    "label": "Democratic Republic of the Congo"
                  },
                  {
                    "value": "gabon",
                    "label": "Gabon"
                  },
                  {
                    "value": "chad",
                    "label": "Chad"
                  },
                  {
                    "value": "congo",
                    "label": "Republic of the Congo"
                  },
                  {
                    "value": "united-kingdom",
                    "label": "United Kingdom"
                  },
                  {
                    "value": "united-states",
                    "label": "United States"
                  },
                  {
                    "value": "netherlands",
                    "label": "Netherlands"
                  },
                  {
                    "value": "france",
                    "label": "France"
                  },
                  {
                    "value": "united-arab-emirates",
                    "label": "United Arab Emirates"
                  },
                  {
                    "value": "mauritius-ibc",
                    "label": "Mauritius (IBC)"
                  },
                  {
                    "value": "cayman-islands",
                    "label": "Cayman Islands"
                  },
                  {
                    "value": "luxembourg",
                    "label": "Luxembourg"
                  }
                ],
                "taxonomy": "countries",
                "coreTable": "companies_general",
                "coreField": "country_of_incorporation",
                "dataType": "Links"
              },
              {
                "key": "legal_status",
                "path": "general.identity.legal_status",
                "label": "Legal status",
                "input": "multiselect",
                "tab": "general",
                "section": "identity",
                "order": 8,
                "required": "never",
                "options": [
                  {
                    "value": "Private Limited Company",
                    "label": "Private Limited Company"
                  },
                  {
                    "value": "Public Limited Company",
                    "label": "Public Limited Company"
                  },
                  {
                    "value": "Limited Liability Company",
                    "label": "Limited Liability Company"
                  },
                  {
                    "value": "Partnership",
                    "label": "Partnership"
                  },
                  {
                    "value": "Sole Proprietorship",
                    "label": "Sole Proprietorship"
                  },
                  {
                    "value": "Cooperative",
                    "label": "Cooperative"
                  },
                  {
                    "value": "NGO / Non-Profit",
                    "label": "NGO / Non-Profit"
                  },
                  {
                    "value": "Government Entity",
                    "label": "Government Entity"
                  },
                  {
                    "value": "Trust",
                    "label": "Trust"
                  },
                  {
                    "value": "Other",
                    "label": "Other"
                  }
                ],
                "coreTable": "companies_general",
                "coreField": "legal_status",
                "dataType": "MultiSelect"
              },
              {
                "key": "datahub.exchange",
                "path": "general.identity.datahub.exchange",
                "label": "Stock exchange",
                "input": "select",
                "tab": "general",
                "section": "identity",
                "order": 9,
                "required": "never",
                "visibleWhen": {
                  "field": "ownership_status",
                  "eq": "Public"
                },
                "options": [
                  {
                    "value": "ngx",
                    "label": "Nigerian Exchange (NGX)"
                  },
                  {
                    "value": "jse",
                    "label": "Johannesburg Stock Exchange (JSE)"
                  },
                  {
                    "value": "nse-kenya",
                    "label": "Nairobi Securities Exchange (NSE)"
                  },
                  {
                    "value": "gse",
                    "label": "Ghana Stock Exchange (GSE)"
                  },
                  {
                    "value": "egx",
                    "label": "Egyptian Exchange (EGX)"
                  },
                  {
                    "value": "brvm",
                    "label": "Bourse Régionale des Valeurs Mobilières (BRVM)"
                  },
                  {
                    "value": "cse",
                    "label": "Casablanca Stock Exchange"
                  },
                  {
                    "value": "lse",
                    "label": "London Stock Exchange"
                  },
                  {
                    "value": "nasdaq",
                    "label": "Nasdaq"
                  },
                  {
                    "value": "nyse",
                    "label": "New York Stock Exchange"
                  },
                  {
                    "value": "other",
                    "label": "Other"
                  }
                ],
                "taxonomy": "exchanges"
              },
              {
                "key": "datahub.ticker",
                "path": "general.identity.datahub.ticker",
                "label": "Ticker symbol",
                "input": "text",
                "tab": "general",
                "section": "identity",
                "order": 10,
                "required": "never",
                "visibleWhen": {
                  "field": "ownership_status",
                  "eq": "Public"
                }
              }
            ]
          },
          {
            "key": "classification",
            "label": "Classification",
            "kind": "fields",
            "tab": "general",
            "order": 1,
            "fields": [
              {
                "key": "sectors",
                "path": "general.classification.sectors",
                "label": "Sector",
                "input": "select",
                "tab": "general",
                "section": "classification",
                "order": 0,
                "required": "always",
                "help": "The primary economic sector.",
                "options": [
                  {
                    "value": "financial-services",
                    "label": "Financial Services"
                  },
                  {
                    "value": "technology",
                    "label": "Technology"
                  },
                  {
                    "value": "consumer-goods",
                    "label": "Consumer Goods & Services"
                  },
                  {
                    "value": "healthcare",
                    "label": "Healthcare"
                  },
                  {
                    "value": "energy-utilities",
                    "label": "Energy & Utilities"
                  },
                  {
                    "value": "agriculture",
                    "label": "Agriculture"
                  },
                  {
                    "value": "industrials",
                    "label": "Industrials"
                  },
                  {
                    "value": "telecommunications",
                    "label": "Telecommunications"
                  },
                  {
                    "value": "real-estate",
                    "label": "Real Estate"
                  },
                  {
                    "value": "transport-logistics",
                    "label": "Transport & Logistics"
                  },
                  {
                    "value": "education",
                    "label": "Education"
                  },
                  {
                    "value": "media-entertainment",
                    "label": "Media & Entertainment"
                  },
                  {
                    "value": "mining-natural-resources",
                    "label": "Mining & Natural Resources"
                  },
                  {
                    "value": "construction",
                    "label": "Construction"
                  },
                  {
                    "value": "hospitality-tourism",
                    "label": "Hospitality & Tourism"
                  },
                  {
                    "value": "professional-services",
                    "label": "Professional Services"
                  }
                ],
                "taxonomy": "sectors",
                "coreTable": "companies_general",
                "coreField": "sectors",
                "dataType": "MultiSelect"
              },
              {
                "key": "sub_sector_updated",
                "path": "general.classification.sub_sector_updated",
                "label": "Sub-sectors",
                "input": "multiselect",
                "tab": "general",
                "section": "classification",
                "order": 1,
                "required": "always",
                "help": "Select all that apply within your sector.",
                "options": [
                  {
                    "value": "payments",
                    "label": "Payments",
                    "group": "financial-services"
                  },
                  {
                    "value": "msme-lending",
                    "label": "MSME Lending",
                    "group": "financial-services"
                  },
                  {
                    "value": "microfinance-institutions",
                    "label": "Microfinance Institutions",
                    "group": "financial-services"
                  },
                  {
                    "value": "fintech-platforms-other",
                    "label": "FinTech Platforms (Other)",
                    "group": "financial-services"
                  },
                  {
                    "value": "banking",
                    "label": "Banking",
                    "group": "financial-services"
                  },
                  {
                    "value": "insurance",
                    "label": "Insurance",
                    "group": "financial-services"
                  },
                  {
                    "value": "insurtech",
                    "label": "InsurTech",
                    "group": "financial-services"
                  },
                  {
                    "value": "asset-management",
                    "label": "Asset Management",
                    "group": "financial-services"
                  },
                  {
                    "value": "mutual-funds",
                    "label": "Mutual Funds",
                    "group": "financial-services"
                  },
                  {
                    "value": "pension-management",
                    "label": "Pension Management",
                    "group": "financial-services"
                  },
                  {
                    "value": "wealth-management",
                    "label": "Wealth Management",
                    "group": "financial-services"
                  },
                  {
                    "value": "capital-markets",
                    "label": "Capital Markets",
                    "group": "financial-services"
                  },
                  {
                    "value": "enterprise-software",
                    "label": "Enterprise Software",
                    "group": "technology"
                  },
                  {
                    "value": "marketplaces",
                    "label": "Marketplaces",
                    "group": "technology"
                  },
                  {
                    "value": "data-analytics",
                    "label": "Data & Analytics",
                    "group": "technology"
                  },
                  {
                    "value": "cloud-infrastructure",
                    "label": "Cloud & Infrastructure",
                    "group": "technology"
                  },
                  {
                    "value": "cybersecurity",
                    "label": "Cybersecurity",
                    "group": "technology"
                  },
                  {
                    "value": "e-commerce",
                    "label": "E-Commerce",
                    "group": "consumer-goods"
                  },
                  {
                    "value": "food-beverage",
                    "label": "Food & Beverage",
                    "group": "consumer-goods"
                  },
                  {
                    "value": "fmcg",
                    "label": "FMCG",
                    "group": "consumer-goods"
                  },
                  {
                    "value": "retail",
                    "label": "Retail",
                    "group": "consumer-goods"
                  },
                  {
                    "value": "clinics-hospitals",
                    "label": "Clinics & Hospitals",
                    "group": "healthcare"
                  },
                  {
                    "value": "pharmaceuticals",
                    "label": "Pharmaceuticals",
                    "group": "healthcare"
                  },
                  {
                    "value": "healthtech",
                    "label": "HealthTech",
                    "group": "healthcare"
                  },
                  {
                    "value": "renewables",
                    "label": "Renewables",
                    "group": "energy-utilities"
                  },
                  {
                    "value": "oil-gas",
                    "label": "Oil & Gas",
                    "group": "energy-utilities"
                  },
                  {
                    "value": "power-generation",
                    "label": "Power Generation",
                    "group": "energy-utilities"
                  },
                  {
                    "value": "off-grid-solar",
                    "label": "Off-Grid Solar",
                    "group": "energy-utilities"
                  },
                  {
                    "value": "agri-inputs",
                    "label": "Agri Inputs",
                    "group": "agriculture"
                  },
                  {
                    "value": "agri-processing",
                    "label": "Agri Processing",
                    "group": "agriculture"
                  },
                  {
                    "value": "agritech",
                    "label": "AgriTech",
                    "group": "agriculture"
                  },
                  {
                    "value": "manufacturing",
                    "label": "Manufacturing",
                    "group": "industrials"
                  },
                  {
                    "value": "packaging",
                    "label": "Packaging",
                    "group": "industrials"
                  },
                  {
                    "value": "mobile-network-operators",
                    "label": "Mobile Network Operators",
                    "group": "telecommunications"
                  },
                  {
                    "value": "telecom-infrastructure",
                    "label": "Telecom Infrastructure",
                    "group": "telecommunications"
                  },
                  {
                    "value": "commercial-property",
                    "label": "Commercial Property",
                    "group": "real-estate"
                  },
                  {
                    "value": "residential-property",
                    "label": "Residential Property",
                    "group": "real-estate"
                  },
                  {
                    "value": "logistics-delivery",
                    "label": "Logistics & Delivery",
                    "group": "transport-logistics"
                  },
                  {
                    "value": "mobility",
                    "label": "Mobility",
                    "group": "transport-logistics"
                  },
                  {
                    "value": "edtech",
                    "label": "EdTech",
                    "group": "education"
                  },
                  {
                    "value": "schools-universities",
                    "label": "Schools & Universities",
                    "group": "education"
                  },
                  {
                    "value": "media-publishing",
                    "label": "Media & Publishing",
                    "group": "media-entertainment"
                  },
                  {
                    "value": "mining",
                    "label": "Mining",
                    "group": "mining-natural-resources"
                  },
                  {
                    "value": "construction-engineering",
                    "label": "Construction & Engineering",
                    "group": "construction"
                  },
                  {
                    "value": "hotels-leisure",
                    "label": "Hotels & Leisure",
                    "group": "hospitality-tourism"
                  },
                  {
                    "value": "legal-advisory",
                    "label": "Legal & Advisory",
                    "group": "professional-services"
                  }
                ],
                "taxonomy": "subsectors",
                "filterBy": "sectors",
                "coreTable": "companies_general",
                "coreField": "sub_sector_updated",
                "dataType": "Links"
              },
              {
                "key": "countries_of_operation",
                "path": "general.classification.countries_of_operation",
                "label": "Countries of operation",
                "input": "multiselect",
                "tab": "general",
                "section": "classification",
                "order": 2,
                "required": "never",
                "help": "Countries where you sell, operate or have active customers.",
                "options": [
                  {
                    "value": "nigeria",
                    "label": "Nigeria"
                  },
                  {
                    "value": "ghana",
                    "label": "Ghana"
                  },
                  {
                    "value": "senegal",
                    "label": "Senegal"
                  },
                  {
                    "value": "cote-divoire",
                    "label": "Côte d'Ivoire"
                  },
                  {
                    "value": "mali",
                    "label": "Mali"
                  },
                  {
                    "value": "benin",
                    "label": "Benin"
                  },
                  {
                    "value": "togo",
                    "label": "Togo"
                  },
                  {
                    "value": "burkina-faso",
                    "label": "Burkina Faso"
                  },
                  {
                    "value": "sierra-leone",
                    "label": "Sierra Leone"
                  },
                  {
                    "value": "liberia",
                    "label": "Liberia"
                  },
                  {
                    "value": "guinea",
                    "label": "Guinea"
                  },
                  {
                    "value": "kenya",
                    "label": "Kenya"
                  },
                  {
                    "value": "tanzania",
                    "label": "Tanzania"
                  },
                  {
                    "value": "uganda",
                    "label": "Uganda"
                  },
                  {
                    "value": "rwanda",
                    "label": "Rwanda"
                  },
                  {
                    "value": "ethiopia",
                    "label": "Ethiopia"
                  },
                  {
                    "value": "somalia",
                    "label": "Somalia"
                  },
                  {
                    "value": "burundi",
                    "label": "Burundi"
                  },
                  {
                    "value": "south-sudan",
                    "label": "South Sudan"
                  },
                  {
                    "value": "south-africa",
                    "label": "South Africa"
                  },
                  {
                    "value": "botswana",
                    "label": "Botswana"
                  },
                  {
                    "value": "namibia",
                    "label": "Namibia"
                  },
                  {
                    "value": "zambia",
                    "label": "Zambia"
                  },
                  {
                    "value": "zimbabwe",
                    "label": "Zimbabwe"
                  },
                  {
                    "value": "mozambique",
                    "label": "Mozambique"
                  },
                  {
                    "value": "malawi",
                    "label": "Malawi"
                  },
                  {
                    "value": "mauritius",
                    "label": "Mauritius"
                  },
                  {
                    "value": "egypt",
                    "label": "Egypt"
                  },
                  {
                    "value": "morocco",
                    "label": "Morocco"
                  },
                  {
                    "value": "tunisia",
                    "label": "Tunisia"
                  },
                  {
                    "value": "algeria",
                    "label": "Algeria"
                  },
                  {
                    "value": "libya",
                    "label": "Libya"
                  },
                  {
                    "value": "sudan",
                    "label": "Sudan"
                  },
                  {
                    "value": "cameroon",
                    "label": "Cameroon"
                  },
                  {
                    "value": "drc",
                    "label": "Democratic Republic of the Congo"
                  },
                  {
                    "value": "gabon",
                    "label": "Gabon"
                  },
                  {
                    "value": "chad",
                    "label": "Chad"
                  },
                  {
                    "value": "congo",
                    "label": "Republic of the Congo"
                  },
                  {
                    "value": "united-kingdom",
                    "label": "United Kingdom"
                  },
                  {
                    "value": "united-states",
                    "label": "United States"
                  },
                  {
                    "value": "netherlands",
                    "label": "Netherlands"
                  },
                  {
                    "value": "france",
                    "label": "France"
                  },
                  {
                    "value": "united-arab-emirates",
                    "label": "United Arab Emirates"
                  },
                  {
                    "value": "mauritius-ibc",
                    "label": "Mauritius (IBC)"
                  },
                  {
                    "value": "cayman-islands",
                    "label": "Cayman Islands"
                  },
                  {
                    "value": "luxembourg",
                    "label": "Luxembourg"
                  }
                ],
                "taxonomy": "countries",
                "coreTable": "companies_general",
                "coreField": "countries_of_operation",
                "dataType": "Links"
              },
              {
                "key": "business_model_customer",
                "path": "general.classification.business_model_customer",
                "label": "Customer focus",
                "input": "multiselect",
                "tab": "general",
                "section": "classification",
                "order": 3,
                "required": "never",
                "options": [
                  {
                    "value": "B2B",
                    "label": "B2B"
                  },
                  {
                    "value": "B2C",
                    "label": "B2C"
                  },
                  {
                    "value": "B2B2C",
                    "label": "B2B2C"
                  }
                ],
                "coreTable": "companies_general",
                "coreField": "business_model_customer",
                "dataType": "MultiSelect"
              },
              {
                "key": "business_model_revenue",
                "path": "general.classification.business_model_revenue",
                "label": "Revenue model",
                "input": "multiselect",
                "tab": "general",
                "section": "classification",
                "order": 4,
                "required": "never",
                "options": [
                  {
                    "value": "Marketplace",
                    "label": "Marketplace"
                  },
                  {
                    "value": "Subscription",
                    "label": "Subscription"
                  },
                  {
                    "value": "Manufacturing",
                    "label": "Manufacturing"
                  },
                  {
                    "value": "Retail/E-commerce",
                    "label": "Retail/E-commerce"
                  },
                  {
                    "value": "Advertising",
                    "label": "Advertising"
                  },
                  {
                    "value": "Transactional",
                    "label": "Transactional"
                  },
                  {
                    "value": "Freemium",
                    "label": "Freemium"
                  },
                  {
                    "value": "Licensing",
                    "label": "Licensing"
                  },
                  {
                    "value": "Franchise",
                    "label": "Franchise"
                  },
                  {
                    "value": "Rental/Leasing",
                    "label": "Rental/Leasing"
                  },
                  {
                    "value": "Consulting/Advisory",
                    "label": "Consulting/Advisory"
                  },
                  {
                    "value": "Financial Services",
                    "label": "Financial Services"
                  },
                  {
                    "value": "Asset Management",
                    "label": "Asset Management"
                  }
                ],
                "coreTable": "companies_general",
                "coreField": "business_model_revenue",
                "dataType": "MultiSelect"
              },
              {
                "key": "distribution_model",
                "path": "general.classification.distribution_model",
                "label": "Distribution model",
                "input": "multiselect",
                "tab": "general",
                "section": "classification",
                "order": 5,
                "required": "never",
                "options": [
                  {
                    "value": "Direct Sales",
                    "label": "Direct Sales"
                  },
                  {
                    "value": "Indirect Sales",
                    "label": "Indirect Sales"
                  },
                  {
                    "value": "Online/Digital Distribution",
                    "label": "Online/Digital Distribution"
                  },
                  {
                    "value": "Physical Retail",
                    "label": "Physical Retail"
                  },
                  {
                    "value": "Wholesale",
                    "label": "Wholesale"
                  },
                  {
                    "value": "Marketplace Platform",
                    "label": "Marketplace Platform"
                  },
                  {
                    "value": "Franchise",
                    "label": "Franchise"
                  },
                  {
                    "value": "Agents/Brokers",
                    "label": "Agents/Brokers"
                  },
                  {
                    "value": "Logistics & Fulfilment Partners",
                    "label": "Logistics & Fulfilment Partners"
                  },
                  {
                    "value": "Embedded or Integrated",
                    "label": "Embedded or Integrated"
                  }
                ],
                "coreTable": "companies_general",
                "coreField": "distribution_model",
                "dataType": "MultiSelect"
              }
            ]
          },
          {
            "key": "status_size",
            "label": "Status and size",
            "kind": "fields",
            "tab": "general",
            "order": 2,
            "fields": [
              {
                "key": "ownership_status",
                "path": "general.status_size.ownership_status",
                "label": "Ownership status",
                "input": "select",
                "tab": "general",
                "section": "status_size",
                "order": 0,
                "required": "always",
                "options": [
                  {
                    "value": "Private",
                    "label": "Private"
                  },
                  {
                    "value": "Public",
                    "label": "Public"
                  },
                  {
                    "value": "Government",
                    "label": "Government"
                  },
                  {
                    "value": "Non-Profit / NGO",
                    "label": "Non-Profit / NGO"
                  }
                ],
                "coreTable": "companies_general",
                "coreField": "ownership_status",
                "dataType": "SingleSelect"
              },
              {
                "key": "company_status",
                "path": "general.status_size.company_status",
                "label": "Company status",
                "input": "select",
                "tab": "general",
                "section": "status_size",
                "order": 1,
                "required": "always",
                "options": [
                  {
                    "value": "Active",
                    "label": "Active"
                  },
                  {
                    "value": "Defunct",
                    "label": "Defunct"
                  },
                  {
                    "value": "Merged/Acquired",
                    "label": "Merged/Acquired"
                  }
                ],
                "coreTable": "companies_general",
                "coreField": "company_status",
                "dataType": "SingleSelect"
              },
              {
                "key": "employee_count",
                "path": "general.status_size.employee_count",
                "label": "Employee count (range)",
                "input": "select",
                "tab": "general",
                "section": "status_size",
                "order": 2,
                "required": "always",
                "options": [
                  {
                    "value": "1-10",
                    "label": "1-10"
                  },
                  {
                    "value": "11-50",
                    "label": "11-50"
                  },
                  {
                    "value": "51-200",
                    "label": "51-200"
                  },
                  {
                    "value": "201-500",
                    "label": "201-500"
                  },
                  {
                    "value": "501-1000",
                    "label": "501-1000"
                  },
                  {
                    "value": "1001-5000",
                    "label": "1001-5000"
                  },
                  {
                    "value": "5000+",
                    "label": "5000+"
                  }
                ],
                "coreTable": "companies_general",
                "coreField": "employee_count",
                "dataType": "SingleSelect"
              },
              {
                "key": "datahub.headcount_exact",
                "path": "general.status_size.datahub.headcount_exact",
                "label": "Exact headcount",
                "input": "number",
                "tab": "general",
                "section": "status_size",
                "order": 3,
                "required": "never",
                "help": "Optional. Leave blank if you prefer to give only a range."
              },
              {
                "key": "datahub.headcount_as_of",
                "path": "general.status_size.datahub.headcount_as_of",
                "label": "Headcount as at",
                "input": "date",
                "tab": "general",
                "section": "status_size",
                "order": 4,
                "required": "never",
                "visibleWhen": {
                  "field": "datahub.headcount_exact",
                  "present": true
                }
              },
              {
                "key": "profitability_if_private",
                "path": "general.status_size.profitability_if_private",
                "label": "Profitability status",
                "input": "select",
                "tab": "general",
                "section": "status_size",
                "order": 5,
                "required": "never",
                "options": [
                  {
                    "value": "Profitable",
                    "label": "Profitable"
                  },
                  {
                    "value": "EBITDA Positive",
                    "label": "EBITDA Positive"
                  },
                  {
                    "value": "Cash Flow Positive",
                    "label": "Cash Flow Positive"
                  },
                  {
                    "value": "Not Profitable",
                    "label": "Not Profitable"
                  },
                  {
                    "value": "Pre-Revenue",
                    "label": "Pre-Revenue"
                  },
                  {
                    "value": "Break-Even",
                    "label": "Break-Even"
                  },
                  {
                    "value": "Unknown / Not Stated",
                    "label": "Unknown / Not Stated"
                  }
                ],
                "coreTable": "companies_general",
                "coreField": "profitability_if_private",
                "dataType": "SingleSelect"
              },
              {
                "key": "type_if_banking",
                "path": "general.status_size.type_if_banking",
                "label": "Bank or non-bank",
                "input": "radio",
                "tab": "general",
                "section": "status_size",
                "order": 6,
                "required": "always",
                "help": "Banks report additional metrics on the Financials tab.",
                "options": [
                  {
                    "value": "Bank",
                    "label": "Bank"
                  },
                  {
                    "value": "Non-Bank",
                    "label": "Non-Bank"
                  }
                ],
                "coreTable": "companies_general",
                "coreField": "type_if_banking",
                "dataType": "SingleSelect"
              }
            ]
          },
          {
            "key": "structure",
            "label": "Corporate structure",
            "kind": "fields",
            "tab": "general",
            "order": 3,
            "fields": [
              {
                "key": "datahub.parent_company_name",
                "path": "general.structure.datahub.parent_company_name",
                "label": "Parent company",
                "input": "text",
                "tab": "general",
                "section": "structure",
                "order": 0,
                "required": "never"
              },
              {
                "key": "datahub.ultimate_parent_name",
                "path": "general.structure.datahub.ultimate_parent_name",
                "label": "Ultimate parent",
                "input": "text",
                "tab": "general",
                "section": "structure",
                "order": 1,
                "required": "never"
              }
            ]
          },
          {
            "key": "subsidiaries",
            "label": "Subsidiaries",
            "kind": "repeatable",
            "tab": "general",
            "order": 4,
            "fields": [
              {
                "key": "datahub.name",
                "path": "general.subsidiaries.datahub.name",
                "label": "Company name",
                "input": "text",
                "tab": "general",
                "section": "subsidiaries",
                "order": 0,
                "required": "always"
              },
              {
                "key": "datahub.country",
                "path": "general.subsidiaries.datahub.country",
                "label": "Country",
                "input": "select",
                "tab": "general",
                "section": "subsidiaries",
                "order": 1,
                "required": "never",
                "options": [
                  {
                    "value": "nigeria",
                    "label": "Nigeria"
                  },
                  {
                    "value": "ghana",
                    "label": "Ghana"
                  },
                  {
                    "value": "senegal",
                    "label": "Senegal"
                  },
                  {
                    "value": "cote-divoire",
                    "label": "Côte d'Ivoire"
                  },
                  {
                    "value": "mali",
                    "label": "Mali"
                  },
                  {
                    "value": "benin",
                    "label": "Benin"
                  },
                  {
                    "value": "togo",
                    "label": "Togo"
                  },
                  {
                    "value": "burkina-faso",
                    "label": "Burkina Faso"
                  },
                  {
                    "value": "sierra-leone",
                    "label": "Sierra Leone"
                  },
                  {
                    "value": "liberia",
                    "label": "Liberia"
                  },
                  {
                    "value": "guinea",
                    "label": "Guinea"
                  },
                  {
                    "value": "kenya",
                    "label": "Kenya"
                  },
                  {
                    "value": "tanzania",
                    "label": "Tanzania"
                  },
                  {
                    "value": "uganda",
                    "label": "Uganda"
                  },
                  {
                    "value": "rwanda",
                    "label": "Rwanda"
                  },
                  {
                    "value": "ethiopia",
                    "label": "Ethiopia"
                  },
                  {
                    "value": "somalia",
                    "label": "Somalia"
                  },
                  {
                    "value": "burundi",
                    "label": "Burundi"
                  },
                  {
                    "value": "south-sudan",
                    "label": "South Sudan"
                  },
                  {
                    "value": "south-africa",
                    "label": "South Africa"
                  },
                  {
                    "value": "botswana",
                    "label": "Botswana"
                  },
                  {
                    "value": "namibia",
                    "label": "Namibia"
                  },
                  {
                    "value": "zambia",
                    "label": "Zambia"
                  },
                  {
                    "value": "zimbabwe",
                    "label": "Zimbabwe"
                  },
                  {
                    "value": "mozambique",
                    "label": "Mozambique"
                  },
                  {
                    "value": "malawi",
                    "label": "Malawi"
                  },
                  {
                    "value": "mauritius",
                    "label": "Mauritius"
                  },
                  {
                    "value": "egypt",
                    "label": "Egypt"
                  },
                  {
                    "value": "morocco",
                    "label": "Morocco"
                  },
                  {
                    "value": "tunisia",
                    "label": "Tunisia"
                  },
                  {
                    "value": "algeria",
                    "label": "Algeria"
                  },
                  {
                    "value": "libya",
                    "label": "Libya"
                  },
                  {
                    "value": "sudan",
                    "label": "Sudan"
                  },
                  {
                    "value": "cameroon",
                    "label": "Cameroon"
                  },
                  {
                    "value": "drc",
                    "label": "Democratic Republic of the Congo"
                  },
                  {
                    "value": "gabon",
                    "label": "Gabon"
                  },
                  {
                    "value": "chad",
                    "label": "Chad"
                  },
                  {
                    "value": "congo",
                    "label": "Republic of the Congo"
                  },
                  {
                    "value": "united-kingdom",
                    "label": "United Kingdom"
                  },
                  {
                    "value": "united-states",
                    "label": "United States"
                  },
                  {
                    "value": "netherlands",
                    "label": "Netherlands"
                  },
                  {
                    "value": "france",
                    "label": "France"
                  },
                  {
                    "value": "united-arab-emirates",
                    "label": "United Arab Emirates"
                  },
                  {
                    "value": "mauritius-ibc",
                    "label": "Mauritius (IBC)"
                  },
                  {
                    "value": "cayman-islands",
                    "label": "Cayman Islands"
                  },
                  {
                    "value": "luxembourg",
                    "label": "Luxembourg"
                  }
                ],
                "taxonomy": "countries"
              },
              {
                "key": "datahub.ownership_pct",
                "path": "general.subsidiaries.datahub.ownership_pct",
                "label": "Ownership %",
                "input": "percent",
                "tab": "general",
                "section": "subsidiaries",
                "order": 2,
                "required": "never"
              }
            ],
            "rowEntity": "subsidiary",
            "rowLabel": "{name}",
            "toggle": {
              "key": "nothing_to_add",
              "label": "No subsidiaries to report"
            }
          },
          {
            "key": "tags",
            "label": "Optional tags",
            "kind": "fields",
            "tab": "general",
            "order": 5,
            "fields": [
              {
                "key": "esg_tags",
                "path": "general.tags.esg_tags",
                "label": "ESG tags",
                "input": "multiselect",
                "tab": "general",
                "section": "tags",
                "order": 0,
                "required": "never",
                "options": [
                  {
                    "value": "Carbon-Neutral",
                    "label": "Carbon-Neutral"
                  },
                  {
                    "value": "Net Zero Commitment",
                    "label": "Net Zero Commitment"
                  },
                  {
                    "value": "Renewable Energy-Powered",
                    "label": "Renewable Energy-Powered"
                  },
                  {
                    "value": "Sustainable Supply Chain",
                    "label": "Sustainable Supply Chain"
                  },
                  {
                    "value": "Circular Economy Focused",
                    "label": "Circular Economy Focused"
                  },
                  {
                    "value": "Green Certified",
                    "label": "Green Certified"
                  },
                  {
                    "value": "ClimateTech Company",
                    "label": "ClimateTech Company"
                  },
                  {
                    "value": "Female-Founded",
                    "label": "Female-Founded"
                  },
                  {
                    "value": "Minority-Founded",
                    "label": "Minority-Founded"
                  },
                  {
                    "value": "Diverse Leadership Team",
                    "label": "Diverse Leadership Team"
                  },
                  {
                    "value": "B-Corp Certified",
                    "label": "B-Corp Certified"
                  },
                  {
                    "value": "Fair Trade Certified",
                    "label": "Fair Trade Certified"
                  },
                  {
                    "value": "Employee-Owned",
                    "label": "Employee-Owned"
                  },
                  {
                    "value": "Disability-Inclusive Workplace",
                    "label": "Disability-Inclusive Workplace"
                  },
                  {
                    "value": "Social Impact-Focused",
                    "label": "Social Impact-Focused"
                  },
                  {
                    "value": "ESG-Reporting Company",
                    "label": "ESG-Reporting Company"
                  },
                  {
                    "value": "Public Benefit Corporation",
                    "label": "Public Benefit Corporation"
                  },
                  {
                    "value": "Governance-Transparent",
                    "label": "Governance-Transparent"
                  }
                ],
                "coreTable": "companies_general",
                "coreField": "esg_tags",
                "dataType": "MultiSelect"
              },
              {
                "key": "ai_tag",
                "path": "general.tags.ai_tag",
                "label": "AI adoption",
                "input": "select",
                "tab": "general",
                "section": "tags",
                "order": 1,
                "required": "never",
                "options": [
                  {
                    "value": "AI-Native",
                    "label": "AI-Native"
                  },
                  {
                    "value": "AI-First",
                    "label": "AI-First"
                  },
                  {
                    "value": "AI-Adopted",
                    "label": "AI-Adopted"
                  },
                  {
                    "value": "AI-Experimenting",
                    "label": "AI-Experimenting"
                  },
                  {
                    "value": "No Material AI",
                    "label": "No Material AI"
                  }
                ],
                "coreTable": "companies_general",
                "coreField": "ai_tag",
                "dataType": "SingleSelect"
              }
            ],
            "collapsed": true
          }
        ],
        "intro": "Confirm the details Stears holds about your company. Fields marked required must be completed."
      },
      {
        "key": "contacts",
        "number": 2,
        "label": "Contacts and locations",
        "shortLabel": "Contacts",
        "coreTables": [
          "companies_general"
        ],
        "sections": [
          {
            "key": "hq",
            "label": "Headquarters",
            "kind": "fields",
            "tab": "contacts",
            "order": 0,
            "fields": [
              {
                "key": "datahub.hq_street",
                "path": "contacts.hq.datahub.hq_street",
                "label": "Street address",
                "input": "text",
                "tab": "contacts",
                "section": "hq",
                "order": 0,
                "required": "never"
              },
              {
                "key": "datahub.hq_city",
                "path": "contacts.hq.datahub.hq_city",
                "label": "City",
                "input": "text",
                "tab": "contacts",
                "section": "hq",
                "order": 1,
                "required": "always"
              },
              {
                "key": "datahub.hq_state",
                "path": "contacts.hq.datahub.hq_state",
                "label": "State or region",
                "input": "text",
                "tab": "contacts",
                "section": "hq",
                "order": 2,
                "required": "never"
              },
              {
                "key": "datahub.hq_postcode",
                "path": "contacts.hq.datahub.hq_postcode",
                "label": "Postcode",
                "input": "text",
                "tab": "contacts",
                "section": "hq",
                "order": 3,
                "required": "never"
              },
              {
                "key": "datahub.hq_country",
                "path": "contacts.hq.datahub.hq_country",
                "label": "Country",
                "input": "select",
                "tab": "contacts",
                "section": "hq",
                "order": 4,
                "required": "always",
                "options": [
                  {
                    "value": "nigeria",
                    "label": "Nigeria"
                  },
                  {
                    "value": "ghana",
                    "label": "Ghana"
                  },
                  {
                    "value": "senegal",
                    "label": "Senegal"
                  },
                  {
                    "value": "cote-divoire",
                    "label": "Côte d'Ivoire"
                  },
                  {
                    "value": "mali",
                    "label": "Mali"
                  },
                  {
                    "value": "benin",
                    "label": "Benin"
                  },
                  {
                    "value": "togo",
                    "label": "Togo"
                  },
                  {
                    "value": "burkina-faso",
                    "label": "Burkina Faso"
                  },
                  {
                    "value": "sierra-leone",
                    "label": "Sierra Leone"
                  },
                  {
                    "value": "liberia",
                    "label": "Liberia"
                  },
                  {
                    "value": "guinea",
                    "label": "Guinea"
                  },
                  {
                    "value": "kenya",
                    "label": "Kenya"
                  },
                  {
                    "value": "tanzania",
                    "label": "Tanzania"
                  },
                  {
                    "value": "uganda",
                    "label": "Uganda"
                  },
                  {
                    "value": "rwanda",
                    "label": "Rwanda"
                  },
                  {
                    "value": "ethiopia",
                    "label": "Ethiopia"
                  },
                  {
                    "value": "somalia",
                    "label": "Somalia"
                  },
                  {
                    "value": "burundi",
                    "label": "Burundi"
                  },
                  {
                    "value": "south-sudan",
                    "label": "South Sudan"
                  },
                  {
                    "value": "south-africa",
                    "label": "South Africa"
                  },
                  {
                    "value": "botswana",
                    "label": "Botswana"
                  },
                  {
                    "value": "namibia",
                    "label": "Namibia"
                  },
                  {
                    "value": "zambia",
                    "label": "Zambia"
                  },
                  {
                    "value": "zimbabwe",
                    "label": "Zimbabwe"
                  },
                  {
                    "value": "mozambique",
                    "label": "Mozambique"
                  },
                  {
                    "value": "malawi",
                    "label": "Malawi"
                  },
                  {
                    "value": "mauritius",
                    "label": "Mauritius"
                  },
                  {
                    "value": "egypt",
                    "label": "Egypt"
                  },
                  {
                    "value": "morocco",
                    "label": "Morocco"
                  },
                  {
                    "value": "tunisia",
                    "label": "Tunisia"
                  },
                  {
                    "value": "algeria",
                    "label": "Algeria"
                  },
                  {
                    "value": "libya",
                    "label": "Libya"
                  },
                  {
                    "value": "sudan",
                    "label": "Sudan"
                  },
                  {
                    "value": "cameroon",
                    "label": "Cameroon"
                  },
                  {
                    "value": "drc",
                    "label": "Democratic Republic of the Congo"
                  },
                  {
                    "value": "gabon",
                    "label": "Gabon"
                  },
                  {
                    "value": "chad",
                    "label": "Chad"
                  },
                  {
                    "value": "congo",
                    "label": "Republic of the Congo"
                  },
                  {
                    "value": "united-kingdom",
                    "label": "United Kingdom"
                  },
                  {
                    "value": "united-states",
                    "label": "United States"
                  },
                  {
                    "value": "netherlands",
                    "label": "Netherlands"
                  },
                  {
                    "value": "france",
                    "label": "France"
                  },
                  {
                    "value": "united-arab-emirates",
                    "label": "United Arab Emirates"
                  },
                  {
                    "value": "mauritius-ibc",
                    "label": "Mauritius (IBC)"
                  },
                  {
                    "value": "cayman-islands",
                    "label": "Cayman Islands"
                  },
                  {
                    "value": "luxembourg",
                    "label": "Luxembourg"
                  }
                ],
                "taxonomy": "countries"
              },
              {
                "key": "datahub.general_phone",
                "path": "contacts.hq.datahub.general_phone",
                "label": "General phone",
                "input": "tel",
                "tab": "contacts",
                "section": "hq",
                "order": 5,
                "required": "never"
              },
              {
                "key": "datahub.general_email",
                "path": "contacts.hq.datahub.general_email",
                "label": "General email",
                "input": "email",
                "tab": "contacts",
                "section": "hq",
                "order": 6,
                "required": "never"
              }
            ]
          },
          {
            "key": "online",
            "label": "Online",
            "kind": "fields",
            "tab": "contacts",
            "order": 1,
            "fields": [
              {
                "key": "datahub.linkedin_url",
                "path": "contacts.online.datahub.linkedin_url",
                "label": "LinkedIn",
                "input": "url",
                "tab": "contacts",
                "section": "online",
                "order": 0,
                "required": "never"
              },
              {
                "key": "datahub.x_url",
                "path": "contacts.online.datahub.x_url",
                "label": "X (Twitter)",
                "input": "url",
                "tab": "contacts",
                "section": "online",
                "order": 1,
                "required": "never"
              },
              {
                "key": "datahub.facebook_url",
                "path": "contacts.online.datahub.facebook_url",
                "label": "Facebook",
                "input": "url",
                "tab": "contacts",
                "section": "online",
                "order": 2,
                "required": "never"
              },
              {
                "key": "datahub.instagram_url",
                "path": "contacts.online.datahub.instagram_url",
                "label": "Instagram",
                "input": "url",
                "tab": "contacts",
                "section": "online",
                "order": 3,
                "required": "never"
              },
              {
                "key": "datahub.youtube_url",
                "path": "contacts.online.datahub.youtube_url",
                "label": "YouTube",
                "input": "url",
                "tab": "contacts",
                "section": "online",
                "order": 4,
                "required": "never"
              }
            ]
          },
          {
            "key": "offices",
            "label": "Other offices",
            "kind": "repeatable",
            "tab": "contacts",
            "order": 2,
            "fields": [
              {
                "key": "datahub.office_type",
                "path": "contacts.offices.datahub.office_type",
                "label": "Office type",
                "input": "select",
                "tab": "contacts",
                "section": "offices",
                "order": 0,
                "required": "always",
                "options": [
                  {
                    "value": "Registered office",
                    "label": "Registered office"
                  },
                  {
                    "value": "Regional office",
                    "label": "Regional office"
                  },
                  {
                    "value": "Branch",
                    "label": "Branch"
                  },
                  {
                    "value": "Other",
                    "label": "Other"
                  }
                ]
              },
              {
                "key": "datahub.city",
                "path": "contacts.offices.datahub.city",
                "label": "City",
                "input": "text",
                "tab": "contacts",
                "section": "offices",
                "order": 1,
                "required": "always"
              },
              {
                "key": "datahub.country",
                "path": "contacts.offices.datahub.country",
                "label": "Country",
                "input": "select",
                "tab": "contacts",
                "section": "offices",
                "order": 2,
                "required": "always",
                "options": [
                  {
                    "value": "nigeria",
                    "label": "Nigeria"
                  },
                  {
                    "value": "ghana",
                    "label": "Ghana"
                  },
                  {
                    "value": "senegal",
                    "label": "Senegal"
                  },
                  {
                    "value": "cote-divoire",
                    "label": "Côte d'Ivoire"
                  },
                  {
                    "value": "mali",
                    "label": "Mali"
                  },
                  {
                    "value": "benin",
                    "label": "Benin"
                  },
                  {
                    "value": "togo",
                    "label": "Togo"
                  },
                  {
                    "value": "burkina-faso",
                    "label": "Burkina Faso"
                  },
                  {
                    "value": "sierra-leone",
                    "label": "Sierra Leone"
                  },
                  {
                    "value": "liberia",
                    "label": "Liberia"
                  },
                  {
                    "value": "guinea",
                    "label": "Guinea"
                  },
                  {
                    "value": "kenya",
                    "label": "Kenya"
                  },
                  {
                    "value": "tanzania",
                    "label": "Tanzania"
                  },
                  {
                    "value": "uganda",
                    "label": "Uganda"
                  },
                  {
                    "value": "rwanda",
                    "label": "Rwanda"
                  },
                  {
                    "value": "ethiopia",
                    "label": "Ethiopia"
                  },
                  {
                    "value": "somalia",
                    "label": "Somalia"
                  },
                  {
                    "value": "burundi",
                    "label": "Burundi"
                  },
                  {
                    "value": "south-sudan",
                    "label": "South Sudan"
                  },
                  {
                    "value": "south-africa",
                    "label": "South Africa"
                  },
                  {
                    "value": "botswana",
                    "label": "Botswana"
                  },
                  {
                    "value": "namibia",
                    "label": "Namibia"
                  },
                  {
                    "value": "zambia",
                    "label": "Zambia"
                  },
                  {
                    "value": "zimbabwe",
                    "label": "Zimbabwe"
                  },
                  {
                    "value": "mozambique",
                    "label": "Mozambique"
                  },
                  {
                    "value": "malawi",
                    "label": "Malawi"
                  },
                  {
                    "value": "mauritius",
                    "label": "Mauritius"
                  },
                  {
                    "value": "egypt",
                    "label": "Egypt"
                  },
                  {
                    "value": "morocco",
                    "label": "Morocco"
                  },
                  {
                    "value": "tunisia",
                    "label": "Tunisia"
                  },
                  {
                    "value": "algeria",
                    "label": "Algeria"
                  },
                  {
                    "value": "libya",
                    "label": "Libya"
                  },
                  {
                    "value": "sudan",
                    "label": "Sudan"
                  },
                  {
                    "value": "cameroon",
                    "label": "Cameroon"
                  },
                  {
                    "value": "drc",
                    "label": "Democratic Republic of the Congo"
                  },
                  {
                    "value": "gabon",
                    "label": "Gabon"
                  },
                  {
                    "value": "chad",
                    "label": "Chad"
                  },
                  {
                    "value": "congo",
                    "label": "Republic of the Congo"
                  },
                  {
                    "value": "united-kingdom",
                    "label": "United Kingdom"
                  },
                  {
                    "value": "united-states",
                    "label": "United States"
                  },
                  {
                    "value": "netherlands",
                    "label": "Netherlands"
                  },
                  {
                    "value": "france",
                    "label": "France"
                  },
                  {
                    "value": "united-arab-emirates",
                    "label": "United Arab Emirates"
                  },
                  {
                    "value": "mauritius-ibc",
                    "label": "Mauritius (IBC)"
                  },
                  {
                    "value": "cayman-islands",
                    "label": "Cayman Islands"
                  },
                  {
                    "value": "luxembourg",
                    "label": "Luxembourg"
                  }
                ],
                "taxonomy": "countries"
              },
              {
                "key": "datahub.address",
                "path": "contacts.offices.datahub.address",
                "label": "Address",
                "input": "text",
                "tab": "contacts",
                "section": "offices",
                "order": 3,
                "required": "never"
              }
            ],
            "rowEntity": "location",
            "rowLabel": "{city}, {country}",
            "toggle": {
              "key": "nothing_to_add",
              "label": "No other offices to report"
            }
          },
          {
            "key": "datahub_contacts",
            "label": "People who receive this link",
            "kind": "repeatable",
            "tab": "contacts",
            "order": 3,
            "fields": [
              {
                "key": "datahub.full_name",
                "path": "contacts.datahub_contacts.datahub.full_name",
                "label": "Name",
                "input": "text",
                "tab": "contacts",
                "section": "datahub_contacts",
                "order": 0,
                "required": "always"
              },
              {
                "key": "datahub.role_title",
                "path": "contacts.datahub_contacts.datahub.role_title",
                "label": "Role",
                "input": "text",
                "tab": "contacts",
                "section": "datahub_contacts",
                "order": 1,
                "required": "never"
              },
              {
                "key": "datahub.email",
                "path": "contacts.datahub_contacts.datahub.email",
                "label": "Email",
                "input": "email",
                "tab": "contacts",
                "section": "datahub_contacts",
                "order": 2,
                "required": "always"
              }
            ],
            "help": "Stears sends the update link to these people. Add a colleague to have them included from the next cycle.",
            "rowEntity": "contact",
            "rowLabel": "{full_name}",
            "minRowsForComplete": 1,
            "readOnlyExisting": true
          }
        ]
      },
      {
        "key": "people",
        "number": 3,
        "label": "Management and board",
        "shortLabel": "People",
        "coreTables": [
          "people_general",
          "people_role_engagements"
        ],
        "sections": [
          {
            "key": "people",
            "label": "Management and board",
            "kind": "repeatable",
            "tab": "people",
            "order": 0,
            "fields": [
              {
                "key": "first_name",
                "path": "people.people.first_name",
                "label": "First name",
                "input": "text",
                "tab": "people",
                "section": "people",
                "order": 0,
                "required": "always",
                "coreTable": "people_general",
                "coreField": "first_name",
                "dataType": "SingleLineText"
              },
              {
                "key": "last_name",
                "path": "people.people.last_name",
                "label": "Last name",
                "input": "text",
                "tab": "people",
                "section": "people",
                "order": 1,
                "required": "always",
                "coreTable": "people_general",
                "coreField": "last_name",
                "dataType": "SingleLineText"
              },
              {
                "key": "role_title",
                "path": "people.people.role_title",
                "label": "Role title",
                "input": "text",
                "tab": "people",
                "section": "people",
                "order": 2,
                "required": "always",
                "help": "The exact title, for example Chief Executive Officer or Managing Director.",
                "coreTable": "people_role_engagements",
                "coreField": "role_title",
                "dataType": "SingleLineText"
              },
              {
                "key": "role_category",
                "path": "people.people.role_category",
                "label": "Role category",
                "input": "select",
                "tab": "people",
                "section": "people",
                "order": 3,
                "required": "always",
                "options": [
                  {
                    "value": "C-Suite / Executive",
                    "label": "C-Suite / Executive"
                  },
                  {
                    "value": "Senior Management",
                    "label": "Senior Management"
                  },
                  {
                    "value": "Executive Director",
                    "label": "Executive Director"
                  },
                  {
                    "value": "Non-Executive Director",
                    "label": "Non-Executive Director"
                  },
                  {
                    "value": "Board Chair / Vice-Chair",
                    "label": "Board Chair / Vice-Chair"
                  },
                  {
                    "value": "Board Committee Chair / Member",
                    "label": "Board Committee Chair / Member"
                  },
                  {
                    "value": "Founder / Co-Founder",
                    "label": "Founder / Co-Founder"
                  },
                  {
                    "value": "General Partner (GP)",
                    "label": "General Partner (GP)"
                  },
                  {
                    "value": "Limited Partner (LP)",
                    "label": "Limited Partner (LP)"
                  },
                  {
                    "value": "Partner",
                    "label": "Partner"
                  },
                  {
                    "value": "Board Observer",
                    "label": "Board Observer"
                  },
                  {
                    "value": "Senior Advisor / Consultant",
                    "label": "Senior Advisor / Consultant"
                  },
                  {
                    "value": "IC Chairperson",
                    "label": "IC Chairperson"
                  },
                  {
                    "value": "Internal IC Members",
                    "label": "Internal IC Members"
                  },
                  {
                    "value": "External IC Members",
                    "label": "External IC Members"
                  },
                  {
                    "value": "Board of Governor",
                    "label": "Board of Governor"
                  }
                ],
                "grouped": true,
                "coreTable": "people_role_engagements",
                "coreField": "role_category",
                "dataType": "SingleSelect"
              },
              {
                "key": "datahub.management_status",
                "path": "people.people.datahub.management_status",
                "label": "Management status",
                "input": "radio",
                "tab": "people",
                "section": "people",
                "order": 4,
                "required": "always",
                "options": [
                  {
                    "value": "Team member",
                    "label": "Team member"
                  },
                  {
                    "value": "Board member",
                    "label": "Board member"
                  }
                ]
              },
              {
                "key": "start_date",
                "path": "people.people.start_date",
                "label": "Start date",
                "input": "date",
                "tab": "people",
                "section": "people",
                "order": 5,
                "required": "never",
                "precision": true,
                "coreTable": "people_role_engagements",
                "coreField": "start_date",
                "dataType": "Date"
              },
              {
                "key": "role_status",
                "path": "people.people.role_status",
                "label": "Status",
                "input": "radio",
                "tab": "people",
                "section": "people",
                "order": 6,
                "required": "always",
                "options": [
                  {
                    "value": "Current",
                    "label": "Current"
                  },
                  {
                    "value": "Former",
                    "label": "Former"
                  }
                ],
                "coreTable": "people_role_engagements",
                "coreField": "role_status",
                "dataType": "SingleSelect"
              },
              {
                "key": "end_date",
                "path": "people.people.end_date",
                "label": "End date",
                "input": "date",
                "tab": "people",
                "section": "people",
                "order": 7,
                "required": "conditional",
                "requiredWhen": {
                  "field": "role_status",
                  "eq": "Former"
                },
                "visibleWhen": {
                  "field": "role_status",
                  "eq": "Former"
                },
                "coreTable": "people_role_engagements",
                "coreField": "end_date",
                "dataType": "Date"
              },
              {
                "key": "datahub.represents",
                "path": "people.people.datahub.represents",
                "label": "Represents",
                "input": "text",
                "tab": "people",
                "section": "people",
                "order": 8,
                "required": "never",
                "visibleWhen": {
                  "field": "datahub.management_status",
                  "eq": "Board member"
                },
                "help": "For board members appointed by an investor, name the investor."
              },
              {
                "key": "datahub.location_city",
                "path": "people.people.datahub.location_city",
                "label": "City",
                "input": "text",
                "tab": "people",
                "section": "people",
                "order": 9,
                "required": "never"
              },
              {
                "key": "datahub.location_country",
                "path": "people.people.datahub.location_country",
                "label": "Country of primary residence",
                "input": "select",
                "tab": "people",
                "section": "people",
                "order": 10,
                "required": "never",
                "options": [
                  {
                    "value": "nigeria",
                    "label": "Nigeria"
                  },
                  {
                    "value": "ghana",
                    "label": "Ghana"
                  },
                  {
                    "value": "senegal",
                    "label": "Senegal"
                  },
                  {
                    "value": "cote-divoire",
                    "label": "Côte d'Ivoire"
                  },
                  {
                    "value": "mali",
                    "label": "Mali"
                  },
                  {
                    "value": "benin",
                    "label": "Benin"
                  },
                  {
                    "value": "togo",
                    "label": "Togo"
                  },
                  {
                    "value": "burkina-faso",
                    "label": "Burkina Faso"
                  },
                  {
                    "value": "sierra-leone",
                    "label": "Sierra Leone"
                  },
                  {
                    "value": "liberia",
                    "label": "Liberia"
                  },
                  {
                    "value": "guinea",
                    "label": "Guinea"
                  },
                  {
                    "value": "kenya",
                    "label": "Kenya"
                  },
                  {
                    "value": "tanzania",
                    "label": "Tanzania"
                  },
                  {
                    "value": "uganda",
                    "label": "Uganda"
                  },
                  {
                    "value": "rwanda",
                    "label": "Rwanda"
                  },
                  {
                    "value": "ethiopia",
                    "label": "Ethiopia"
                  },
                  {
                    "value": "somalia",
                    "label": "Somalia"
                  },
                  {
                    "value": "burundi",
                    "label": "Burundi"
                  },
                  {
                    "value": "south-sudan",
                    "label": "South Sudan"
                  },
                  {
                    "value": "south-africa",
                    "label": "South Africa"
                  },
                  {
                    "value": "botswana",
                    "label": "Botswana"
                  },
                  {
                    "value": "namibia",
                    "label": "Namibia"
                  },
                  {
                    "value": "zambia",
                    "label": "Zambia"
                  },
                  {
                    "value": "zimbabwe",
                    "label": "Zimbabwe"
                  },
                  {
                    "value": "mozambique",
                    "label": "Mozambique"
                  },
                  {
                    "value": "malawi",
                    "label": "Malawi"
                  },
                  {
                    "value": "mauritius",
                    "label": "Mauritius"
                  },
                  {
                    "value": "egypt",
                    "label": "Egypt"
                  },
                  {
                    "value": "morocco",
                    "label": "Morocco"
                  },
                  {
                    "value": "tunisia",
                    "label": "Tunisia"
                  },
                  {
                    "value": "algeria",
                    "label": "Algeria"
                  },
                  {
                    "value": "libya",
                    "label": "Libya"
                  },
                  {
                    "value": "sudan",
                    "label": "Sudan"
                  },
                  {
                    "value": "cameroon",
                    "label": "Cameroon"
                  },
                  {
                    "value": "drc",
                    "label": "Democratic Republic of the Congo"
                  },
                  {
                    "value": "gabon",
                    "label": "Gabon"
                  },
                  {
                    "value": "chad",
                    "label": "Chad"
                  },
                  {
                    "value": "congo",
                    "label": "Republic of the Congo"
                  },
                  {
                    "value": "united-kingdom",
                    "label": "United Kingdom"
                  },
                  {
                    "value": "united-states",
                    "label": "United States"
                  },
                  {
                    "value": "netherlands",
                    "label": "Netherlands"
                  },
                  {
                    "value": "france",
                    "label": "France"
                  },
                  {
                    "value": "united-arab-emirates",
                    "label": "United Arab Emirates"
                  },
                  {
                    "value": "mauritius-ibc",
                    "label": "Mauritius (IBC)"
                  },
                  {
                    "value": "cayman-islands",
                    "label": "Cayman Islands"
                  },
                  {
                    "value": "luxembourg",
                    "label": "Luxembourg"
                  }
                ],
                "taxonomy": "countries"
              },
              {
                "key": "linkedin_url",
                "path": "people.people.linkedin_url",
                "label": "LinkedIn",
                "input": "url",
                "tab": "people",
                "section": "people",
                "order": 11,
                "required": "never",
                "coreTable": "people_general",
                "coreField": "linkedin_url",
                "dataType": "URL"
              },
              {
                "key": "email",
                "path": "people.people.email",
                "label": "Professional email",
                "input": "email",
                "tab": "people",
                "section": "people",
                "order": 12,
                "required": "never",
                "help": "Held in Stears internal records only, never published.",
                "confidential": "always",
                "coreTable": "people_general",
                "coreField": "email",
                "dataType": "Email"
              },
              {
                "key": "phone_number",
                "path": "people.people.phone_number",
                "label": "Phone",
                "input": "tel",
                "tab": "people",
                "section": "people",
                "order": 13,
                "required": "never",
                "help": "Held in Stears internal records only, never published.",
                "confidential": "always",
                "coreTable": "people_general",
                "coreField": "phone_number",
                "dataType": "PhoneNumber"
              },
              {
                "key": "biography",
                "path": "people.people.biography",
                "label": "Biography",
                "input": "longtext",
                "tab": "people",
                "section": "people",
                "order": 14,
                "required": "never",
                "maxLength": 1500,
                "coreTable": "people_general",
                "coreField": "biography",
                "dataType": "LongText"
              },
              {
                "key": "gender",
                "path": "people.people.gender",
                "label": "Gender",
                "input": "select",
                "tab": "people",
                "section": "people",
                "order": 15,
                "required": "never",
                "help": "Optional. Used only for aggregate diversity reporting.",
                "options": [
                  {
                    "value": "Male",
                    "label": "Male"
                  },
                  {
                    "value": "Female",
                    "label": "Female"
                  },
                  {
                    "value": "Other",
                    "label": "Other"
                  },
                  {
                    "value": "Undisclosed",
                    "label": "Undisclosed"
                  }
                ],
                "coreTable": "people_general",
                "coreField": "gender",
                "dataType": "SingleSelect"
              },
              {
                "key": "nationality",
                "path": "people.people.nationality",
                "label": "Nationality",
                "input": "multiselect",
                "tab": "people",
                "section": "people",
                "order": 16,
                "required": "never",
                "help": "Optional.",
                "options": [
                  {
                    "value": "nigeria",
                    "label": "Nigeria"
                  },
                  {
                    "value": "ghana",
                    "label": "Ghana"
                  },
                  {
                    "value": "senegal",
                    "label": "Senegal"
                  },
                  {
                    "value": "cote-divoire",
                    "label": "Côte d'Ivoire"
                  },
                  {
                    "value": "mali",
                    "label": "Mali"
                  },
                  {
                    "value": "benin",
                    "label": "Benin"
                  },
                  {
                    "value": "togo",
                    "label": "Togo"
                  },
                  {
                    "value": "burkina-faso",
                    "label": "Burkina Faso"
                  },
                  {
                    "value": "sierra-leone",
                    "label": "Sierra Leone"
                  },
                  {
                    "value": "liberia",
                    "label": "Liberia"
                  },
                  {
                    "value": "guinea",
                    "label": "Guinea"
                  },
                  {
                    "value": "kenya",
                    "label": "Kenya"
                  },
                  {
                    "value": "tanzania",
                    "label": "Tanzania"
                  },
                  {
                    "value": "uganda",
                    "label": "Uganda"
                  },
                  {
                    "value": "rwanda",
                    "label": "Rwanda"
                  },
                  {
                    "value": "ethiopia",
                    "label": "Ethiopia"
                  },
                  {
                    "value": "somalia",
                    "label": "Somalia"
                  },
                  {
                    "value": "burundi",
                    "label": "Burundi"
                  },
                  {
                    "value": "south-sudan",
                    "label": "South Sudan"
                  },
                  {
                    "value": "south-africa",
                    "label": "South Africa"
                  },
                  {
                    "value": "botswana",
                    "label": "Botswana"
                  },
                  {
                    "value": "namibia",
                    "label": "Namibia"
                  },
                  {
                    "value": "zambia",
                    "label": "Zambia"
                  },
                  {
                    "value": "zimbabwe",
                    "label": "Zimbabwe"
                  },
                  {
                    "value": "mozambique",
                    "label": "Mozambique"
                  },
                  {
                    "value": "malawi",
                    "label": "Malawi"
                  },
                  {
                    "value": "mauritius",
                    "label": "Mauritius"
                  },
                  {
                    "value": "egypt",
                    "label": "Egypt"
                  },
                  {
                    "value": "morocco",
                    "label": "Morocco"
                  },
                  {
                    "value": "tunisia",
                    "label": "Tunisia"
                  },
                  {
                    "value": "algeria",
                    "label": "Algeria"
                  },
                  {
                    "value": "libya",
                    "label": "Libya"
                  },
                  {
                    "value": "sudan",
                    "label": "Sudan"
                  },
                  {
                    "value": "cameroon",
                    "label": "Cameroon"
                  },
                  {
                    "value": "drc",
                    "label": "Democratic Republic of the Congo"
                  },
                  {
                    "value": "gabon",
                    "label": "Gabon"
                  },
                  {
                    "value": "chad",
                    "label": "Chad"
                  },
                  {
                    "value": "congo",
                    "label": "Republic of the Congo"
                  },
                  {
                    "value": "united-kingdom",
                    "label": "United Kingdom"
                  },
                  {
                    "value": "united-states",
                    "label": "United States"
                  },
                  {
                    "value": "netherlands",
                    "label": "Netherlands"
                  },
                  {
                    "value": "france",
                    "label": "France"
                  },
                  {
                    "value": "united-arab-emirates",
                    "label": "United Arab Emirates"
                  },
                  {
                    "value": "mauritius-ibc",
                    "label": "Mauritius (IBC)"
                  },
                  {
                    "value": "cayman-islands",
                    "label": "Cayman Islands"
                  },
                  {
                    "value": "luxembourg",
                    "label": "Luxembourg"
                  }
                ],
                "taxonomy": "countries",
                "coreTable": "people_general",
                "coreField": "nationality",
                "dataType": "Links"
              }
            ],
            "rowEntity": "person_role",
            "rowLabel": "{first_name} {last_name} — {role_title}",
            "toggle": {
              "key": "no_changes",
              "label": "No changes to management or board"
            }
          }
        ],
        "intro": "One row per role. Someone who is both a founder and the chief executive has two rows."
      },
      {
        "key": "ownership",
        "number": 4,
        "label": "Ownership",
        "shortLabel": "Ownership",
        "coreTables": [
          "companies_ownership_structure"
        ],
        "sections": [
          {
            "key": "owners",
            "label": "Shareholders",
            "kind": "repeatable",
            "tab": "ownership",
            "order": 0,
            "fields": [
              {
                "key": "owner_name",
                "path": "ownership.owners.owner_name",
                "label": "Owner name",
                "input": "text",
                "tab": "ownership",
                "section": "owners",
                "order": 0,
                "required": "always",
                "coreTable": "companies_ownership_structure",
                "coreField": "owner_name",
                "dataType": "SingleLineText"
              },
              {
                "key": "datahub.owner_type",
                "path": "ownership.owners.datahub.owner_type",
                "label": "Owner type",
                "input": "select",
                "tab": "ownership",
                "section": "owners",
                "order": 1,
                "required": "always",
                "options": [
                  {
                    "value": "Individual",
                    "label": "Individual"
                  },
                  {
                    "value": "Company",
                    "label": "Company"
                  },
                  {
                    "value": "Fund vehicle",
                    "label": "Fund vehicle"
                  },
                  {
                    "value": "Fund manager (GP)",
                    "label": "Fund manager (GP)"
                  },
                  {
                    "value": "Institutional investor (LP)",
                    "label": "Institutional investor (LP)"
                  },
                  {
                    "value": "Government",
                    "label": "Government"
                  },
                  {
                    "value": "Employee scheme",
                    "label": "Employee scheme"
                  },
                  {
                    "value": "Other",
                    "label": "Other"
                  }
                ]
              },
              {
                "key": "ownership_%",
                "path": "ownership.owners.ownership_%",
                "label": "Ownership % (undiluted)",
                "input": "percent",
                "tab": "ownership",
                "section": "owners",
                "order": 2,
                "required": "never",
                "hiddenWhen": {
                  "control": "percentages_undisclosed"
                },
                "coreTable": "companies_ownership_structure",
                "coreField": "ownership_%",
                "dataType": "Decimal"
              },
              {
                "key": "ownership_percent_diluted",
                "path": "ownership.owners.ownership_percent_diluted",
                "label": "Ownership % (fully diluted)",
                "input": "percent",
                "tab": "ownership",
                "section": "owners",
                "order": 3,
                "required": "never",
                "hiddenWhen": {
                  "control": "percentages_undisclosed"
                },
                "coreTable": "companies_ownership_structure",
                "coreField": "ownership_percent_diluted",
                "dataType": "Decimal"
              },
              {
                "key": "stake_type",
                "path": "ownership.owners.stake_type",
                "label": "Stake type",
                "input": "select",
                "tab": "ownership",
                "section": "owners",
                "order": 4,
                "required": "never",
                "options": [
                  {
                    "value": "Direct",
                    "label": "Direct"
                  },
                  {
                    "value": "Indirect",
                    "label": "Indirect"
                  },
                  {
                    "value": "Fully Diluted",
                    "label": "Fully Diluted"
                  }
                ],
                "coreTable": "companies_ownership_structure",
                "coreField": "stake_type",
                "dataType": "SingleSelect"
              },
              {
                "key": "ownership_stake",
                "path": "ownership.owners.ownership_stake",
                "label": "Stake category",
                "input": "select",
                "tab": "ownership",
                "section": "owners",
                "order": 5,
                "required": "always",
                "options": [
                  {
                    "value": "Majority",
                    "label": "Majority"
                  },
                  {
                    "value": "Minority",
                    "label": "Minority"
                  },
                  {
                    "value": "Strategic Minority",
                    "label": "Strategic Minority"
                  },
                  {
                    "value": "Controlling",
                    "label": "Controlling"
                  },
                  {
                    "value": "Undisclosed",
                    "label": "Undisclosed"
                  }
                ],
                "coreTable": "companies_ownership_structure",
                "coreField": "ownership_stake",
                "dataType": "SingleSelect"
              },
              {
                "key": "shareholder_status",
                "path": "ownership.owners.shareholder_status",
                "label": "Shareholder status",
                "input": "radio",
                "tab": "ownership",
                "section": "owners",
                "order": 6,
                "required": "always",
                "options": [
                  {
                    "value": "Current",
                    "label": "Current"
                  },
                  {
                    "value": "Former",
                    "label": "Former"
                  }
                ],
                "coreTable": "companies_ownership_structure",
                "coreField": "shareholder_status",
                "dataType": "SingleSelect"
              },
              {
                "key": "investment_status",
                "path": "ownership.owners.investment_status",
                "label": "Investment status",
                "input": "select",
                "tab": "ownership",
                "section": "owners",
                "order": 7,
                "required": "never",
                "options": [
                  {
                    "value": "Active",
                    "label": "Active"
                  },
                  {
                    "value": "Partially Realised",
                    "label": "Partially Realised"
                  },
                  {
                    "value": "Fully Realised",
                    "label": "Fully Realised"
                  },
                  {
                    "value": "Written Off",
                    "label": "Written Off"
                  }
                ],
                "coreTable": "companies_ownership_structure",
                "coreField": "investment_status",
                "dataType": "SingleSelect"
              },
              {
                "key": "is_lead_investor",
                "path": "ownership.owners.is_lead_investor",
                "label": "Lead investor",
                "input": "radio",
                "tab": "ownership",
                "section": "owners",
                "order": 8,
                "required": "never",
                "options": [
                  {
                    "value": "Yes",
                    "label": "Yes"
                  },
                  {
                    "value": "No",
                    "label": "No"
                  }
                ],
                "coreTable": "companies_ownership_structure",
                "coreField": "is_lead_investor",
                "dataType": "SingleSelect"
              },
              {
                "key": "is_board_seat",
                "path": "ownership.owners.is_board_seat",
                "label": "Board seat",
                "input": "radio",
                "tab": "ownership",
                "section": "owners",
                "order": 9,
                "required": "never",
                "options": [
                  {
                    "value": "Yes",
                    "label": "Yes"
                  },
                  {
                    "value": "No",
                    "label": "No"
                  }
                ],
                "coreTable": "companies_ownership_structure",
                "coreField": "is_board_seat",
                "dataType": "SingleSelect"
              },
              {
                "key": "primary_instrument",
                "path": "ownership.owners.primary_instrument",
                "label": "Instruments held",
                "input": "multiselect",
                "tab": "ownership",
                "section": "owners",
                "order": 10,
                "required": "never",
                "options": [
                  {
                    "value": "Ordinary Equity",
                    "label": "Ordinary Equity"
                  },
                  {
                    "value": "Preferred Equity",
                    "label": "Preferred Equity"
                  },
                  {
                    "value": "Convertible Note",
                    "label": "Convertible Note"
                  },
                  {
                    "value": "Debt",
                    "label": "Debt"
                  },
                  {
                    "value": "Mixed",
                    "label": "Mixed"
                  },
                  {
                    "value": "Equity",
                    "label": "Equity"
                  },
                  {
                    "value": "Preference Equity",
                    "label": "Preference Equity"
                  }
                ],
                "coreTable": "companies_ownership_structure",
                "coreField": "primary_instrument",
                "dataType": "MultiSelect"
              },
              {
                "key": "has_liquidation_preference",
                "path": "ownership.owners.has_liquidation_preference",
                "label": "Liquidation preference",
                "input": "radio",
                "tab": "ownership",
                "section": "owners",
                "order": 11,
                "required": "never",
                "options": [
                  {
                    "value": "Yes",
                    "label": "Yes"
                  },
                  {
                    "value": "No",
                    "label": "No"
                  }
                ],
                "coreTable": "companies_ownership_structure",
                "coreField": "has_liquidation_preference",
                "dataType": "SingleSelect"
              },
              {
                "key": "liquidation_multiple",
                "path": "ownership.owners.liquidation_multiple",
                "label": "Liquidation multiple",
                "input": "number",
                "tab": "ownership",
                "section": "owners",
                "order": 12,
                "required": "never",
                "visibleWhen": {
                  "field": "has_liquidation_preference",
                  "eq": "Yes"
                },
                "step": 0.1,
                "coreTable": "companies_ownership_structure",
                "coreField": "liquidation_multiple",
                "dataType": "Decimal"
              },
              {
                "key": "datahub.capital_deployed_amount",
                "path": "ownership.owners.datahub.capital_deployed_amount",
                "label": "Capital deployed",
                "input": "money",
                "tab": "ownership",
                "section": "owners",
                "order": 13,
                "required": "never"
              },
              {
                "key": "reporting_date",
                "path": "ownership.owners.reporting_date",
                "label": "As-of date",
                "input": "date",
                "tab": "ownership",
                "section": "owners",
                "order": 14,
                "required": "always",
                "coreTable": "companies_ownership_structure",
                "coreField": "reporting_date",
                "dataType": "Date"
              },
              {
                "key": "source",
                "path": "ownership.owners.source",
                "label": "Source",
                "input": "text",
                "tab": "ownership",
                "section": "owners",
                "order": 15,
                "required": "never",
                "help": "A link or document name supporting these figures.",
                "coreTable": "companies_ownership_structure",
                "coreField": "source",
                "dataType": "SingleLineText"
              }
            ],
            "rowEntity": "owner",
            "rowLabel": "{owner_name}",
            "toggle": {
              "key": "no_changes",
              "label": "No changes to ownership"
            },
            "confidentiality": "row",
            "validate": [
              "ownership_sum"
            ]
          }
        ],
        "intro": "Who owns the company and how much. You can mark the whole cap table confidential.",
        "sectionControls": [
          {
            "key": "cap_table_confidential",
            "input": "checkbox",
            "label": "Cap table is confidential — record it but never publish it"
          },
          {
            "key": "percentages_undisclosed",
            "input": "checkbox",
            "label": "Prefer not to disclose percentages"
          }
        ]
      },
      {
        "key": "transactions",
        "number": 5,
        "label": "Transactions",
        "shortLabel": "Transactions",
        "coreTables": [
          "transactions_general"
        ],
        "sections": [
          {
            "key": "transactions",
            "label": "Transactions",
            "kind": "repeatable",
            "tab": "transactions",
            "order": 0,
            "fields": [],
            "layout": "cards",
            "rowEntity": "transaction",
            "rowLabel": "{transaction_type} — {datahub.counterparty_summary}",
            "toggle": {
              "key": "no_transactions",
              "label": "No transactions in this period"
            },
            "confidentiality": "row",
            "blocks": [
              {
                "key": "basics",
                "label": "Basics",
                "fields": [
                  {
                    "key": "transaction_type",
                    "path": "transactions.transactions.transaction_type",
                    "label": "Transaction type",
                    "input": "select",
                    "tab": "transactions",
                    "section": "transactions",
                    "order": 0,
                    "required": "always",
                    "block": "basics",
                    "options": [
                      {
                        "value": "Investment",
                        "label": "Investment"
                      },
                      {
                        "value": "Merger/Acquisition (M&A)",
                        "label": "Merger/Acquisition (M&A)"
                      },
                      {
                        "value": "Debt Financing",
                        "label": "Debt Financing"
                      },
                      {
                        "value": "Project Financing",
                        "label": "Project Financing"
                      },
                      {
                        "value": "Exit",
                        "label": "Exit"
                      }
                    ],
                    "coreTable": "transactions_general",
                    "coreField": "transaction_type",
                    "dataType": "MultiSelect"
                  },
                  {
                    "key": "deal_status",
                    "path": "transactions.transactions.deal_status",
                    "label": "Deal status",
                    "input": "select",
                    "tab": "transactions",
                    "section": "transactions",
                    "order": 1,
                    "required": "always",
                    "block": "basics",
                    "options": [
                      {
                        "value": "Announced",
                        "label": "Announced"
                      },
                      {
                        "value": "Announced – Pending Regulatory Approval",
                        "label": "Announced – Pending Regulatory Approval"
                      },
                      {
                        "value": "Announced – Pending Investment Committee/Board Approval",
                        "label": "Announced – Pending Investment Committee/Board Approval"
                      },
                      {
                        "value": "Approved",
                        "label": "Approved"
                      },
                      {
                        "value": "Closed",
                        "label": "Closed"
                      },
                      {
                        "value": "Terminated",
                        "label": "Terminated"
                      }
                    ],
                    "coreTable": "transactions_general",
                    "coreField": "deal_status",
                    "dataType": "MultiSelect"
                  },
                  {
                    "key": "announcement_date",
                    "path": "transactions.transactions.announcement_date",
                    "label": "Announcement date",
                    "input": "date",
                    "tab": "transactions",
                    "section": "transactions",
                    "order": 2,
                    "required": "always",
                    "block": "basics",
                    "precision": true,
                    "coreTable": "transactions_general",
                    "coreField": "announcement_date",
                    "dataType": "Date"
                  },
                  {
                    "key": "completion_date",
                    "path": "transactions.transactions.completion_date",
                    "label": "Completion date",
                    "input": "date",
                    "tab": "transactions",
                    "section": "transactions",
                    "order": 3,
                    "required": "conditional",
                    "block": "basics",
                    "requiredWhen": {
                      "field": "deal_status",
                      "eq": "Closed"
                    },
                    "visibleWhen": {
                      "field": "deal_status",
                      "eq": "Closed"
                    },
                    "precision": true,
                    "coreTable": "transactions_general",
                    "coreField": "completion_date",
                    "dataType": "Date"
                  },
                  {
                    "key": "datahub.publication_permission",
                    "path": "transactions.transactions.datahub.publication_permission",
                    "label": "Publication permission",
                    "input": "radio",
                    "tab": "transactions",
                    "section": "transactions",
                    "order": 4,
                    "required": "always",
                    "block": "basics",
                    "options": [
                      {
                        "value": "Stears may publish",
                        "label": "Stears may publish"
                      },
                      {
                        "value": "Confidential — internal records only",
                        "label": "Confidential — internal records only"
                      }
                    ],
                    "default": "Stears may publish"
                  }
                ]
              },
              {
                "key": "parties",
                "label": "Parties",
                "fields": [
                  {
                    "key": "datahub.investors",
                    "path": "transactions.transactions.datahub.investors",
                    "label": "Investors, buyers or lenders",
                    "input": "partylist",
                    "tab": "transactions",
                    "section": "transactions",
                    "order": 5,
                    "required": "always",
                    "block": "parties",
                    "roles": [
                      "Lead investor",
                      "Participant",
                      "Acquirer",
                      "Lender",
                      "Sponsor"
                    ]
                  },
                  {
                    "key": "participating_fund",
                    "path": "transactions.transactions.participating_fund",
                    "label": "Participating funds",
                    "input": "taglist",
                    "tab": "transactions",
                    "section": "transactions",
                    "order": 6,
                    "required": "never",
                    "block": "parties",
                    "help": "Name the fund vehicle, not the manager.",
                    "coreTable": "transactions_general",
                    "coreField": "participating_fund",
                    "dataType": "Links"
                  },
                  {
                    "key": "sellers",
                    "path": "transactions.transactions.sellers",
                    "label": "Sellers",
                    "input": "taglist",
                    "tab": "transactions",
                    "section": "transactions",
                    "order": 7,
                    "required": "never",
                    "block": "parties",
                    "visibleWhen": {
                      "field": "transaction_type",
                      "in": [
                        "Merger/Acquisition (M&A)",
                        "Exit"
                      ]
                    },
                    "coreTable": "transactions_general",
                    "coreField": "sellers",
                    "dataType": "Links"
                  },
                  {
                    "key": "advisors_buy_side",
                    "path": "transactions.transactions.advisors_buy_side",
                    "label": "Advisors, buy side",
                    "input": "text",
                    "tab": "transactions",
                    "section": "transactions",
                    "order": 8,
                    "required": "never",
                    "block": "parties",
                    "help": "Firm (Financial), Firm (Legal)",
                    "coreTable": "transactions_general",
                    "coreField": "advisors_buy_side",
                    "dataType": "SingleLineText"
                  },
                  {
                    "key": "advisors_sell_side",
                    "path": "transactions.transactions.advisors_sell_side",
                    "label": "Advisors, sell side",
                    "input": "text",
                    "tab": "transactions",
                    "section": "transactions",
                    "order": 9,
                    "required": "never",
                    "block": "parties",
                    "visibleWhen": {
                      "field": "transaction_type",
                      "in": [
                        "Merger/Acquisition (M&A)",
                        "Exit"
                      ]
                    },
                    "coreTable": "transactions_general",
                    "coreField": "advisors_sell_side",
                    "dataType": "SingleLineText"
                  }
                ]
              },
              {
                "key": "structure",
                "label": "Structure and value",
                "fields": [
                  {
                    "key": "financing_instrument",
                    "path": "transactions.transactions.financing_instrument",
                    "label": "Financing instruments",
                    "input": "multiselect",
                    "tab": "transactions",
                    "section": "transactions",
                    "order": 10,
                    "required": "always",
                    "block": "structure",
                    "options": [
                      {
                        "value": "Ordinary Shares (Equity)",
                        "label": "Ordinary Shares (Equity)"
                      },
                      {
                        "value": "Preference Shares (Equity)",
                        "label": "Preference Shares (Equity)"
                      },
                      {
                        "value": "Warrants (Equity)",
                        "label": "Warrants (Equity)"
                      },
                      {
                        "value": "Simple Agreement for Future Equity (SAFE) (Equity)",
                        "label": "Simple Agreement for Future Equity (SAFE) (Equity)"
                      },
                      {
                        "value": "Options",
                        "label": "Options"
                      },
                      {
                        "value": "Equity",
                        "label": "Equity"
                      },
                      {
                        "value": "Senior Debt",
                        "label": "Senior Debt"
                      },
                      {
                        "value": "Mezzanine Debt",
                        "label": "Mezzanine Debt"
                      },
                      {
                        "value": "Subordinated Debt",
                        "label": "Subordinated Debt"
                      },
                      {
                        "value": "Junior Debt",
                        "label": "Junior Debt"
                      },
                      {
                        "value": "Shareholder Loans",
                        "label": "Shareholder Loans"
                      },
                      {
                        "value": "Payment-in-Kind (PIK) Note",
                        "label": "Payment-in-Kind (PIK) Note"
                      },
                      {
                        "value": "Convertible Securities (Debt)",
                        "label": "Convertible Securities (Debt)"
                      },
                      {
                        "value": "Term Loan",
                        "label": "Term Loan"
                      },
                      {
                        "value": "Working Capital Loan",
                        "label": "Working Capital Loan"
                      },
                      {
                        "value": "Revolving Credit Facility",
                        "label": "Revolving Credit Facility"
                      },
                      {
                        "value": "Syndicated Loan",
                        "label": "Syndicated Loan"
                      },
                      {
                        "value": "Trade Finance",
                        "label": "Trade Finance"
                      },
                      {
                        "value": "Private Capital (Debt)",
                        "label": "Private Capital (Debt)"
                      },
                      {
                        "value": "Debt",
                        "label": "Debt"
                      },
                      {
                        "value": "Grant",
                        "label": "Grant"
                      },
                      {
                        "value": "Guarantee",
                        "label": "Guarantee"
                      }
                    ],
                    "coreTable": "transactions_general",
                    "coreField": "financing_instrument",
                    "dataType": "MultiSelect"
                  },
                  {
                    "key": "datahub.currency",
                    "path": "transactions.transactions.datahub.currency",
                    "label": "Currency",
                    "input": "select",
                    "tab": "transactions",
                    "section": "transactions",
                    "order": 11,
                    "required": "conditional",
                    "block": "structure",
                    "requiredWhen": {
                      "anyAmountPresent": true
                    },
                    "options": [
                      {
                        "value": "USD",
                        "label": "USD"
                      },
                      {
                        "value": "NGN",
                        "label": "NGN"
                      },
                      {
                        "value": "ZAR",
                        "label": "ZAR"
                      },
                      {
                        "value": "KES",
                        "label": "KES"
                      },
                      {
                        "value": "GHS",
                        "label": "GHS"
                      },
                      {
                        "value": "EGP",
                        "label": "EGP"
                      },
                      {
                        "value": "MAD",
                        "label": "MAD"
                      },
                      {
                        "value": "TZS",
                        "label": "TZS"
                      },
                      {
                        "value": "UGX",
                        "label": "UGX"
                      },
                      {
                        "value": "RWF",
                        "label": "RWF"
                      },
                      {
                        "value": "XOF",
                        "label": "XOF"
                      },
                      {
                        "value": "XAF",
                        "label": "XAF"
                      },
                      {
                        "value": "ZMW",
                        "label": "ZMW"
                      },
                      {
                        "value": "MUR",
                        "label": "MUR"
                      },
                      {
                        "value": "EUR",
                        "label": "EUR"
                      },
                      {
                        "value": "GBP",
                        "label": "GBP"
                      }
                    ],
                    "taxonomy": "currencies"
                  },
                  {
                    "key": "total_deal_amount",
                    "path": "transactions.transactions.total_deal_amount",
                    "label": "Total deal amount",
                    "input": "money",
                    "tab": "transactions",
                    "section": "transactions",
                    "order": 12,
                    "required": "never",
                    "block": "structure",
                    "undisclosed": true,
                    "coreTable": "transactions_general",
                    "coreField": "total_deal_amount",
                    "dataType": "Decimal"
                  },
                  {
                    "key": "buyer_type",
                    "path": "transactions.transactions.buyer_type",
                    "label": "Buyer type",
                    "input": "select",
                    "tab": "transactions",
                    "section": "transactions",
                    "order": 13,
                    "required": "never",
                    "block": "structure",
                    "visibleWhen": {
                      "field": "transaction_type",
                      "in": [
                        "Investment",
                        "Merger/Acquisition (M&A)",
                        "Exit"
                      ]
                    },
                    "options": [
                      {
                        "value": "Strategic",
                        "label": "Strategic"
                      },
                      {
                        "value": "Financial",
                        "label": "Financial"
                      }
                    ],
                    "coreTable": "transactions_general",
                    "coreField": "buyer_type",
                    "dataType": "MultiSelect"
                  },
                  {
                    "key": "equity_stake",
                    "path": "transactions.transactions.equity_stake",
                    "label": "Equity stake acquired",
                    "input": "percent",
                    "tab": "transactions",
                    "section": "transactions",
                    "order": 14,
                    "required": "never",
                    "block": "structure",
                    "visibleWhen": {
                      "field": "transaction_type",
                      "in": [
                        "Investment",
                        "Merger/Acquisition (M&A)",
                        "Exit"
                      ]
                    },
                    "undisclosed": true,
                    "coreTable": "transactions_general",
                    "coreField": "equity_stake",
                    "dataType": "Decimal"
                  },
                  {
                    "key": "debt_amount",
                    "path": "transactions.transactions.debt_amount",
                    "label": "Debt amount",
                    "input": "money",
                    "tab": "transactions",
                    "section": "transactions",
                    "order": 15,
                    "required": "never",
                    "block": "structure",
                    "visibleWhen": {
                      "anyOf": [
                        {
                          "field": "transaction_type",
                          "in": [
                            "Debt Financing",
                            "Project Financing"
                          ]
                        },
                        {
                          "field": "financing_instrument",
                          "includesAny": [
                            "Senior Debt",
                            "Mezzanine Debt",
                            "Subordinated Debt",
                            "Junior Debt",
                            "Shareholder Loans",
                            "Term Loan",
                            "Working Capital Loan",
                            "Revolving Credit Facility",
                            "Syndicated Loan",
                            "Trade Finance",
                            "Private Capital (Debt)",
                            "Debt",
                            "Convertible Securities (Debt)",
                            "Payment-in-Kind (PIK) Note"
                          ]
                        }
                      ]
                    },
                    "undisclosed": true,
                    "coreTable": "transactions_general",
                    "coreField": "debt_amount",
                    "dataType": "Decimal"
                  },
                  {
                    "key": "enterprise_value",
                    "path": "transactions.transactions.enterprise_value",
                    "label": "Enterprise value",
                    "input": "money",
                    "tab": "transactions",
                    "section": "transactions",
                    "order": 16,
                    "required": "never",
                    "block": "structure",
                    "visibleWhen": {
                      "field": "transaction_type",
                      "in": [
                        "Investment",
                        "Merger/Acquisition (M&A)",
                        "Exit"
                      ]
                    },
                    "undisclosed": true,
                    "coreTable": "transactions_general",
                    "coreField": "enterprise_value",
                    "dataType": "Decimal"
                  },
                  {
                    "key": "equity_value",
                    "path": "transactions.transactions.equity_value",
                    "label": "Equity value",
                    "input": "money",
                    "tab": "transactions",
                    "section": "transactions",
                    "order": 17,
                    "required": "never",
                    "block": "structure",
                    "visibleWhen": {
                      "field": "transaction_type",
                      "in": [
                        "Investment",
                        "Merger/Acquisition (M&A)",
                        "Exit"
                      ]
                    },
                    "undisclosed": true,
                    "coreTable": "transactions_general",
                    "coreField": "equity_value",
                    "dataType": "Decimal"
                  },
                  {
                    "key": "pre_money_valuation",
                    "path": "transactions.transactions.pre_money_valuation",
                    "label": "Pre-money valuation",
                    "input": "money",
                    "tab": "transactions",
                    "section": "transactions",
                    "order": 18,
                    "required": "never",
                    "block": "structure",
                    "visibleWhen": {
                      "field": "transaction_type",
                      "eq": "Investment"
                    },
                    "undisclosed": true,
                    "coreTable": "transactions_general",
                    "coreField": "pre_money_valuation",
                    "dataType": "Decimal"
                  },
                  {
                    "key": "post_money_valuation",
                    "path": "transactions.transactions.post_money_valuation",
                    "label": "Post-money valuation",
                    "input": "money",
                    "tab": "transactions",
                    "section": "transactions",
                    "order": 19,
                    "required": "never",
                    "block": "structure",
                    "visibleWhen": {
                      "field": "transaction_type",
                      "eq": "Investment"
                    },
                    "undisclosed": true,
                    "coreTable": "transactions_general",
                    "coreField": "post_money_valuation",
                    "dataType": "Decimal"
                  },
                  {
                    "key": "investment_type_stage",
                    "path": "transactions.transactions.investment_type_stage",
                    "label": "Investment stage",
                    "input": "select",
                    "tab": "transactions",
                    "section": "transactions",
                    "order": 20,
                    "required": "never",
                    "block": "structure",
                    "visibleWhen": {
                      "field": "transaction_type",
                      "eq": "Investment"
                    },
                    "options": [
                      {
                        "value": "Pre-Seed",
                        "label": "Pre-Seed"
                      },
                      {
                        "value": "Seed",
                        "label": "Seed"
                      },
                      {
                        "value": "Seed Extension / Pre-Series A",
                        "label": "Seed Extension / Pre-Series A"
                      },
                      {
                        "value": "Series A",
                        "label": "Series A"
                      },
                      {
                        "value": "Series A Extension / Pre-Series B",
                        "label": "Series A Extension / Pre-Series B"
                      },
                      {
                        "value": "Series B",
                        "label": "Series B"
                      },
                      {
                        "value": "Series B Extension / Pre-Series C",
                        "label": "Series B Extension / Pre-Series C"
                      },
                      {
                        "value": "Series C+",
                        "label": "Series C+"
                      },
                      {
                        "value": "Bridge Round",
                        "label": "Bridge Round"
                      },
                      {
                        "value": "Growth Capital",
                        "label": "Growth Capital"
                      }
                    ],
                    "coreTable": "transactions_general",
                    "coreField": "investment_type_stage",
                    "dataType": "SingleSelect"
                  },
                  {
                    "key": "investment_strategy",
                    "path": "transactions.transactions.investment_strategy",
                    "label": "Investment strategy",
                    "input": "multiselect",
                    "tab": "transactions",
                    "section": "transactions",
                    "order": 21,
                    "required": "never",
                    "block": "structure",
                    "options": [
                      {
                        "value": "Growth Equity",
                        "label": "Growth Equity"
                      },
                      {
                        "value": "Buyout",
                        "label": "Buyout"
                      },
                      {
                        "value": "Secondary Sale",
                        "label": "Secondary Sale"
                      },
                      {
                        "value": "Bridge Financing",
                        "label": "Bridge Financing"
                      },
                      {
                        "value": "Bolt-On",
                        "label": "Bolt-On"
                      },
                      {
                        "value": "Venture Equity",
                        "label": "Venture Equity"
                      },
                      {
                        "value": "Venture Debt",
                        "label": "Venture Debt"
                      },
                      {
                        "value": "Carve-Out",
                        "label": "Carve-Out"
                      },
                      {
                        "value": "Strategic Minority",
                        "label": "Strategic Minority"
                      },
                      {
                        "value": "Acquisition",
                        "label": "Acquisition"
                      },
                      {
                        "value": "Asset Sale",
                        "label": "Asset Sale"
                      },
                      {
                        "value": "Joint Venture",
                        "label": "Joint Venture"
                      },
                      {
                        "value": "Leveraged Buyout (LBO)",
                        "label": "Leveraged Buyout (LBO)"
                      },
                      {
                        "value": "Management Buy-in / Buy-out (MBI/MBO)",
                        "label": "Management Buy-in / Buy-out (MBI/MBO)"
                      },
                      {
                        "value": "Merger",
                        "label": "Merger"
                      },
                      {
                        "value": "Strategic Majority",
                        "label": "Strategic Majority"
                      },
                      {
                        "value": "Accelerator Program",
                        "label": "Accelerator Program"
                      },
                      {
                        "value": "Venture Lab/Studio",
                        "label": "Venture Lab/Studio"
                      },
                      {
                        "value": "Direct Lending",
                        "label": "Direct Lending"
                      },
                      {
                        "value": "Corporate Lending",
                        "label": "Corporate Lending"
                      }
                    ],
                    "coreTable": "transactions_general",
                    "coreField": "investment_strategy",
                    "dataType": "MultiSelect"
                  },
                  {
                    "key": "asset_class",
                    "path": "transactions.transactions.asset_class",
                    "label": "Asset class",
                    "input": "select",
                    "tab": "transactions",
                    "section": "transactions",
                    "order": 22,
                    "required": "never",
                    "block": "structure",
                    "options": [
                      {
                        "value": "Private Equity",
                        "label": "Private Equity"
                      },
                      {
                        "value": "Venture Capital",
                        "label": "Venture Capital"
                      },
                      {
                        "value": "Private Credit",
                        "label": "Private Credit"
                      },
                      {
                        "value": "Corporate Transactions",
                        "label": "Corporate Transactions"
                      },
                      {
                        "value": "Infrastructure & Project Finance",
                        "label": "Infrastructure & Project Finance"
                      },
                      {
                        "value": "Real Estate",
                        "label": "Real Estate"
                      },
                      {
                        "value": "Natural Resources",
                        "label": "Natural Resources"
                      }
                    ],
                    "coreTable": "transactions_general",
                    "coreField": "asset_class",
                    "dataType": "MultiSelect"
                  },
                  {
                    "key": "follow_on_investment",
                    "path": "transactions.transactions.follow_on_investment",
                    "label": "Follow-on investment",
                    "input": "radio",
                    "tab": "transactions",
                    "section": "transactions",
                    "order": 23,
                    "required": "never",
                    "block": "structure",
                    "visibleWhen": {
                      "field": "transaction_type",
                      "eq": "Investment"
                    },
                    "options": [
                      {
                        "value": "True",
                        "label": "True"
                      },
                      {
                        "value": "False",
                        "label": "False"
                      }
                    ],
                    "coreTable": "transactions_general",
                    "coreField": "follow_on_investment",
                    "dataType": "SingleSelect"
                  },
                  {
                    "key": "payment_structure",
                    "path": "transactions.transactions.payment_structure",
                    "label": "Payment structure",
                    "input": "multiselect",
                    "tab": "transactions",
                    "section": "transactions",
                    "order": 24,
                    "required": "never",
                    "block": "structure",
                    "visibleWhen": {
                      "field": "transaction_type",
                      "in": [
                        "Merger/Acquisition (M&A)",
                        "Exit"
                      ]
                    },
                    "options": [
                      {
                        "value": "Cash",
                        "label": "Cash"
                      },
                      {
                        "value": "Stock",
                        "label": "Stock"
                      },
                      {
                        "value": "Cash & Stock",
                        "label": "Cash & Stock"
                      },
                      {
                        "value": "Debt-Financed",
                        "label": "Debt-Financed"
                      },
                      {
                        "value": "Earn-Out",
                        "label": "Earn-Out"
                      },
                      {
                        "value": "Mixed",
                        "label": "Mixed"
                      }
                    ],
                    "coreTable": "transactions_general",
                    "coreField": "payment_structure",
                    "dataType": "MultiSelect"
                  }
                ]
              },
              {
                "key": "debt_terms",
                "label": "Debt terms",
                "visibleWhen": {
                  "anyOf": [
                    {
                      "field": "transaction_type",
                      "in": [
                        "Debt Financing",
                        "Project Financing"
                      ]
                    },
                    {
                      "field": "financing_instrument",
                      "includesAny": [
                        "Senior Debt",
                        "Mezzanine Debt",
                        "Subordinated Debt",
                        "Junior Debt",
                        "Shareholder Loans",
                        "Term Loan",
                        "Working Capital Loan",
                        "Revolving Credit Facility",
                        "Syndicated Loan",
                        "Trade Finance",
                        "Private Capital (Debt)",
                        "Debt",
                        "Convertible Securities (Debt)",
                        "Payment-in-Kind (PIK) Note"
                      ]
                    }
                  ]
                },
                "fields": [
                  {
                    "key": "interest_rate",
                    "path": "transactions.transactions.interest_rate",
                    "label": "Interest rate",
                    "input": "percent",
                    "tab": "transactions",
                    "section": "transactions",
                    "order": 25,
                    "required": "never",
                    "block": "debt_terms",
                    "coreTable": "transactions_general",
                    "coreField": "interest_rate",
                    "dataType": "Decimal"
                  },
                  {
                    "key": "interest_rate_type",
                    "path": "transactions.transactions.interest_rate_type",
                    "label": "Interest rate type",
                    "input": "select",
                    "tab": "transactions",
                    "section": "transactions",
                    "order": 26,
                    "required": "never",
                    "block": "debt_terms",
                    "options": [
                      {
                        "value": "Fixed Rate",
                        "label": "Fixed Rate"
                      },
                      {
                        "value": "Floating Rate",
                        "label": "Floating Rate"
                      },
                      {
                        "value": "Interest-Free Loan",
                        "label": "Interest-Free Loan"
                      }
                    ],
                    "coreTable": "transactions_general",
                    "coreField": "interest_rate_type",
                    "dataType": "MultiSelect"
                  },
                  {
                    "key": "benchmark_if_floating",
                    "path": "transactions.transactions.benchmark_if_floating",
                    "label": "Benchmark if floating",
                    "input": "text",
                    "tab": "transactions",
                    "section": "transactions",
                    "order": 27,
                    "required": "never",
                    "block": "debt_terms",
                    "visibleWhen": {
                      "field": "interest_rate_type",
                      "eq": "Floating Rate"
                    },
                    "coreTable": "transactions_general",
                    "coreField": "benchmark_if_floating",
                    "dataType": "SingleLineText"
                  },
                  {
                    "key": "loan_duration",
                    "path": "transactions.transactions.loan_duration",
                    "label": "Loan duration",
                    "input": "select",
                    "tab": "transactions",
                    "section": "transactions",
                    "order": 28,
                    "required": "never",
                    "block": "debt_terms",
                    "options": [
                      {
                        "value": "Short-term (<1 year)",
                        "label": "Short-term (<1 year)"
                      },
                      {
                        "value": "Medium-term (1–5 years)",
                        "label": "Medium-term (1–5 years)"
                      },
                      {
                        "value": "Long-term (>5 years)",
                        "label": "Long-term (>5 years)"
                      },
                      {
                        "value": "Perpetual Debt",
                        "label": "Perpetual Debt"
                      }
                    ],
                    "coreTable": "transactions_general",
                    "coreField": "loan_duration",
                    "dataType": "MultiSelect"
                  },
                  {
                    "key": "maturity_date",
                    "path": "transactions.transactions.maturity_date",
                    "label": "Maturity date",
                    "input": "date",
                    "tab": "transactions",
                    "section": "transactions",
                    "order": 29,
                    "required": "never",
                    "block": "debt_terms",
                    "coreTable": "transactions_general",
                    "coreField": "maturity_date",
                    "dataType": "Date"
                  },
                  {
                    "key": "repayment_terms",
                    "path": "transactions.transactions.repayment_terms",
                    "label": "Repayment terms",
                    "input": "multiselect",
                    "tab": "transactions",
                    "section": "transactions",
                    "order": 30,
                    "required": "never",
                    "block": "debt_terms",
                    "options": [
                      {
                        "value": "Amortising Loan",
                        "label": "Amortising Loan"
                      },
                      {
                        "value": "Bullet Payment",
                        "label": "Bullet Payment"
                      },
                      {
                        "value": "Interest-Only Period",
                        "label": "Interest-Only Period"
                      },
                      {
                        "value": "Convertible Debt",
                        "label": "Convertible Debt"
                      },
                      {
                        "value": "Repayable on Exit",
                        "label": "Repayable on Exit"
                      }
                    ],
                    "coreTable": "transactions_general",
                    "coreField": "repayment_terms",
                    "dataType": "MultiSelect"
                  },
                  {
                    "key": "collateral_type",
                    "path": "transactions.transactions.collateral_type",
                    "label": "Collateral type",
                    "input": "multiselect",
                    "tab": "transactions",
                    "section": "transactions",
                    "order": 31,
                    "required": "never",
                    "block": "debt_terms",
                    "options": [
                      {
                        "value": "Secured Loan",
                        "label": "Secured Loan"
                      },
                      {
                        "value": "Unsecured Loan",
                        "label": "Unsecured Loan"
                      },
                      {
                        "value": "Mezzanine Debt",
                        "label": "Mezzanine Debt"
                      }
                    ],
                    "coreTable": "transactions_general",
                    "coreField": "collateral_type",
                    "dataType": "MultiSelect"
                  },
                  {
                    "key": "special_conditions",
                    "path": "transactions.transactions.special_conditions",
                    "label": "Special conditions",
                    "input": "multiselect",
                    "tab": "transactions",
                    "section": "transactions",
                    "order": 32,
                    "required": "never",
                    "block": "debt_terms",
                    "options": [
                      {
                        "value": "PIK (Payment-in-Kind) Interest",
                        "label": "PIK (Payment-in-Kind) Interest"
                      },
                      {
                        "value": "Step-Up Rate",
                        "label": "Step-Up Rate"
                      },
                      {
                        "value": "Balloon Payment",
                        "label": "Balloon Payment"
                      },
                      {
                        "value": "Callable Debt",
                        "label": "Callable Debt"
                      },
                      {
                        "value": "Puttable Debt",
                        "label": "Puttable Debt"
                      }
                    ],
                    "coreTable": "transactions_general",
                    "coreField": "special_conditions",
                    "dataType": "MultiSelect"
                  },
                  {
                    "key": "guarantors_collaterals",
                    "path": "transactions.transactions.guarantors_collaterals",
                    "label": "Guarantors or collateral",
                    "input": "text",
                    "tab": "transactions",
                    "section": "transactions",
                    "order": 33,
                    "required": "never",
                    "block": "debt_terms",
                    "coreTable": "transactions_general",
                    "coreField": "guarantors_collaterals",
                    "dataType": "SingleLineText"
                  },
                  {
                    "key": "interest_rate_terms",
                    "path": "transactions.transactions.interest_rate_terms",
                    "label": "Interest rate terms",
                    "input": "longtext",
                    "tab": "transactions",
                    "section": "transactions",
                    "order": 34,
                    "required": "never",
                    "block": "debt_terms",
                    "coreTable": "transactions_general",
                    "coreField": "interest_rate_terms",
                    "dataType": "LongText"
                  },
                  {
                    "key": "debt_purpose",
                    "path": "transactions.transactions.debt_purpose",
                    "label": "Debt purpose",
                    "input": "longtext",
                    "tab": "transactions",
                    "section": "transactions",
                    "order": 35,
                    "required": "never",
                    "block": "debt_terms",
                    "coreTable": "transactions_general",
                    "coreField": "debt_purpose",
                    "dataType": "LongText"
                  }
                ]
              },
              {
                "key": "project",
                "label": "Project details",
                "visibleWhen": {
                  "field": "transaction_type",
                  "eq": "Project Financing"
                },
                "fields": [
                  {
                    "key": "datahub.project_description",
                    "path": "transactions.transactions.datahub.project_description",
                    "label": "Project description",
                    "input": "longtext",
                    "tab": "transactions",
                    "section": "transactions",
                    "order": 36,
                    "required": "always",
                    "block": "project"
                  },
                  {
                    "key": "datahub.project_country",
                    "path": "transactions.transactions.datahub.project_country",
                    "label": "Project country",
                    "input": "select",
                    "tab": "transactions",
                    "section": "transactions",
                    "order": 37,
                    "required": "always",
                    "block": "project",
                    "options": [
                      {
                        "value": "nigeria",
                        "label": "Nigeria"
                      },
                      {
                        "value": "ghana",
                        "label": "Ghana"
                      },
                      {
                        "value": "senegal",
                        "label": "Senegal"
                      },
                      {
                        "value": "cote-divoire",
                        "label": "Côte d'Ivoire"
                      },
                      {
                        "value": "mali",
                        "label": "Mali"
                      },
                      {
                        "value": "benin",
                        "label": "Benin"
                      },
                      {
                        "value": "togo",
                        "label": "Togo"
                      },
                      {
                        "value": "burkina-faso",
                        "label": "Burkina Faso"
                      },
                      {
                        "value": "sierra-leone",
                        "label": "Sierra Leone"
                      },
                      {
                        "value": "liberia",
                        "label": "Liberia"
                      },
                      {
                        "value": "guinea",
                        "label": "Guinea"
                      },
                      {
                        "value": "kenya",
                        "label": "Kenya"
                      },
                      {
                        "value": "tanzania",
                        "label": "Tanzania"
                      },
                      {
                        "value": "uganda",
                        "label": "Uganda"
                      },
                      {
                        "value": "rwanda",
                        "label": "Rwanda"
                      },
                      {
                        "value": "ethiopia",
                        "label": "Ethiopia"
                      },
                      {
                        "value": "somalia",
                        "label": "Somalia"
                      },
                      {
                        "value": "burundi",
                        "label": "Burundi"
                      },
                      {
                        "value": "south-sudan",
                        "label": "South Sudan"
                      },
                      {
                        "value": "south-africa",
                        "label": "South Africa"
                      },
                      {
                        "value": "botswana",
                        "label": "Botswana"
                      },
                      {
                        "value": "namibia",
                        "label": "Namibia"
                      },
                      {
                        "value": "zambia",
                        "label": "Zambia"
                      },
                      {
                        "value": "zimbabwe",
                        "label": "Zimbabwe"
                      },
                      {
                        "value": "mozambique",
                        "label": "Mozambique"
                      },
                      {
                        "value": "malawi",
                        "label": "Malawi"
                      },
                      {
                        "value": "mauritius",
                        "label": "Mauritius"
                      },
                      {
                        "value": "egypt",
                        "label": "Egypt"
                      },
                      {
                        "value": "morocco",
                        "label": "Morocco"
                      },
                      {
                        "value": "tunisia",
                        "label": "Tunisia"
                      },
                      {
                        "value": "algeria",
                        "label": "Algeria"
                      },
                      {
                        "value": "libya",
                        "label": "Libya"
                      },
                      {
                        "value": "sudan",
                        "label": "Sudan"
                      },
                      {
                        "value": "cameroon",
                        "label": "Cameroon"
                      },
                      {
                        "value": "drc",
                        "label": "Democratic Republic of the Congo"
                      },
                      {
                        "value": "gabon",
                        "label": "Gabon"
                      },
                      {
                        "value": "chad",
                        "label": "Chad"
                      },
                      {
                        "value": "congo",
                        "label": "Republic of the Congo"
                      },
                      {
                        "value": "united-kingdom",
                        "label": "United Kingdom"
                      },
                      {
                        "value": "united-states",
                        "label": "United States"
                      },
                      {
                        "value": "netherlands",
                        "label": "Netherlands"
                      },
                      {
                        "value": "france",
                        "label": "France"
                      },
                      {
                        "value": "united-arab-emirates",
                        "label": "United Arab Emirates"
                      },
                      {
                        "value": "mauritius-ibc",
                        "label": "Mauritius (IBC)"
                      },
                      {
                        "value": "cayman-islands",
                        "label": "Cayman Islands"
                      },
                      {
                        "value": "luxembourg",
                        "label": "Luxembourg"
                      }
                    ],
                    "taxonomy": "countries"
                  },
                  {
                    "key": "datahub.project_city",
                    "path": "transactions.transactions.datahub.project_city",
                    "label": "Project city or location",
                    "input": "text",
                    "tab": "transactions",
                    "section": "transactions",
                    "order": 38,
                    "required": "never",
                    "block": "project"
                  },
                  {
                    "key": "datahub.project_sponsor",
                    "path": "transactions.transactions.datahub.project_sponsor",
                    "label": "Project sponsor",
                    "input": "text",
                    "tab": "transactions",
                    "section": "transactions",
                    "order": 39,
                    "required": "never",
                    "block": "project"
                  },
                  {
                    "key": "datahub.spv_name",
                    "path": "transactions.transactions.datahub.spv_name",
                    "label": "SPV or project company",
                    "input": "text",
                    "tab": "transactions",
                    "section": "transactions",
                    "order": 40,
                    "required": "never",
                    "block": "project",
                    "help": "The entity that legally receives the financing, if separate from the sponsor."
                  }
                ]
              },
              {
                "key": "exit",
                "label": "Exit details",
                "visibleWhen": {
                  "field": "transaction_type",
                  "eq": "Exit"
                },
                "fields": [
                  {
                    "key": "exit_date",
                    "path": "transactions.transactions.exit_date",
                    "label": "Exit date",
                    "input": "date",
                    "tab": "transactions",
                    "section": "transactions",
                    "order": 41,
                    "required": "always",
                    "block": "exit",
                    "coreTable": "transactions_general",
                    "coreField": "exit_date",
                    "dataType": "Date"
                  },
                  {
                    "key": "exit_strategy",
                    "path": "transactions.transactions.exit_strategy",
                    "label": "Exit strategy",
                    "input": "multiselect",
                    "tab": "transactions",
                    "section": "transactions",
                    "order": 42,
                    "required": "always",
                    "block": "exit",
                    "options": [
                      {
                        "value": "Trade Sale",
                        "label": "Trade Sale"
                      },
                      {
                        "value": "Secondary Sale",
                        "label": "Secondary Sale"
                      },
                      {
                        "value": "Initial Public Offering (IPO)",
                        "label": "Initial Public Offering (IPO)"
                      },
                      {
                        "value": "Buyback",
                        "label": "Buyback"
                      },
                      {
                        "value": "Merger",
                        "label": "Merger"
                      },
                      {
                        "value": "Reverse Merger",
                        "label": "Reverse Merger"
                      },
                      {
                        "value": "Special Purpose Acquisition Company (SPAC)",
                        "label": "Special Purpose Acquisition Company (SPAC)"
                      },
                      {
                        "value": "Management Buyout (MBO) / Employee Buyout",
                        "label": "Management Buyout (MBO) / Employee Buyout"
                      },
                      {
                        "value": "Write-off / Liquidation",
                        "label": "Write-off / Liquidation"
                      },
                      {
                        "value": "Other",
                        "label": "Other"
                      },
                      {
                        "value": "Unspecified",
                        "label": "Unspecified"
                      }
                    ],
                    "coreTable": "transactions_general",
                    "coreField": "exit_strategy",
                    "dataType": "MultiSelect"
                  },
                  {
                    "key": "partial_full_exit",
                    "path": "transactions.transactions.partial_full_exit",
                    "label": "Partial or full exit",
                    "input": "select",
                    "tab": "transactions",
                    "section": "transactions",
                    "order": 43,
                    "required": "always",
                    "block": "exit",
                    "options": [
                      {
                        "value": "Full Exit",
                        "label": "Full Exit"
                      },
                      {
                        "value": "Partial Exit",
                        "label": "Partial Exit"
                      },
                      {
                        "value": "No",
                        "label": "No"
                      },
                      {
                        "value": "Unspecified",
                        "label": "Unspecified"
                      }
                    ],
                    "coreTable": "transactions_general",
                    "coreField": "partial_full_exit",
                    "dataType": "MultiSelect"
                  },
                  {
                    "key": "stake_sold",
                    "path": "transactions.transactions.stake_sold",
                    "label": "Stake sold",
                    "input": "percent",
                    "tab": "transactions",
                    "section": "transactions",
                    "order": 44,
                    "required": "never",
                    "block": "exit",
                    "coreTable": "transactions_general",
                    "coreField": "stake_sold",
                    "dataType": "Percent"
                  },
                  {
                    "key": "exit_stake_retained_partial",
                    "path": "transactions.transactions.exit_stake_retained_partial",
                    "label": "Stake retained",
                    "input": "percent",
                    "tab": "transactions",
                    "section": "transactions",
                    "order": 45,
                    "required": "never",
                    "block": "exit",
                    "visibleWhen": {
                      "field": "partial_full_exit",
                      "eq": "Partial Exit"
                    },
                    "coreTable": "transactions_general",
                    "coreField": "exit_stake_retained_partial",
                    "dataType": "Decimal"
                  },
                  {
                    "key": "pre_transaction_ownership",
                    "path": "transactions.transactions.pre_transaction_ownership",
                    "label": "Pre-transaction ownership",
                    "input": "percent",
                    "tab": "transactions",
                    "section": "transactions",
                    "order": 46,
                    "required": "never",
                    "block": "exit",
                    "coreTable": "transactions_general",
                    "coreField": "pre_transaction_ownership",
                    "dataType": "Percent"
                  },
                  {
                    "key": "post_transaction_stake",
                    "path": "transactions.transactions.post_transaction_stake",
                    "label": "Post-transaction stake",
                    "input": "percent",
                    "tab": "transactions",
                    "section": "transactions",
                    "order": 47,
                    "required": "never",
                    "block": "exit",
                    "coreTable": "transactions_general",
                    "coreField": "post_transaction_stake",
                    "dataType": "Percent"
                  },
                  {
                    "key": "exit_proceeds",
                    "path": "transactions.transactions.exit_proceeds",
                    "label": "Exit proceeds",
                    "input": "money",
                    "tab": "transactions",
                    "section": "transactions",
                    "order": 48,
                    "required": "never",
                    "block": "exit",
                    "undisclosed": true,
                    "coreTable": "transactions_general",
                    "coreField": "exit_proceeds",
                    "dataType": "Decimal"
                  },
                  {
                    "key": "initial_investment",
                    "path": "transactions.transactions.initial_investment",
                    "label": "Initial investment amount",
                    "input": "money",
                    "tab": "transactions",
                    "section": "transactions",
                    "order": 49,
                    "required": "never",
                    "block": "exit",
                    "undisclosed": true,
                    "coreTable": "transactions_general",
                    "coreField": "initial_investment",
                    "dataType": "Number"
                  },
                  {
                    "key": "initial_invest_announce_date",
                    "path": "transactions.transactions.initial_invest_announce_date",
                    "label": "Initial investment announcement date",
                    "input": "date",
                    "tab": "transactions",
                    "section": "transactions",
                    "order": 50,
                    "required": "never",
                    "block": "exit",
                    "coreTable": "transactions_general",
                    "coreField": "initial_invest_announce_date",
                    "dataType": "Date"
                  },
                  {
                    "key": "value_creation",
                    "path": "transactions.transactions.value_creation",
                    "label": "Value creation",
                    "input": "longtext",
                    "tab": "transactions",
                    "section": "transactions",
                    "order": 51,
                    "required": "never",
                    "block": "exit",
                    "coreTable": "transactions_general",
                    "coreField": "value_creation",
                    "dataType": "LongText"
                  }
                ]
              },
              {
                "key": "narrative",
                "label": "Narrative",
                "fields": [
                  {
                    "key": "use_of_proceeds",
                    "path": "transactions.transactions.use_of_proceeds",
                    "label": "Use of proceeds",
                    "input": "longtext",
                    "tab": "transactions",
                    "section": "transactions",
                    "order": 52,
                    "required": "never",
                    "block": "narrative",
                    "visibleWhen": {
                      "field": "transaction_type",
                      "in": [
                        "Investment",
                        "Debt Financing",
                        "Project Financing"
                      ]
                    },
                    "coreTable": "transactions_general",
                    "coreField": "use_of_proceeds",
                    "dataType": "LongText"
                  },
                  {
                    "key": "transaction_summary",
                    "path": "transactions.transactions.transaction_summary",
                    "label": "Transaction summary",
                    "input": "longtext",
                    "tab": "transactions",
                    "section": "transactions",
                    "order": 53,
                    "required": "never",
                    "block": "narrative",
                    "help": "In your own words. Stears analysts may rewrite this for the platform.",
                    "coreTable": "transactions_general",
                    "coreField": "transaction_summary",
                    "dataType": "LongText"
                  },
                  {
                    "key": "announcement_link",
                    "path": "transactions.transactions.announcement_link",
                    "label": "Announcement link",
                    "input": "url",
                    "tab": "transactions",
                    "section": "transactions",
                    "order": 54,
                    "required": "never",
                    "block": "narrative",
                    "help": "A press release, filing or credible article.",
                    "coreTable": "transactions_general",
                    "coreField": "announcement_link",
                    "dataType": "URL"
                  },
                  {
                    "key": "datahub.notes",
                    "path": "transactions.transactions.datahub.notes",
                    "label": "Notes to Stears",
                    "input": "longtext",
                    "tab": "transactions",
                    "section": "transactions",
                    "order": 55,
                    "required": "never",
                    "block": "narrative",
                    "help": "Never published."
                  }
                ]
              }
            ]
          }
        ],
        "intro": "Investments, acquisitions, debt, project finance and exits. Add anything announced or completed in the period."
      },
      {
        "key": "financials",
        "number": 6,
        "label": "Financials",
        "shortLabel": "Financials",
        "coreTables": [
          "companies_financials"
        ],
        "sections": [
          {
            "key": "periods",
            "label": "Financial periods",
            "kind": "repeatable",
            "tab": "financials",
            "order": 0,
            "fields": [],
            "layout": "cards",
            "rowEntity": "financial_period",
            "rowLabel": "{period} to {reporting_date}",
            "toggle": {
              "key": "no_changes",
              "label": "No financials to report for this period"
            },
            "confidentiality": "row",
            "blocks": [
              {
                "key": "period_header",
                "label": "Period",
                "fields": [
                  {
                    "key": "period",
                    "path": "financials.periods.period",
                    "label": "Period type",
                    "input": "radio",
                    "tab": "financials",
                    "section": "periods",
                    "order": 0,
                    "required": "always",
                    "block": "period_header",
                    "options": [
                      {
                        "value": "Yearly",
                        "label": "Yearly"
                      },
                      {
                        "value": "Half-Year",
                        "label": "Half-Year"
                      },
                      {
                        "value": "Quarterly",
                        "label": "Quarterly"
                      }
                    ],
                    "coreTable": "companies_financials",
                    "coreField": "period",
                    "dataType": "SingleSelect"
                  },
                  {
                    "key": "reporting_date",
                    "path": "financials.periods.reporting_date",
                    "label": "Period end date",
                    "input": "date",
                    "tab": "financials",
                    "section": "periods",
                    "order": 1,
                    "required": "always",
                    "block": "period_header",
                    "coreTable": "companies_financials",
                    "coreField": "reporting_date",
                    "dataType": "Date"
                  },
                  {
                    "key": "currency",
                    "path": "financials.periods.currency",
                    "label": "Currency",
                    "input": "select",
                    "tab": "financials",
                    "section": "periods",
                    "order": 2,
                    "required": "always",
                    "block": "period_header",
                    "options": [
                      {
                        "value": "USD",
                        "label": "USD"
                      },
                      {
                        "value": "NGN",
                        "label": "NGN"
                      },
                      {
                        "value": "ZAR",
                        "label": "ZAR"
                      },
                      {
                        "value": "KES",
                        "label": "KES"
                      },
                      {
                        "value": "GHS",
                        "label": "GHS"
                      },
                      {
                        "value": "EGP",
                        "label": "EGP"
                      },
                      {
                        "value": "MAD",
                        "label": "MAD"
                      },
                      {
                        "value": "TZS",
                        "label": "TZS"
                      },
                      {
                        "value": "UGX",
                        "label": "UGX"
                      },
                      {
                        "value": "RWF",
                        "label": "RWF"
                      },
                      {
                        "value": "XOF",
                        "label": "XOF"
                      },
                      {
                        "value": "XAF",
                        "label": "XAF"
                      },
                      {
                        "value": "ZMW",
                        "label": "ZMW"
                      },
                      {
                        "value": "MUR",
                        "label": "MUR"
                      },
                      {
                        "value": "EUR",
                        "label": "EUR"
                      },
                      {
                        "value": "GBP",
                        "label": "GBP"
                      }
                    ],
                    "taxonomy": "currencies",
                    "coreTable": "companies_financials",
                    "coreField": "currency",
                    "dataType": "SingleLineText"
                  },
                  {
                    "key": "financial_type",
                    "path": "financials.periods.financial_type",
                    "label": "Statement basis",
                    "input": "radio",
                    "tab": "financials",
                    "section": "periods",
                    "order": 3,
                    "required": "always",
                    "block": "period_header",
                    "options": [
                      {
                        "value": "Company",
                        "label": "Company"
                      },
                      {
                        "value": "Group",
                        "label": "Group"
                      }
                    ],
                    "coreTable": "companies_financials",
                    "coreField": "financial_type",
                    "dataType": "SingleSelect"
                  },
                  {
                    "key": "datahub.audit_status",
                    "path": "financials.periods.datahub.audit_status",
                    "label": "Audit status",
                    "input": "select",
                    "tab": "financials",
                    "section": "periods",
                    "order": 4,
                    "required": "never",
                    "block": "period_header",
                    "options": [
                      {
                        "value": "Audited",
                        "label": "Audited"
                      },
                      {
                        "value": "Management accounts",
                        "label": "Management accounts"
                      },
                      {
                        "value": "Unaudited draft",
                        "label": "Unaudited draft"
                      }
                    ]
                  },
                  {
                    "key": "datahub.publication_permission",
                    "path": "financials.periods.datahub.publication_permission",
                    "label": "Publication permission",
                    "input": "radio",
                    "tab": "financials",
                    "section": "periods",
                    "order": 5,
                    "required": "always",
                    "block": "period_header",
                    "options": [
                      {
                        "value": "Stears may publish",
                        "label": "Stears may publish"
                      },
                      {
                        "value": "Confidential — internal records only",
                        "label": "Confidential — internal records only"
                      }
                    ],
                    "default": "Stears may publish"
                  }
                ]
              },
              {
                "key": "income_statement",
                "label": "Income statement",
                "fields": [
                  {
                    "key": "revenue",
                    "path": "financials.periods.revenue",
                    "label": "Revenue",
                    "input": "money",
                    "tab": "financials",
                    "section": "periods",
                    "order": 6,
                    "required": "never",
                    "block": "income_statement",
                    "undisclosed": true,
                    "coreTable": "companies_financials",
                    "coreField": "revenue",
                    "dataType": "Decimal"
                  },
                  {
                    "key": "gross_profit",
                    "path": "financials.periods.gross_profit",
                    "label": "Gross profit",
                    "input": "money",
                    "tab": "financials",
                    "section": "periods",
                    "order": 7,
                    "required": "never",
                    "block": "income_statement",
                    "undisclosed": true,
                    "coreTable": "companies_financials",
                    "coreField": "gross_profit",
                    "dataType": "Decimal"
                  },
                  {
                    "key": "operating_expenses",
                    "path": "financials.periods.operating_expenses",
                    "label": "Operating expenses",
                    "input": "money",
                    "tab": "financials",
                    "section": "periods",
                    "order": 8,
                    "required": "never",
                    "block": "income_statement",
                    "undisclosed": true,
                    "coreTable": "companies_financials",
                    "coreField": "operating_expenses",
                    "dataType": "Decimal"
                  },
                  {
                    "key": "operating_profit",
                    "path": "financials.periods.operating_profit",
                    "label": "Operating profit",
                    "input": "money",
                    "tab": "financials",
                    "section": "periods",
                    "order": 9,
                    "required": "never",
                    "block": "income_statement",
                    "undisclosed": true,
                    "coreTable": "companies_financials",
                    "coreField": "operating_profit",
                    "dataType": "Decimal"
                  },
                  {
                    "key": "ebitda",
                    "path": "financials.periods.ebitda",
                    "label": "EBITDA",
                    "input": "money",
                    "tab": "financials",
                    "section": "periods",
                    "order": 10,
                    "required": "never",
                    "block": "income_statement",
                    "help": "Earnings before interest, taxes, depreciation and amortisation.",
                    "undisclosed": true,
                    "coreTable": "companies_financials",
                    "coreField": "ebitda",
                    "dataType": "Decimal"
                  },
                  {
                    "key": "adjusted_ebidta",
                    "path": "financials.periods.adjusted_ebidta",
                    "label": "Adjusted EBITDA",
                    "input": "money",
                    "tab": "financials",
                    "section": "periods",
                    "order": 11,
                    "required": "never",
                    "block": "income_statement",
                    "undisclosed": true,
                    "coreTable": "companies_financials",
                    "coreField": "adjusted_ebidta",
                    "dataType": "Decimal"
                  },
                  {
                    "key": "interest_income",
                    "path": "financials.periods.interest_income",
                    "label": "Interest income",
                    "input": "money",
                    "tab": "financials",
                    "section": "periods",
                    "order": 12,
                    "required": "never",
                    "block": "income_statement",
                    "undisclosed": true,
                    "coreTable": "companies_financials",
                    "coreField": "interest_income",
                    "dataType": "Decimal"
                  },
                  {
                    "key": "interest_expense",
                    "path": "financials.periods.interest_expense",
                    "label": "Interest expense",
                    "input": "money",
                    "tab": "financials",
                    "section": "periods",
                    "order": 13,
                    "required": "never",
                    "block": "income_statement",
                    "undisclosed": true,
                    "coreTable": "companies_financials",
                    "coreField": "interest_expense",
                    "dataType": "Decimal"
                  },
                  {
                    "key": "net_profit",
                    "path": "financials.periods.net_profit",
                    "label": "Net profit",
                    "input": "money",
                    "tab": "financials",
                    "section": "periods",
                    "order": 14,
                    "required": "never",
                    "block": "income_statement",
                    "undisclosed": true,
                    "coreTable": "companies_financials",
                    "coreField": "net_profit",
                    "dataType": "Decimal"
                  }
                ]
              },
              {
                "key": "balance_sheet",
                "label": "Balance sheet",
                "fields": [
                  {
                    "key": "total_assets",
                    "path": "financials.periods.total_assets",
                    "label": "Total assets",
                    "input": "money",
                    "tab": "financials",
                    "section": "periods",
                    "order": 15,
                    "required": "never",
                    "block": "balance_sheet",
                    "undisclosed": true,
                    "coreTable": "companies_financials",
                    "coreField": "total_assets",
                    "dataType": "Decimal"
                  },
                  {
                    "key": "total_liabilities",
                    "path": "financials.periods.total_liabilities",
                    "label": "Total liabilities",
                    "input": "money",
                    "tab": "financials",
                    "section": "periods",
                    "order": 16,
                    "required": "never",
                    "block": "balance_sheet",
                    "undisclosed": true,
                    "coreTable": "companies_financials",
                    "coreField": "total_liabilities",
                    "dataType": "Decimal"
                  },
                  {
                    "key": "total_equity",
                    "path": "financials.periods.total_equity",
                    "label": "Total equity",
                    "input": "money",
                    "tab": "financials",
                    "section": "periods",
                    "order": 17,
                    "required": "never",
                    "block": "balance_sheet",
                    "undisclosed": true,
                    "coreTable": "companies_financials",
                    "coreField": "total_equity",
                    "dataType": "Decimal"
                  },
                  {
                    "key": "retained_earnings",
                    "path": "financials.periods.retained_earnings",
                    "label": "Retained earnings",
                    "input": "money",
                    "tab": "financials",
                    "section": "periods",
                    "order": 18,
                    "required": "never",
                    "block": "balance_sheet",
                    "undisclosed": true,
                    "coreTable": "companies_financials",
                    "coreField": "retained_earnings",
                    "dataType": "Decimal"
                  },
                  {
                    "key": "total_debt",
                    "path": "financials.periods.total_debt",
                    "label": "Total debt",
                    "input": "money",
                    "tab": "financials",
                    "section": "periods",
                    "order": 19,
                    "required": "never",
                    "block": "balance_sheet",
                    "help": "Interest-bearing debt only.",
                    "undisclosed": true,
                    "coreTable": "companies_financials",
                    "coreField": "total_debt",
                    "dataType": "Decimal"
                  },
                  {
                    "key": "cash_and_cash_equivalents",
                    "path": "financials.periods.cash_and_cash_equivalents",
                    "label": "Cash and cash equivalents",
                    "input": "money",
                    "tab": "financials",
                    "section": "periods",
                    "order": 20,
                    "required": "never",
                    "block": "balance_sheet",
                    "undisclosed": true,
                    "coreTable": "companies_financials",
                    "coreField": "cash_and_cash_equivalents",
                    "dataType": "Decimal"
                  }
                ]
              },
              {
                "key": "cash_flow",
                "label": "Cash flow",
                "fields": [
                  {
                    "key": "net_cash_flow_from_operating_activities",
                    "path": "financials.periods.net_cash_flow_from_operating_activities",
                    "label": "Net cash from operating activities",
                    "input": "money",
                    "tab": "financials",
                    "section": "periods",
                    "order": 21,
                    "required": "never",
                    "block": "cash_flow",
                    "undisclosed": true,
                    "coreTable": "companies_financials",
                    "coreField": "net_cash_flow_from_operating_activities",
                    "dataType": "Decimal"
                  },
                  {
                    "key": "net_cash_flow_from_investing_activities",
                    "path": "financials.periods.net_cash_flow_from_investing_activities",
                    "label": "Net cash from investing activities",
                    "input": "money",
                    "tab": "financials",
                    "section": "periods",
                    "order": 22,
                    "required": "never",
                    "block": "cash_flow",
                    "undisclosed": true,
                    "coreTable": "companies_financials",
                    "coreField": "net_cash_flow_from_investing_activities",
                    "dataType": "Decimal"
                  },
                  {
                    "key": "net_cash_flow_used_in_financing_activities",
                    "path": "financials.periods.net_cash_flow_used_in_financing_activities",
                    "label": "Net cash from financing activities",
                    "input": "money",
                    "tab": "financials",
                    "section": "periods",
                    "order": 23,
                    "required": "never",
                    "block": "cash_flow",
                    "undisclosed": true,
                    "coreTable": "companies_financials",
                    "coreField": "net_cash_flow_used_in_financing_activities",
                    "dataType": "Decimal"
                  }
                ]
              },
              {
                "key": "bank_metrics",
                "label": "Bank metrics",
                "visibleWhen": {
                  "profile": "type_if_banking",
                  "eq": "Bank"
                },
                "fields": [
                  {
                    "key": "npl_ratio",
                    "path": "financials.periods.npl_ratio",
                    "label": "Non-performing loan ratio",
                    "input": "percent",
                    "tab": "financials",
                    "section": "periods",
                    "order": 24,
                    "required": "never",
                    "block": "bank_metrics",
                    "coreTable": "companies_financials",
                    "coreField": "npl_ratio",
                    "dataType": "Decimal"
                  },
                  {
                    "key": "capital_adequacy_ratio",
                    "path": "financials.periods.capital_adequacy_ratio",
                    "label": "Capital adequacy ratio",
                    "input": "percent",
                    "tab": "financials",
                    "section": "periods",
                    "order": 25,
                    "required": "never",
                    "block": "bank_metrics",
                    "coreTable": "companies_financials",
                    "coreField": "capital_adequacy_ratio",
                    "dataType": "Decimal"
                  },
                  {
                    "key": "loan_to_deposit_ratio",
                    "path": "financials.periods.loan_to_deposit_ratio",
                    "label": "Loan-to-deposit ratio",
                    "input": "percent",
                    "tab": "financials",
                    "section": "periods",
                    "order": 26,
                    "required": "never",
                    "block": "bank_metrics",
                    "coreTable": "companies_financials",
                    "coreField": "loan_to_deposit_ratio",
                    "dataType": "Decimal"
                  },
                  {
                    "key": "cost_to_income_ratio",
                    "path": "financials.periods.cost_to_income_ratio",
                    "label": "Cost-to-income ratio",
                    "input": "percent",
                    "tab": "financials",
                    "section": "periods",
                    "order": 27,
                    "required": "never",
                    "block": "bank_metrics",
                    "coreTable": "companies_financials",
                    "coreField": "cost_to_income_ratio",
                    "dataType": "Decimal"
                  },
                  {
                    "key": "cost_of_funds",
                    "path": "financials.periods.cost_of_funds",
                    "label": "Cost of funds",
                    "input": "percent",
                    "tab": "financials",
                    "section": "periods",
                    "order": 28,
                    "required": "never",
                    "block": "bank_metrics",
                    "coreTable": "companies_financials",
                    "coreField": "cost_of_funds",
                    "dataType": "Decimal"
                  }
                ]
              },
              {
                "key": "source",
                "label": "Source and notes",
                "fields": [
                  {
                    "key": "url",
                    "path": "financials.periods.url",
                    "label": "Source document URL",
                    "input": "url",
                    "tab": "financials",
                    "section": "periods",
                    "order": 29,
                    "required": "never",
                    "block": "source",
                    "coreTable": "companies_financials",
                    "coreField": "url",
                    "dataType": "URL"
                  },
                  {
                    "key": "notes",
                    "path": "financials.periods.notes",
                    "label": "Notes",
                    "input": "longtext",
                    "tab": "financials",
                    "section": "periods",
                    "order": 30,
                    "required": "never",
                    "block": "source",
                    "coreTable": "companies_financials",
                    "coreField": "notes",
                    "dataType": "LongText"
                  }
                ]
              }
            ]
          }
        ],
        "intro": "Report in your own currency, in full units. Every figure can be left blank or marked undisclosed."
      },
      {
        "key": "products",
        "number": 7,
        "label": "Products, competitors and providers",
        "shortLabel": "Products",
        "coreTables": [
          "companies_general"
        ],
        "sections": [
          {
            "key": "products",
            "label": "Products and services",
            "kind": "repeatable",
            "tab": "products",
            "order": 0,
            "fields": [
              {
                "key": "datahub.name",
                "path": "products.products.datahub.name",
                "label": "Name",
                "input": "text",
                "tab": "products",
                "section": "products",
                "order": 0,
                "required": "always"
              },
              {
                "key": "datahub.description",
                "path": "products.products.datahub.description",
                "label": "Description",
                "input": "longtext",
                "tab": "products",
                "section": "products",
                "order": 1,
                "required": "never",
                "maxLength": 600
              },
              {
                "key": "datahub.category",
                "path": "products.products.datahub.category",
                "label": "Category",
                "input": "text",
                "tab": "products",
                "section": "products",
                "order": 2,
                "required": "never"
              },
              {
                "key": "datahub.status",
                "path": "products.products.datahub.status",
                "label": "Status",
                "input": "select",
                "tab": "products",
                "section": "products",
                "order": 3,
                "required": "never",
                "options": [
                  {
                    "value": "Active",
                    "label": "Active"
                  },
                  {
                    "value": "Discontinued",
                    "label": "Discontinued"
                  },
                  {
                    "value": "In development",
                    "label": "In development"
                  }
                ]
              },
              {
                "key": "datahub.launch_year",
                "path": "products.products.datahub.launch_year",
                "label": "Launch year",
                "input": "year",
                "tab": "products",
                "section": "products",
                "order": 4,
                "required": "never"
              }
            ],
            "rowEntity": "product",
            "rowLabel": "{name}",
            "toggle": {
              "key": "nothing_to_add",
              "label": "Nothing to add"
            }
          },
          {
            "key": "competitors",
            "label": "Competitors",
            "kind": "repeatable",
            "tab": "products",
            "order": 1,
            "fields": [
              {
                "key": "datahub.name",
                "path": "products.competitors.datahub.name",
                "label": "Name",
                "input": "text",
                "tab": "products",
                "section": "competitors",
                "order": 0,
                "required": "always"
              },
              {
                "key": "datahub.country",
                "path": "products.competitors.datahub.country",
                "label": "Country",
                "input": "select",
                "tab": "products",
                "section": "competitors",
                "order": 1,
                "required": "never",
                "options": [
                  {
                    "value": "nigeria",
                    "label": "Nigeria"
                  },
                  {
                    "value": "ghana",
                    "label": "Ghana"
                  },
                  {
                    "value": "senegal",
                    "label": "Senegal"
                  },
                  {
                    "value": "cote-divoire",
                    "label": "Côte d'Ivoire"
                  },
                  {
                    "value": "mali",
                    "label": "Mali"
                  },
                  {
                    "value": "benin",
                    "label": "Benin"
                  },
                  {
                    "value": "togo",
                    "label": "Togo"
                  },
                  {
                    "value": "burkina-faso",
                    "label": "Burkina Faso"
                  },
                  {
                    "value": "sierra-leone",
                    "label": "Sierra Leone"
                  },
                  {
                    "value": "liberia",
                    "label": "Liberia"
                  },
                  {
                    "value": "guinea",
                    "label": "Guinea"
                  },
                  {
                    "value": "kenya",
                    "label": "Kenya"
                  },
                  {
                    "value": "tanzania",
                    "label": "Tanzania"
                  },
                  {
                    "value": "uganda",
                    "label": "Uganda"
                  },
                  {
                    "value": "rwanda",
                    "label": "Rwanda"
                  },
                  {
                    "value": "ethiopia",
                    "label": "Ethiopia"
                  },
                  {
                    "value": "somalia",
                    "label": "Somalia"
                  },
                  {
                    "value": "burundi",
                    "label": "Burundi"
                  },
                  {
                    "value": "south-sudan",
                    "label": "South Sudan"
                  },
                  {
                    "value": "south-africa",
                    "label": "South Africa"
                  },
                  {
                    "value": "botswana",
                    "label": "Botswana"
                  },
                  {
                    "value": "namibia",
                    "label": "Namibia"
                  },
                  {
                    "value": "zambia",
                    "label": "Zambia"
                  },
                  {
                    "value": "zimbabwe",
                    "label": "Zimbabwe"
                  },
                  {
                    "value": "mozambique",
                    "label": "Mozambique"
                  },
                  {
                    "value": "malawi",
                    "label": "Malawi"
                  },
                  {
                    "value": "mauritius",
                    "label": "Mauritius"
                  },
                  {
                    "value": "egypt",
                    "label": "Egypt"
                  },
                  {
                    "value": "morocco",
                    "label": "Morocco"
                  },
                  {
                    "value": "tunisia",
                    "label": "Tunisia"
                  },
                  {
                    "value": "algeria",
                    "label": "Algeria"
                  },
                  {
                    "value": "libya",
                    "label": "Libya"
                  },
                  {
                    "value": "sudan",
                    "label": "Sudan"
                  },
                  {
                    "value": "cameroon",
                    "label": "Cameroon"
                  },
                  {
                    "value": "drc",
                    "label": "Democratic Republic of the Congo"
                  },
                  {
                    "value": "gabon",
                    "label": "Gabon"
                  },
                  {
                    "value": "chad",
                    "label": "Chad"
                  },
                  {
                    "value": "congo",
                    "label": "Republic of the Congo"
                  },
                  {
                    "value": "united-kingdom",
                    "label": "United Kingdom"
                  },
                  {
                    "value": "united-states",
                    "label": "United States"
                  },
                  {
                    "value": "netherlands",
                    "label": "Netherlands"
                  },
                  {
                    "value": "france",
                    "label": "France"
                  },
                  {
                    "value": "united-arab-emirates",
                    "label": "United Arab Emirates"
                  },
                  {
                    "value": "mauritius-ibc",
                    "label": "Mauritius (IBC)"
                  },
                  {
                    "value": "cayman-islands",
                    "label": "Cayman Islands"
                  },
                  {
                    "value": "luxembourg",
                    "label": "Luxembourg"
                  }
                ],
                "taxonomy": "countries"
              },
              {
                "key": "datahub.website",
                "path": "products.competitors.datahub.website",
                "label": "Website",
                "input": "url",
                "tab": "products",
                "section": "competitors",
                "order": 2,
                "required": "never"
              }
            ],
            "rowEntity": "competitor",
            "rowLabel": "{name}",
            "toggle": {
              "key": "nothing_to_add",
              "label": "Nothing to add"
            }
          },
          {
            "key": "service_providers",
            "label": "Service providers",
            "kind": "repeatable",
            "tab": "products",
            "order": 2,
            "fields": [
              {
                "key": "datahub.firm_name",
                "path": "products.service_providers.datahub.firm_name",
                "label": "Firm",
                "input": "text",
                "tab": "products",
                "section": "service_providers",
                "order": 0,
                "required": "always"
              },
              {
                "key": "datahub.service_type",
                "path": "products.service_providers.datahub.service_type",
                "label": "Service type",
                "input": "select",
                "tab": "products",
                "section": "service_providers",
                "order": 1,
                "required": "always",
                "options": [
                  {
                    "value": "Legal",
                    "label": "Legal"
                  },
                  {
                    "value": "Audit and accounting",
                    "label": "Audit and accounting"
                  },
                  {
                    "value": "Investment bank or financial adviser",
                    "label": "Investment bank or financial adviser"
                  },
                  {
                    "value": "Tax",
                    "label": "Tax"
                  },
                  {
                    "value": "Consulting",
                    "label": "Consulting"
                  },
                  {
                    "value": "Public relations",
                    "label": "Public relations"
                  },
                  {
                    "value": "Company secretary",
                    "label": "Company secretary"
                  },
                  {
                    "value": "Share registrar",
                    "label": "Share registrar"
                  },
                  {
                    "value": "Other",
                    "label": "Other"
                  }
                ]
              },
              {
                "key": "datahub.relationship",
                "path": "products.service_providers.datahub.relationship",
                "label": "Relationship",
                "input": "select",
                "tab": "products",
                "section": "service_providers",
                "order": 2,
                "required": "never",
                "options": [
                  {
                    "value": "Ongoing",
                    "label": "Ongoing"
                  },
                  {
                    "value": "Deal-specific",
                    "label": "Deal-specific"
                  }
                ]
              },
              {
                "key": "datahub.since",
                "path": "products.service_providers.datahub.since",
                "label": "Since",
                "input": "year",
                "tab": "products",
                "section": "service_providers",
                "order": 3,
                "required": "never"
              }
            ],
            "rowEntity": "service_provider",
            "rowLabel": "{firm_name} — {service_type}",
            "toggle": {
              "key": "nothing_to_add",
              "label": "Nothing to add"
            }
          }
        ]
      },
      {
        "key": "documents",
        "number": 8,
        "label": "Documents",
        "shortLabel": "Documents",
        "coreTables": [],
        "sections": [
          {
            "key": "documents",
            "label": "Supporting documents",
            "kind": "uploads",
            "tab": "documents",
            "order": 0,
            "fields": [],
            "toggle": {
              "key": "nothing_to_add",
              "label": "No documents to upload"
            }
          }
        ],
        "intro": "Optional. Annual reports, financial statements, press releases or anything that supports your submission. Files are private to Stears."
      },
      {
        "key": "review",
        "number": 9,
        "label": "Review and submit",
        "shortLabel": "Review",
        "coreTables": [],
        "sections": [
          {
            "key": "review",
            "label": "Review",
            "kind": "review",
            "tab": "review",
            "order": 0,
            "fields": []
          }
        ]
      }
    ]
  },
  {
    "key": "gp",
    "label": "Fund manager (GP)",
    "entityType": "gp",
    "tabs": [
      {
        "key": "general",
        "number": 1,
        "label": "Firm profile",
        "shortLabel": "Firm",
        "coreTables": [
          "investors_general"
        ],
        "sections": [
          {
            "key": "identity",
            "label": "Corporate Data",
            "kind": "fields",
            "tab": "general",
            "order": 0,
            "fields": [
              {
                "key": "investor_name",
                "path": "general.identity.investor_name",
                "label": "Firm name",
                "input": "text",
                "tab": "general",
                "section": "identity",
                "order": 0,
                "required": "always",
                "help": "The registered name of the management company",
                "coreTable": "investors_general",
                "coreField": "investor_name",
                "dataType": "SingleLineText"
              },
              {
                "key": "datahub.brand_names",
                "path": "general.identity.datahub.brand_names",
                "label": "Brand or trading names",
                "input": "taglist",
                "tab": "general",
                "section": "identity",
                "order": 1,
                "required": "never",
                "help": "Names your firm is commonly known by."
              },
              {
                "key": "alias_former_names",
                "path": "general.identity.alias_former_names",
                "label": "Former names",
                "input": "taglist",
                "tab": "general",
                "section": "identity",
                "order": 2,
                "required": "never",
                "help": "Previous registered or trading names.",
                "coreTable": "investors_general",
                "coreField": "alias_former_names",
                "dataType": "Links"
              },
              {
                "key": "description_strategy",
                "path": "general.identity.description_strategy",
                "label": "Firm description and strategy",
                "input": "longtext",
                "tab": "general",
                "section": "identity",
                "order": 3,
                "required": "always",
                "help": "What the firm does, the strategy it runs and how it creates value. Neutral and factual, present tense.",
                "maxLength": 2000,
                "coreTable": "investors_general",
                "coreField": "description_strategy",
                "dataType": "LongText"
              },
              {
                "key": "website_url",
                "path": "general.identity.website_url",
                "label": "Website",
                "input": "url",
                "tab": "general",
                "section": "identity",
                "order": 4,
                "required": "always",
                "coreTable": "investors_general",
                "coreField": "website_url",
                "dataType": "URL"
              },
              {
                "key": "founding_year",
                "path": "general.identity.founding_year",
                "label": "Year founded",
                "input": "year",
                "tab": "general",
                "section": "identity",
                "order": 5,
                "required": "never",
                "coreTable": "investors_general",
                "coreField": "founding_year",
                "dataType": "Number"
              },
              {
                "key": "investor_type",
                "path": "general.identity.investor_type",
                "label": "Investor type",
                "input": "multiselect",
                "tab": "general",
                "section": "identity",
                "order": 6,
                "required": "always",
                "help": "Select every type that describes your firm.",
                "options": [
                  {
                    "value": "venture-capital",
                    "label": "Venture Capital"
                  },
                  {
                    "value": "private-equity",
                    "label": "Private Equity"
                  },
                  {
                    "value": "high-net-worth-individuals",
                    "label": "High Net-Worth Individuals (HNIs)"
                  },
                  {
                    "value": "development-finance-institution",
                    "label": "Development Finance Institution"
                  },
                  {
                    "value": "corporate-venture-capital",
                    "label": "Corporate Venture Capital"
                  },
                  {
                    "value": "angel-network",
                    "label": "Angel Network"
                  },
                  {
                    "value": "sovereign-wealth-fund",
                    "label": "Sovereign Wealth Fund"
                  },
                  {
                    "value": "family-office",
                    "label": "Family Office"
                  },
                  {
                    "value": "private-credit",
                    "label": "Private Credit"
                  },
                  {
                    "value": "corporate-strategic-investor",
                    "label": "Corporate Strategic Investor"
                  }
                ],
                "taxonomy": "gp_investor_types",
                "coreTable": "investors_general",
                "coreField": "investor_type",
                "dataType": "MultiSelect"
              },
              {
                "key": "investor_status",
                "path": "general.identity.investor_status",
                "label": "Investor status",
                "input": "select",
                "tab": "general",
                "section": "identity",
                "order": 7,
                "required": "always",
                "options": [
                  {
                    "value": "actively-seeking",
                    "label": "Actively seeking new investments"
                  },
                  {
                    "value": "out-of-business",
                    "label": "Out of business"
                  },
                  {
                    "value": "fully-invested",
                    "label": "Fully invested, no longer seeking new investments"
                  },
                  {
                    "value": "acquired-merged",
                    "label": "Acquired/Merged"
                  },
                  {
                    "value": "acquired-merged-operating-subsidiary",
                    "label": "Acquired/Merged (Operating subsidiary)"
                  },
                  {
                    "value": "not-making-new-investments",
                    "label": "Not making new investments"
                  },
                  {
                    "value": "reducing-investment-activity",
                    "label": "Reducing investment activity"
                  },
                  {
                    "value": "will-consider",
                    "label": "Will consider new projects"
                  }
                ],
                "taxonomy": "investor_statuses",
                "coreTable": "investors_general",
                "coreField": "investor_status",
                "dataType": "SingleSelect"
              }
            ]
          },
          {
            "key": "hq_location",
            "label": "Headquarters",
            "kind": "fields",
            "tab": "general",
            "order": 1,
            "fields": [
              {
                "key": "hq_city_country",
                "path": "general.hq_location.hq_city_country",
                "label": "Headquarters (city, country)",
                "input": "text",
                "tab": "general",
                "section": "hq_location",
                "order": 0,
                "required": "always",
                "help": "For example, Lagos, Nigeria.",
                "coreTable": "investors_general",
                "coreField": "hq_city_country",
                "dataType": "SingleLineText"
              },
              {
                "key": "hq_region",
                "path": "general.hq_location.hq_region",
                "label": "Headquarters region",
                "input": "select",
                "tab": "general",
                "section": "hq_location",
                "order": 1,
                "required": "never",
                "options": [
                  {
                    "value": "western-africa",
                    "label": "Western Africa"
                  },
                  {
                    "value": "eastern-africa",
                    "label": "Eastern Africa"
                  },
                  {
                    "value": "southern-africa",
                    "label": "Southern Africa"
                  },
                  {
                    "value": "northern-africa",
                    "label": "Northern Africa"
                  },
                  {
                    "value": "central-africa",
                    "label": "Central Africa"
                  },
                  {
                    "value": "europe",
                    "label": "Europe"
                  },
                  {
                    "value": "northern-america",
                    "label": "Northern America"
                  },
                  {
                    "value": "central-america",
                    "label": "Central America"
                  },
                  {
                    "value": "southern-america",
                    "label": "Southern America"
                  },
                  {
                    "value": "middle-east",
                    "label": "Middle East"
                  },
                  {
                    "value": "asia",
                    "label": "Asia"
                  },
                  {
                    "value": "australia",
                    "label": "Australia"
                  }
                ],
                "taxonomy": "hq_regions",
                "coreTable": "investors_general",
                "coreField": "hq_region",
                "dataType": "Links"
              }
            ]
          },
          {
            "key": "capital",
            "label": "Capital",
            "kind": "fields",
            "tab": "general",
            "order": 2,
            "fields": [
              {
                "key": "assets_under_management",
                "path": "general.capital.assets_under_management",
                "label": "Assets under management",
                "input": "money",
                "tab": "general",
                "section": "capital",
                "order": 0,
                "required": "never",
                "help": "Current assets under management across every vehicle.",
                "undisclosed": true,
                "coreTable": "investors_general",
                "coreField": "assets_under_management",
                "dataType": "Currency"
              },
              {
                "key": "total_amount_committed",
                "path": "general.capital.total_amount_committed",
                "label": "Total capital committed",
                "input": "money",
                "tab": "general",
                "section": "capital",
                "order": 1,
                "required": "never",
                "help": "Total capital committed to your funds by investors since inception.",
                "undisclosed": true,
                "coreTable": "investors_general",
                "coreField": "total_amount_committed",
                "dataType": "Currency"
              },
              {
                "key": "currency_ticket_size",
                "path": "general.capital.currency_ticket_size",
                "label": "Ticket size currency",
                "input": "select",
                "tab": "general",
                "section": "capital",
                "order": 2,
                "required": "never",
                "help": "The currency your ticket sizes are quoted in.",
                "options": [
                  {
                    "value": "USD",
                    "label": "USD"
                  },
                  {
                    "value": "NGN",
                    "label": "NGN"
                  },
                  {
                    "value": "ZAR",
                    "label": "ZAR"
                  },
                  {
                    "value": "KES",
                    "label": "KES"
                  },
                  {
                    "value": "GHS",
                    "label": "GHS"
                  },
                  {
                    "value": "EGP",
                    "label": "EGP"
                  },
                  {
                    "value": "MAD",
                    "label": "MAD"
                  },
                  {
                    "value": "TZS",
                    "label": "TZS"
                  },
                  {
                    "value": "UGX",
                    "label": "UGX"
                  },
                  {
                    "value": "RWF",
                    "label": "RWF"
                  },
                  {
                    "value": "XOF",
                    "label": "XOF"
                  },
                  {
                    "value": "XAF",
                    "label": "XAF"
                  },
                  {
                    "value": "ZMW",
                    "label": "ZMW"
                  },
                  {
                    "value": "MUR",
                    "label": "MUR"
                  },
                  {
                    "value": "EUR",
                    "label": "EUR"
                  },
                  {
                    "value": "GBP",
                    "label": "GBP"
                  }
                ],
                "taxonomy": "currencies",
                "coreTable": "investors_general",
                "coreField": "currency_ticket_size",
                "dataType": "SingleSelect"
              },
              {
                "key": "ticket_size",
                "path": "general.capital.ticket_size",
                "label": "Typical ticket size",
                "input": "multiselect",
                "tab": "general",
                "section": "capital",
                "order": 3,
                "required": "never",
                "options": [
                  {
                    "value": "lt-100k",
                    "label": "< 100K"
                  },
                  {
                    "value": "100k-500k",
                    "label": "100K - 500K"
                  },
                  {
                    "value": "500k-1m",
                    "label": "500K - 1 Mn"
                  },
                  {
                    "value": "1m-3m",
                    "label": "1 Mn - 3 Mn"
                  },
                  {
                    "value": "3m-5m",
                    "label": "3 Mn - 5 Mn"
                  },
                  {
                    "value": "5m-15m",
                    "label": "5 Mn - 15 Mn"
                  },
                  {
                    "value": "15m-30m",
                    "label": "15 Mn - 30 Mn"
                  },
                  {
                    "value": "30m-50m",
                    "label": "30 Mn - 50 Mn"
                  },
                  {
                    "value": "50m-70m",
                    "label": "50 Mn - 70 Mn"
                  },
                  {
                    "value": "70m-100m",
                    "label": "70 Mn - 100 Mn"
                  },
                  {
                    "value": "100m-200m",
                    "label": "100 Mn to 200 Mn"
                  }
                ],
                "taxonomy": "ticket_sizes",
                "coreTable": "investors_general",
                "coreField": "ticket_size",
                "dataType": "Links"
              }
            ]
          },
          {
            "key": "impact",
            "label": "Impact",
            "kind": "fields",
            "tab": "general",
            "order": 3,
            "fields": [
              {
                "key": "sdg_focus",
                "path": "general.impact.sdg_focus",
                "label": "SDG focus",
                "input": "multiselect",
                "tab": "general",
                "section": "impact",
                "order": 0,
                "required": "never",
                "options": [
                  {
                    "value": "sdg-1-(no-poverty)",
                    "label": "SDG 1 (No Poverty)"
                  },
                  {
                    "value": "sdg-2-(zero-hunger)",
                    "label": "SDG 2 (Zero Hunger)"
                  },
                  {
                    "value": "sdg-3-(good-health-and-well-being)",
                    "label": "SDG 3 (Good Health and Well-Being)"
                  },
                  {
                    "value": "sdg-4-(quality-education)",
                    "label": "SDG 4 (Quality Education)"
                  },
                  {
                    "value": "sdg-5-(gender-equality)",
                    "label": "SDG 5 (Gender Equality)"
                  },
                  {
                    "value": "sdg-6-(clean-water-and-sanitation)",
                    "label": "SDG 6 (Clean Water and Sanitation)"
                  },
                  {
                    "value": "sdg-7-(affordable-and-clean-energy)",
                    "label": "SDG 7 (Affordable and Clean Energy)"
                  },
                  {
                    "value": "sdg-8-(decent-work-and-economic-growth)",
                    "label": "SDG 8 (Decent Work and Economic Growth)"
                  },
                  {
                    "value": "sdg-9-(industry-innovation-and-infrastructure)",
                    "label": "SDG 9 (Industry Innovation and Infrastructure)"
                  },
                  {
                    "value": "sdg-10-(reduced-inequalities)",
                    "label": "SDG 10 (Reduced Inequalities)"
                  },
                  {
                    "value": "sdg-11-(sustainable-cities-and-communities)",
                    "label": "SDG 11 (Sustainable Cities and Communities)"
                  },
                  {
                    "value": "sdg-12-(responsible-consumption-and-production)",
                    "label": "SDG 12 (Responsible Consumption and Production)"
                  },
                  {
                    "value": "sdg-13-(climate-action)",
                    "label": "SDG 13 (Climate Action)"
                  },
                  {
                    "value": "sdg-14-(life-below-water)",
                    "label": "SDG 14 (Life Below Water)"
                  },
                  {
                    "value": "sdg-15-(life-on-land)",
                    "label": "SDG 15 (Life on Land)"
                  },
                  {
                    "value": "sdg-16-(peace-justice-and-strong-institutions)",
                    "label": "SDG 16 (Peace Justice and Strong Institutions)"
                  },
                  {
                    "value": "sdg-17-(partnerships-for-the-goals)",
                    "label": "SDG 17 (Partnerships for the Goals)"
                  }
                ],
                "taxonomy": "sdg_focuses",
                "coreTable": "investors_general",
                "coreField": "sdg_focus",
                "dataType": "Links"
              },
              {
                "key": "impact_reports",
                "path": "general.impact.impact_reports",
                "label": "Impact report",
                "input": "url",
                "tab": "general",
                "section": "impact",
                "order": 1,
                "required": "never",
                "help": "A link to your most recent published impact or ESG report.",
                "coreTable": "investors_general",
                "coreField": "impact_reports",
                "dataType": "URL"
              }
            ],
            "collapsed": true
          }
        ],
        "intro": "Confirm the details Stears holds about your firm. Fields marked required must be completed."
      },
      {
        "key": "contacts",
        "number": 2,
        "label": "Contacts and locations",
        "shortLabel": "Contacts",
        "coreTables": [
          "investors_general"
        ],
        "sections": [
          {
            "key": "hq",
            "label": "Headquarters address",
            "kind": "fields",
            "tab": "contacts",
            "order": 0,
            "fields": [
              {
                "key": "datahub.hq_street",
                "path": "contacts.hq.datahub.hq_street",
                "label": "Street address",
                "input": "text",
                "tab": "contacts",
                "section": "hq",
                "order": 0,
                "required": "never"
              },
              {
                "key": "datahub.hq_city",
                "path": "contacts.hq.datahub.hq_city",
                "label": "City",
                "input": "text",
                "tab": "contacts",
                "section": "hq",
                "order": 1,
                "required": "always"
              },
              {
                "key": "datahub.hq_state",
                "path": "contacts.hq.datahub.hq_state",
                "label": "State or region",
                "input": "text",
                "tab": "contacts",
                "section": "hq",
                "order": 2,
                "required": "never"
              },
              {
                "key": "datahub.hq_postcode",
                "path": "contacts.hq.datahub.hq_postcode",
                "label": "Postcode",
                "input": "text",
                "tab": "contacts",
                "section": "hq",
                "order": 3,
                "required": "never"
              },
              {
                "key": "datahub.general_phone",
                "path": "contacts.hq.datahub.general_phone",
                "label": "General phone",
                "input": "tel",
                "tab": "contacts",
                "section": "hq",
                "order": 4,
                "required": "never"
              },
              {
                "key": "datahub.general_email",
                "path": "contacts.hq.datahub.general_email",
                "label": "General email",
                "input": "email",
                "tab": "contacts",
                "section": "hq",
                "order": 5,
                "required": "never"
              }
            ]
          },
          {
            "key": "online",
            "label": "Online",
            "kind": "fields",
            "tab": "contacts",
            "order": 1,
            "fields": [
              {
                "key": "datahub.linkedin_url",
                "path": "contacts.online.datahub.linkedin_url",
                "label": "LinkedIn",
                "input": "url",
                "tab": "contacts",
                "section": "online",
                "order": 0,
                "required": "never"
              },
              {
                "key": "datahub.x_url",
                "path": "contacts.online.datahub.x_url",
                "label": "X (Twitter)",
                "input": "url",
                "tab": "contacts",
                "section": "online",
                "order": 1,
                "required": "never"
              }
            ]
          },
          {
            "key": "offices",
            "label": "Other offices",
            "kind": "repeatable",
            "tab": "contacts",
            "order": 2,
            "fields": [
              {
                "key": "datahub.office_type",
                "path": "contacts.offices.datahub.office_type",
                "label": "Office type",
                "input": "select",
                "tab": "contacts",
                "section": "offices",
                "order": 0,
                "required": "always",
                "options": [
                  {
                    "value": "Registered office",
                    "label": "Registered office"
                  },
                  {
                    "value": "Regional office",
                    "label": "Regional office"
                  },
                  {
                    "value": "Representative office",
                    "label": "Representative office"
                  },
                  {
                    "value": "Other",
                    "label": "Other"
                  }
                ]
              },
              {
                "key": "datahub.city",
                "path": "contacts.offices.datahub.city",
                "label": "City",
                "input": "text",
                "tab": "contacts",
                "section": "offices",
                "order": 1,
                "required": "always"
              },
              {
                "key": "datahub.country",
                "path": "contacts.offices.datahub.country",
                "label": "Country",
                "input": "select",
                "tab": "contacts",
                "section": "offices",
                "order": 2,
                "required": "always",
                "options": [
                  {
                    "value": "nigeria",
                    "label": "Nigeria"
                  },
                  {
                    "value": "ghana",
                    "label": "Ghana"
                  },
                  {
                    "value": "senegal",
                    "label": "Senegal"
                  },
                  {
                    "value": "cote-divoire",
                    "label": "Côte d'Ivoire"
                  },
                  {
                    "value": "mali",
                    "label": "Mali"
                  },
                  {
                    "value": "benin",
                    "label": "Benin"
                  },
                  {
                    "value": "togo",
                    "label": "Togo"
                  },
                  {
                    "value": "burkina-faso",
                    "label": "Burkina Faso"
                  },
                  {
                    "value": "sierra-leone",
                    "label": "Sierra Leone"
                  },
                  {
                    "value": "liberia",
                    "label": "Liberia"
                  },
                  {
                    "value": "guinea",
                    "label": "Guinea"
                  },
                  {
                    "value": "kenya",
                    "label": "Kenya"
                  },
                  {
                    "value": "tanzania",
                    "label": "Tanzania"
                  },
                  {
                    "value": "uganda",
                    "label": "Uganda"
                  },
                  {
                    "value": "rwanda",
                    "label": "Rwanda"
                  },
                  {
                    "value": "ethiopia",
                    "label": "Ethiopia"
                  },
                  {
                    "value": "somalia",
                    "label": "Somalia"
                  },
                  {
                    "value": "burundi",
                    "label": "Burundi"
                  },
                  {
                    "value": "south-sudan",
                    "label": "South Sudan"
                  },
                  {
                    "value": "south-africa",
                    "label": "South Africa"
                  },
                  {
                    "value": "botswana",
                    "label": "Botswana"
                  },
                  {
                    "value": "namibia",
                    "label": "Namibia"
                  },
                  {
                    "value": "zambia",
                    "label": "Zambia"
                  },
                  {
                    "value": "zimbabwe",
                    "label": "Zimbabwe"
                  },
                  {
                    "value": "mozambique",
                    "label": "Mozambique"
                  },
                  {
                    "value": "malawi",
                    "label": "Malawi"
                  },
                  {
                    "value": "mauritius",
                    "label": "Mauritius"
                  },
                  {
                    "value": "egypt",
                    "label": "Egypt"
                  },
                  {
                    "value": "morocco",
                    "label": "Morocco"
                  },
                  {
                    "value": "tunisia",
                    "label": "Tunisia"
                  },
                  {
                    "value": "algeria",
                    "label": "Algeria"
                  },
                  {
                    "value": "libya",
                    "label": "Libya"
                  },
                  {
                    "value": "sudan",
                    "label": "Sudan"
                  },
                  {
                    "value": "cameroon",
                    "label": "Cameroon"
                  },
                  {
                    "value": "drc",
                    "label": "Democratic Republic of the Congo"
                  },
                  {
                    "value": "gabon",
                    "label": "Gabon"
                  },
                  {
                    "value": "chad",
                    "label": "Chad"
                  },
                  {
                    "value": "congo",
                    "label": "Republic of the Congo"
                  },
                  {
                    "value": "united-kingdom",
                    "label": "United Kingdom"
                  },
                  {
                    "value": "united-states",
                    "label": "United States"
                  },
                  {
                    "value": "netherlands",
                    "label": "Netherlands"
                  },
                  {
                    "value": "france",
                    "label": "France"
                  },
                  {
                    "value": "united-arab-emirates",
                    "label": "United Arab Emirates"
                  },
                  {
                    "value": "mauritius-ibc",
                    "label": "Mauritius (IBC)"
                  },
                  {
                    "value": "cayman-islands",
                    "label": "Cayman Islands"
                  },
                  {
                    "value": "luxembourg",
                    "label": "Luxembourg"
                  }
                ],
                "taxonomy": "countries"
              },
              {
                "key": "datahub.address",
                "path": "contacts.offices.datahub.address",
                "label": "Address",
                "input": "text",
                "tab": "contacts",
                "section": "offices",
                "order": 3,
                "required": "never"
              }
            ],
            "rowEntity": "location",
            "rowLabel": "{city}, {country}",
            "toggle": {
              "key": "nothing_to_add",
              "label": "No other offices to report"
            }
          },
          {
            "key": "datahub_contacts",
            "label": "People who receive this link",
            "kind": "repeatable",
            "tab": "contacts",
            "order": 3,
            "fields": [
              {
                "key": "datahub.full_name",
                "path": "contacts.datahub_contacts.datahub.full_name",
                "label": "Name",
                "input": "text",
                "tab": "contacts",
                "section": "datahub_contacts",
                "order": 0,
                "required": "always"
              },
              {
                "key": "datahub.role_title",
                "path": "contacts.datahub_contacts.datahub.role_title",
                "label": "Role",
                "input": "text",
                "tab": "contacts",
                "section": "datahub_contacts",
                "order": 1,
                "required": "never"
              },
              {
                "key": "datahub.email",
                "path": "contacts.datahub_contacts.datahub.email",
                "label": "Email",
                "input": "email",
                "tab": "contacts",
                "section": "datahub_contacts",
                "order": 2,
                "required": "always"
              }
            ],
            "help": "Stears sends the update link to these people. Add a colleague to have them included from the next cycle.",
            "rowEntity": "contact",
            "rowLabel": "{full_name}",
            "minRowsForComplete": 1,
            "readOnlyExisting": true
          }
        ]
      },
      {
        "key": "people",
        "number": 3,
        "label": "Management team",
        "shortLabel": "Team",
        "coreTables": [
          "people_general",
          "people_role_engagements"
        ],
        "sections": [
          {
            "key": "people",
            "label": "Investment team, partners and board",
            "kind": "repeatable",
            "tab": "people",
            "order": 0,
            "fields": [
              {
                "key": "first_name",
                "path": "people.people.first_name",
                "label": "First name",
                "input": "text",
                "tab": "people",
                "section": "people",
                "order": 0,
                "required": "always",
                "coreTable": "people_general",
                "coreField": "first_name",
                "dataType": "SingleLineText"
              },
              {
                "key": "last_name",
                "path": "people.people.last_name",
                "label": "Last name",
                "input": "text",
                "tab": "people",
                "section": "people",
                "order": 1,
                "required": "always",
                "coreTable": "people_general",
                "coreField": "last_name",
                "dataType": "SingleLineText"
              },
              {
                "key": "role_title",
                "path": "people.people.role_title",
                "label": "Role title",
                "input": "text",
                "tab": "people",
                "section": "people",
                "order": 2,
                "required": "always",
                "help": "The exact title, for example Managing Partner or Head of Investments.",
                "coreTable": "people_role_engagements",
                "coreField": "role_title",
                "dataType": "SingleLineText"
              },
              {
                "key": "role_category",
                "path": "people.people.role_category",
                "label": "Role category",
                "input": "select",
                "tab": "people",
                "section": "people",
                "order": 3,
                "required": "always",
                "options": [
                  {
                    "value": "C-Suite / Executive",
                    "label": "C-Suite / Executive"
                  },
                  {
                    "value": "Senior Management",
                    "label": "Senior Management"
                  },
                  {
                    "value": "Executive Director",
                    "label": "Executive Director"
                  },
                  {
                    "value": "Non-Executive Director",
                    "label": "Non-Executive Director"
                  },
                  {
                    "value": "Board Chair / Vice-Chair",
                    "label": "Board Chair / Vice-Chair"
                  },
                  {
                    "value": "Board Committee Chair / Member",
                    "label": "Board Committee Chair / Member"
                  },
                  {
                    "value": "Founder / Co-Founder",
                    "label": "Founder / Co-Founder"
                  },
                  {
                    "value": "General Partner (GP)",
                    "label": "General Partner (GP)"
                  },
                  {
                    "value": "Limited Partner (LP)",
                    "label": "Limited Partner (LP)"
                  },
                  {
                    "value": "Partner",
                    "label": "Partner"
                  },
                  {
                    "value": "Board Observer",
                    "label": "Board Observer"
                  },
                  {
                    "value": "Senior Advisor / Consultant",
                    "label": "Senior Advisor / Consultant"
                  },
                  {
                    "value": "IC Chairperson",
                    "label": "IC Chairperson"
                  },
                  {
                    "value": "Internal IC Members",
                    "label": "Internal IC Members"
                  },
                  {
                    "value": "External IC Members",
                    "label": "External IC Members"
                  },
                  {
                    "value": "Board of Governor",
                    "label": "Board of Governor"
                  }
                ],
                "grouped": true,
                "coreTable": "people_role_engagements",
                "coreField": "role_category",
                "dataType": "SingleSelect"
              },
              {
                "key": "datahub.management_status",
                "path": "people.people.datahub.management_status",
                "label": "Management status",
                "input": "radio",
                "tab": "people",
                "section": "people",
                "order": 4,
                "required": "always",
                "options": [
                  {
                    "value": "Team member",
                    "label": "Team member"
                  },
                  {
                    "value": "Board member",
                    "label": "Board member"
                  },
                  {
                    "value": "Investment committee",
                    "label": "Investment committee"
                  }
                ]
              },
              {
                "key": "start_date",
                "path": "people.people.start_date",
                "label": "Start date",
                "input": "date",
                "tab": "people",
                "section": "people",
                "order": 5,
                "required": "never",
                "precision": true,
                "coreTable": "people_role_engagements",
                "coreField": "start_date",
                "dataType": "Date"
              },
              {
                "key": "role_status",
                "path": "people.people.role_status",
                "label": "Status",
                "input": "radio",
                "tab": "people",
                "section": "people",
                "order": 6,
                "required": "always",
                "options": [
                  {
                    "value": "Current",
                    "label": "Current"
                  },
                  {
                    "value": "Former",
                    "label": "Former"
                  }
                ],
                "coreTable": "people_role_engagements",
                "coreField": "role_status",
                "dataType": "SingleSelect"
              },
              {
                "key": "end_date",
                "path": "people.people.end_date",
                "label": "End date",
                "input": "date",
                "tab": "people",
                "section": "people",
                "order": 7,
                "required": "conditional",
                "requiredWhen": {
                  "field": "role_status",
                  "eq": "Former"
                },
                "visibleWhen": {
                  "field": "role_status",
                  "eq": "Former"
                },
                "coreTable": "people_role_engagements",
                "coreField": "end_date",
                "dataType": "Date"
              },
              {
                "key": "datahub.location_city",
                "path": "people.people.datahub.location_city",
                "label": "City",
                "input": "text",
                "tab": "people",
                "section": "people",
                "order": 8,
                "required": "never"
              },
              {
                "key": "datahub.location_country",
                "path": "people.people.datahub.location_country",
                "label": "Country of primary residence",
                "input": "select",
                "tab": "people",
                "section": "people",
                "order": 9,
                "required": "never",
                "options": [
                  {
                    "value": "nigeria",
                    "label": "Nigeria"
                  },
                  {
                    "value": "ghana",
                    "label": "Ghana"
                  },
                  {
                    "value": "senegal",
                    "label": "Senegal"
                  },
                  {
                    "value": "cote-divoire",
                    "label": "Côte d'Ivoire"
                  },
                  {
                    "value": "mali",
                    "label": "Mali"
                  },
                  {
                    "value": "benin",
                    "label": "Benin"
                  },
                  {
                    "value": "togo",
                    "label": "Togo"
                  },
                  {
                    "value": "burkina-faso",
                    "label": "Burkina Faso"
                  },
                  {
                    "value": "sierra-leone",
                    "label": "Sierra Leone"
                  },
                  {
                    "value": "liberia",
                    "label": "Liberia"
                  },
                  {
                    "value": "guinea",
                    "label": "Guinea"
                  },
                  {
                    "value": "kenya",
                    "label": "Kenya"
                  },
                  {
                    "value": "tanzania",
                    "label": "Tanzania"
                  },
                  {
                    "value": "uganda",
                    "label": "Uganda"
                  },
                  {
                    "value": "rwanda",
                    "label": "Rwanda"
                  },
                  {
                    "value": "ethiopia",
                    "label": "Ethiopia"
                  },
                  {
                    "value": "somalia",
                    "label": "Somalia"
                  },
                  {
                    "value": "burundi",
                    "label": "Burundi"
                  },
                  {
                    "value": "south-sudan",
                    "label": "South Sudan"
                  },
                  {
                    "value": "south-africa",
                    "label": "South Africa"
                  },
                  {
                    "value": "botswana",
                    "label": "Botswana"
                  },
                  {
                    "value": "namibia",
                    "label": "Namibia"
                  },
                  {
                    "value": "zambia",
                    "label": "Zambia"
                  },
                  {
                    "value": "zimbabwe",
                    "label": "Zimbabwe"
                  },
                  {
                    "value": "mozambique",
                    "label": "Mozambique"
                  },
                  {
                    "value": "malawi",
                    "label": "Malawi"
                  },
                  {
                    "value": "mauritius",
                    "label": "Mauritius"
                  },
                  {
                    "value": "egypt",
                    "label": "Egypt"
                  },
                  {
                    "value": "morocco",
                    "label": "Morocco"
                  },
                  {
                    "value": "tunisia",
                    "label": "Tunisia"
                  },
                  {
                    "value": "algeria",
                    "label": "Algeria"
                  },
                  {
                    "value": "libya",
                    "label": "Libya"
                  },
                  {
                    "value": "sudan",
                    "label": "Sudan"
                  },
                  {
                    "value": "cameroon",
                    "label": "Cameroon"
                  },
                  {
                    "value": "drc",
                    "label": "Democratic Republic of the Congo"
                  },
                  {
                    "value": "gabon",
                    "label": "Gabon"
                  },
                  {
                    "value": "chad",
                    "label": "Chad"
                  },
                  {
                    "value": "congo",
                    "label": "Republic of the Congo"
                  },
                  {
                    "value": "united-kingdom",
                    "label": "United Kingdom"
                  },
                  {
                    "value": "united-states",
                    "label": "United States"
                  },
                  {
                    "value": "netherlands",
                    "label": "Netherlands"
                  },
                  {
                    "value": "france",
                    "label": "France"
                  },
                  {
                    "value": "united-arab-emirates",
                    "label": "United Arab Emirates"
                  },
                  {
                    "value": "mauritius-ibc",
                    "label": "Mauritius (IBC)"
                  },
                  {
                    "value": "cayman-islands",
                    "label": "Cayman Islands"
                  },
                  {
                    "value": "luxembourg",
                    "label": "Luxembourg"
                  }
                ],
                "taxonomy": "countries"
              },
              {
                "key": "linkedin_url",
                "path": "people.people.linkedin_url",
                "label": "LinkedIn",
                "input": "url",
                "tab": "people",
                "section": "people",
                "order": 10,
                "required": "never",
                "coreTable": "people_general",
                "coreField": "linkedin_url",
                "dataType": "URL"
              },
              {
                "key": "email",
                "path": "people.people.email",
                "label": "Professional email",
                "input": "email",
                "tab": "people",
                "section": "people",
                "order": 11,
                "required": "never",
                "help": "Held in Stears internal records only, never published.",
                "confidential": "always",
                "coreTable": "people_general",
                "coreField": "email",
                "dataType": "Email"
              },
              {
                "key": "phone_number",
                "path": "people.people.phone_number",
                "label": "Phone",
                "input": "tel",
                "tab": "people",
                "section": "people",
                "order": 12,
                "required": "never",
                "help": "Held in Stears internal records only, never published.",
                "confidential": "always",
                "coreTable": "people_general",
                "coreField": "phone_number",
                "dataType": "PhoneNumber"
              },
              {
                "key": "biography",
                "path": "people.people.biography",
                "label": "Biography",
                "input": "longtext",
                "tab": "people",
                "section": "people",
                "order": 13,
                "required": "never",
                "maxLength": 1500,
                "coreTable": "people_general",
                "coreField": "biography",
                "dataType": "LongText"
              },
              {
                "key": "gender",
                "path": "people.people.gender",
                "label": "Gender",
                "input": "select",
                "tab": "people",
                "section": "people",
                "order": 14,
                "required": "never",
                "help": "Optional. Used for aggregate diversity reporting",
                "options": [
                  {
                    "value": "Male",
                    "label": "Male"
                  },
                  {
                    "value": "Female",
                    "label": "Female"
                  },
                  {
                    "value": "Other",
                    "label": "Other"
                  },
                  {
                    "value": "Undisclosed",
                    "label": "Undisclosed"
                  }
                ],
                "coreTable": "people_general",
                "coreField": "gender",
                "dataType": "SingleSelect"
              },
              {
                "key": "nationality",
                "path": "people.people.nationality",
                "label": "Nationality",
                "input": "multiselect",
                "tab": "people",
                "section": "people",
                "order": 15,
                "required": "never",
                "help": "Optional.",
                "options": [
                  {
                    "value": "nigeria",
                    "label": "Nigeria"
                  },
                  {
                    "value": "ghana",
                    "label": "Ghana"
                  },
                  {
                    "value": "senegal",
                    "label": "Senegal"
                  },
                  {
                    "value": "cote-divoire",
                    "label": "Côte d'Ivoire"
                  },
                  {
                    "value": "mali",
                    "label": "Mali"
                  },
                  {
                    "value": "benin",
                    "label": "Benin"
                  },
                  {
                    "value": "togo",
                    "label": "Togo"
                  },
                  {
                    "value": "burkina-faso",
                    "label": "Burkina Faso"
                  },
                  {
                    "value": "sierra-leone",
                    "label": "Sierra Leone"
                  },
                  {
                    "value": "liberia",
                    "label": "Liberia"
                  },
                  {
                    "value": "guinea",
                    "label": "Guinea"
                  },
                  {
                    "value": "kenya",
                    "label": "Kenya"
                  },
                  {
                    "value": "tanzania",
                    "label": "Tanzania"
                  },
                  {
                    "value": "uganda",
                    "label": "Uganda"
                  },
                  {
                    "value": "rwanda",
                    "label": "Rwanda"
                  },
                  {
                    "value": "ethiopia",
                    "label": "Ethiopia"
                  },
                  {
                    "value": "somalia",
                    "label": "Somalia"
                  },
                  {
                    "value": "burundi",
                    "label": "Burundi"
                  },
                  {
                    "value": "south-sudan",
                    "label": "South Sudan"
                  },
                  {
                    "value": "south-africa",
                    "label": "South Africa"
                  },
                  {
                    "value": "botswana",
                    "label": "Botswana"
                  },
                  {
                    "value": "namibia",
                    "label": "Namibia"
                  },
                  {
                    "value": "zambia",
                    "label": "Zambia"
                  },
                  {
                    "value": "zimbabwe",
                    "label": "Zimbabwe"
                  },
                  {
                    "value": "mozambique",
                    "label": "Mozambique"
                  },
                  {
                    "value": "malawi",
                    "label": "Malawi"
                  },
                  {
                    "value": "mauritius",
                    "label": "Mauritius"
                  },
                  {
                    "value": "egypt",
                    "label": "Egypt"
                  },
                  {
                    "value": "morocco",
                    "label": "Morocco"
                  },
                  {
                    "value": "tunisia",
                    "label": "Tunisia"
                  },
                  {
                    "value": "algeria",
                    "label": "Algeria"
                  },
                  {
                    "value": "libya",
                    "label": "Libya"
                  },
                  {
                    "value": "sudan",
                    "label": "Sudan"
                  },
                  {
                    "value": "cameroon",
                    "label": "Cameroon"
                  },
                  {
                    "value": "drc",
                    "label": "Democratic Republic of the Congo"
                  },
                  {
                    "value": "gabon",
                    "label": "Gabon"
                  },
                  {
                    "value": "chad",
                    "label": "Chad"
                  },
                  {
                    "value": "congo",
                    "label": "Republic of the Congo"
                  },
                  {
                    "value": "united-kingdom",
                    "label": "United Kingdom"
                  },
                  {
                    "value": "united-states",
                    "label": "United States"
                  },
                  {
                    "value": "netherlands",
                    "label": "Netherlands"
                  },
                  {
                    "value": "france",
                    "label": "France"
                  },
                  {
                    "value": "united-arab-emirates",
                    "label": "United Arab Emirates"
                  },
                  {
                    "value": "mauritius-ibc",
                    "label": "Mauritius (IBC)"
                  },
                  {
                    "value": "cayman-islands",
                    "label": "Cayman Islands"
                  },
                  {
                    "value": "luxembourg",
                    "label": "Luxembourg"
                  }
                ],
                "taxonomy": "countries",
                "coreTable": "people_general",
                "coreField": "nationality",
                "dataType": "Links"
              }
            ],
            "rowEntity": "person_role",
            "rowLabel": "{first_name} {last_name} — {role_title}",
            "toggle": {
              "key": "no_changes",
              "label": "No changes to the team"
            }
          }
        ],
        "intro": "One row per role. A founder who is also the managing partner has two rows."
      },
      {
        "key": "mandate",
        "number": 4,
        "label": "Investment mandate",
        "shortLabel": "Mandate",
        "coreTables": [
          "investors_general"
        ],
        "sections": [
          {
            "key": "geography",
            "label": "Geography",
            "kind": "fields",
            "tab": "mandate",
            "order": 0,
            "fields": [
              {
                "key": "regions_of_investment",
                "path": "mandate.geography.regions_of_investment",
                "label": "Regions of investment",
                "input": "multiselect",
                "tab": "mandate",
                "section": "geography",
                "order": 0,
                "required": "always",
                "options": [
                  {
                    "value": "global",
                    "label": "Global"
                  },
                  {
                    "value": "pan-african",
                    "label": "Pan-African"
                  },
                  {
                    "value": "sub-saharan-africa",
                    "label": "Sub-Saharan Africa"
                  },
                  {
                    "value": "northern-africa",
                    "label": "Northern Africa"
                  },
                  {
                    "value": "eastern-africa",
                    "label": "Eastern Africa"
                  },
                  {
                    "value": "western-africa",
                    "label": "Western Africa"
                  },
                  {
                    "value": "central-africa",
                    "label": "Central Africa"
                  },
                  {
                    "value": "southern-africa",
                    "label": "Southern Africa"
                  },
                  {
                    "value": "europe",
                    "label": "Europe"
                  },
                  {
                    "value": "asia",
                    "label": "Asia"
                  },
                  {
                    "value": "middle-east",
                    "label": "Middle East"
                  },
                  {
                    "value": "americas",
                    "label": "Americas"
                  },
                  {
                    "value": "southern-america",
                    "label": "Southern America"
                  },
                  {
                    "value": "northern-america",
                    "label": "Northern America"
                  },
                  {
                    "value": "central-america",
                    "label": "Central America"
                  },
                  {
                    "value": "latin-america",
                    "label": "Latin America"
                  },
                  {
                    "value": "australia",
                    "label": "Australia"
                  },
                  {
                    "value": "eurasia",
                    "label": "Eurasia"
                  },
                  {
                    "value": "oceania",
                    "label": "Oceania"
                  }
                ],
                "taxonomy": "regions",
                "coreTable": "investors_general",
                "coreField": "regions_of_investment",
                "dataType": "Links"
              },
              {
                "key": "country_of_operation",
                "path": "mandate.geography.country_of_operation",
                "label": "Country of operation",
                "input": "multiselect",
                "tab": "mandate",
                "section": "geography",
                "order": 1,
                "required": "never",
                "help": "Countries where you hold or actively seek investments.",
                "options": [
                  {
                    "value": "nigeria",
                    "label": "Nigeria"
                  },
                  {
                    "value": "ghana",
                    "label": "Ghana"
                  },
                  {
                    "value": "senegal",
                    "label": "Senegal"
                  },
                  {
                    "value": "cote-divoire",
                    "label": "Côte d'Ivoire"
                  },
                  {
                    "value": "mali",
                    "label": "Mali"
                  },
                  {
                    "value": "benin",
                    "label": "Benin"
                  },
                  {
                    "value": "togo",
                    "label": "Togo"
                  },
                  {
                    "value": "burkina-faso",
                    "label": "Burkina Faso"
                  },
                  {
                    "value": "sierra-leone",
                    "label": "Sierra Leone"
                  },
                  {
                    "value": "liberia",
                    "label": "Liberia"
                  },
                  {
                    "value": "guinea",
                    "label": "Guinea"
                  },
                  {
                    "value": "kenya",
                    "label": "Kenya"
                  },
                  {
                    "value": "tanzania",
                    "label": "Tanzania"
                  },
                  {
                    "value": "uganda",
                    "label": "Uganda"
                  },
                  {
                    "value": "rwanda",
                    "label": "Rwanda"
                  },
                  {
                    "value": "ethiopia",
                    "label": "Ethiopia"
                  },
                  {
                    "value": "somalia",
                    "label": "Somalia"
                  },
                  {
                    "value": "burundi",
                    "label": "Burundi"
                  },
                  {
                    "value": "south-sudan",
                    "label": "South Sudan"
                  },
                  {
                    "value": "south-africa",
                    "label": "South Africa"
                  },
                  {
                    "value": "botswana",
                    "label": "Botswana"
                  },
                  {
                    "value": "namibia",
                    "label": "Namibia"
                  },
                  {
                    "value": "zambia",
                    "label": "Zambia"
                  },
                  {
                    "value": "zimbabwe",
                    "label": "Zimbabwe"
                  },
                  {
                    "value": "mozambique",
                    "label": "Mozambique"
                  },
                  {
                    "value": "malawi",
                    "label": "Malawi"
                  },
                  {
                    "value": "mauritius",
                    "label": "Mauritius"
                  },
                  {
                    "value": "egypt",
                    "label": "Egypt"
                  },
                  {
                    "value": "morocco",
                    "label": "Morocco"
                  },
                  {
                    "value": "tunisia",
                    "label": "Tunisia"
                  },
                  {
                    "value": "algeria",
                    "label": "Algeria"
                  },
                  {
                    "value": "libya",
                    "label": "Libya"
                  },
                  {
                    "value": "sudan",
                    "label": "Sudan"
                  },
                  {
                    "value": "cameroon",
                    "label": "Cameroon"
                  },
                  {
                    "value": "drc",
                    "label": "Democratic Republic of the Congo"
                  },
                  {
                    "value": "gabon",
                    "label": "Gabon"
                  },
                  {
                    "value": "chad",
                    "label": "Chad"
                  },
                  {
                    "value": "congo",
                    "label": "Republic of the Congo"
                  },
                  {
                    "value": "united-kingdom",
                    "label": "United Kingdom"
                  },
                  {
                    "value": "united-states",
                    "label": "United States"
                  },
                  {
                    "value": "netherlands",
                    "label": "Netherlands"
                  },
                  {
                    "value": "france",
                    "label": "France"
                  },
                  {
                    "value": "united-arab-emirates",
                    "label": "United Arab Emirates"
                  },
                  {
                    "value": "mauritius-ibc",
                    "label": "Mauritius (IBC)"
                  },
                  {
                    "value": "cayman-islands",
                    "label": "Cayman Islands"
                  },
                  {
                    "value": "luxembourg",
                    "label": "Luxembourg"
                  }
                ],
                "taxonomy": "countries",
                "coreTable": "investors_general",
                "coreField": "country_of_operation",
                "dataType": "Links"
              }
            ]
          },
          {
            "key": "focus",
            "label": "Sector and stage",
            "kind": "fields",
            "tab": "mandate",
            "order": 1,
            "fields": [
              {
                "key": "sector_preference",
                "path": "mandate.focus.sector_preference",
                "label": "Sector preferences",
                "input": "multiselect",
                "tab": "mandate",
                "section": "focus",
                "order": 0,
                "required": "always",
                "options": [
                  {
                    "value": "sector-agnostic",
                    "label": "Sector Agnostic"
                  },
                  {
                    "value": "financial-services",
                    "label": "Financial Services"
                  },
                  {
                    "value": "energy-utilities",
                    "label": "Energy & Utilities"
                  },
                  {
                    "value": "consumer-staples",
                    "label": "Consumer Staples"
                  },
                  {
                    "value": "consumer-discretionary",
                    "label": "Consumer Discretionary"
                  },
                  {
                    "value": "information-technology",
                    "label": "Information Technology"
                  },
                  {
                    "value": "communication-services",
                    "label": "Communication Services"
                  },
                  {
                    "value": "agriculture",
                    "label": "Agriculture"
                  },
                  {
                    "value": "industrials",
                    "label": "Industrials"
                  },
                  {
                    "value": "healthcare",
                    "label": "Healthcare"
                  },
                  {
                    "value": "real-estate",
                    "label": "Real Estate"
                  },
                  {
                    "value": "materials",
                    "label": "Materials"
                  }
                ],
                "taxonomy": "investment_sectors",
                "coreTable": "investors_general",
                "coreField": "sector_preference",
                "dataType": "Links"
              },
              {
                "key": "investment_stage",
                "path": "mandate.focus.investment_stage",
                "label": "Investment stages",
                "input": "multiselect",
                "tab": "mandate",
                "section": "focus",
                "order": 1,
                "required": "always",
                "options": [
                  {
                    "value": "pre-seed",
                    "label": "Pre-seed"
                  },
                  {
                    "value": "seed",
                    "label": "Seed"
                  },
                  {
                    "value": "series-a",
                    "label": "Series A"
                  },
                  {
                    "value": "series-b",
                    "label": "Series B"
                  },
                  {
                    "value": "series-c",
                    "label": "Series C"
                  },
                  {
                    "value": "series-d+",
                    "label": "Series D+"
                  },
                  {
                    "value": "growth-stage",
                    "label": "Growth Stage"
                  },
                  {
                    "value": "growth-equity",
                    "label": "Growth Equity"
                  },
                  {
                    "value": "buyout",
                    "label": "Buyout"
                  }
                ],
                "taxonomy": "investment_stages",
                "coreTable": "investors_general",
                "coreField": "investment_stage",
                "dataType": "Links"
              },
              {
                "key": "investment_instrument",
                "path": "mandate.focus.investment_instrument",
                "label": "Instruments used",
                "input": "multiselect",
                "tab": "mandate",
                "section": "focus",
                "order": 2,
                "required": "never",
                "options": [
                  {
                    "value": "equity",
                    "label": "Equity"
                  },
                  {
                    "value": "debt",
                    "label": "Debt"
                  },
                  {
                    "value": "mezzanine",
                    "label": "Mezzanine"
                  },
                  {
                    "value": "safe",
                    "label": "SAFE"
                  }
                ],
                "taxonomy": "gp_instruments",
                "coreTable": "investors_general",
                "coreField": "investment_instrument",
                "dataType": "Links"
              }
            ]
          }
        ],
        "intro": "Where you invest, what you invest in and how."
      },
      {
        "key": "funds",
        "number": 5,
        "label": "Funds and vehicles",
        "shortLabel": "Funds",
        "coreTables": [
          "investment_vehicles"
        ],
        "sections": [
          {
            "key": "vehicles",
            "label": "Fund vehicles",
            "kind": "repeatable",
            "tab": "funds",
            "order": 0,
            "fields": [],
            "layout": "cards",
            "rowEntity": "fund_vehicle",
            "rowLabel": "{fund_name} ({vintage_year})",
            "toggle": {
              "key": "nothing_to_add",
              "label": "No fund vehicles to report"
            },
            "confidentiality": "row",
            "blocks": [
              {
                "key": "vehicle_identity",
                "label": "Fund",
                "fields": [
                  {
                    "key": "fund_name",
                    "path": "funds.vehicles.fund_name",
                    "label": "Fund name",
                    "input": "text",
                    "tab": "funds",
                    "section": "vehicles",
                    "order": 0,
                    "required": "always",
                    "block": "vehicle_identity",
                    "coreTable": "investment_vehicles",
                    "coreField": "fund_name",
                    "dataType": "SingleLineText"
                  },
                  {
                    "key": "vintage_year",
                    "path": "funds.vehicles.vintage_year",
                    "label": "Vintage year",
                    "input": "year",
                    "tab": "funds",
                    "section": "vehicles",
                    "order": 1,
                    "required": "never",
                    "block": "vehicle_identity",
                    "coreTable": "investment_vehicles",
                    "coreField": "vintage_year",
                    "dataType": "Number"
                  },
                  {
                    "key": "fund_type",
                    "path": "funds.vehicles.fund_type",
                    "label": "Fund type",
                    "input": "multiselect",
                    "tab": "funds",
                    "section": "vehicles",
                    "order": 2,
                    "required": "never",
                    "block": "vehicle_identity",
                    "options": [
                      {
                        "value": "private-equity",
                        "label": "Private Equity"
                      },
                      {
                        "value": "venture-capital",
                        "label": "Venture Capital"
                      },
                      {
                        "value": "private-credit",
                        "label": "Private Credit"
                      },
                      {
                        "value": "infrastructure",
                        "label": "Infrastructure"
                      },
                      {
                        "value": "real-estate",
                        "label": "Real Estate"
                      },
                      {
                        "value": "impact-fund",
                        "label": "Impact Fund"
                      }
                    ],
                    "taxonomy": "fund_types",
                    "coreTable": "investment_vehicles",
                    "coreField": "fund_type",
                    "dataType": "Links"
                  },
                  {
                    "key": "fund_strategy",
                    "path": "funds.vehicles.fund_strategy",
                    "label": "Fund strategy",
                    "input": "multiselect",
                    "tab": "funds",
                    "section": "vehicles",
                    "order": 3,
                    "required": "never",
                    "block": "vehicle_identity",
                    "options": [
                      {
                        "value": "seed-&-early-stage",
                        "label": "Seed & Early-stage"
                      },
                      {
                        "value": "expansion-/-late-stage",
                        "label": "Expansion / Late-stage"
                      },
                      {
                        "value": "growth-equity",
                        "label": "Growth Equity"
                      },
                      {
                        "value": "buyout",
                        "label": "Buyout"
                      },
                      {
                        "value": "mezzanine",
                        "label": "Mezzanine"
                      },
                      {
                        "value": "direct-lending",
                        "label": "Direct Lending"
                      },
                      {
                        "value": "venture-debt",
                        "label": "Venture Debt"
                      },
                      {
                        "value": "distressed-/-special-situations",
                        "label": "Distressed / Special Situations"
                      },
                      {
                        "value": "fund-of-funds",
                        "label": "Fund of Funds"
                      },
                      {
                        "value": "secondaries-(lp-led-&-gp-led/continuation-vehicles)",
                        "label": "Secondaries (LP-led & GP-led/continuation vehicles)"
                      }
                    ],
                    "taxonomy": "fund_strategies",
                    "coreTable": "investment_vehicles",
                    "coreField": "fund_strategy",
                    "dataType": "Links"
                  },
                  {
                    "key": "nature_of_fund",
                    "path": "funds.vehicles.nature_of_fund",
                    "label": "Nature of fund",
                    "input": "select",
                    "tab": "funds",
                    "section": "vehicles",
                    "order": 4,
                    "required": "never",
                    "block": "vehicle_identity",
                    "options": [
                      {
                        "value": "independent",
                        "label": "Independent"
                      },
                      {
                        "value": "captive",
                        "label": "Captive"
                      },
                      {
                        "value": "semi-captive",
                        "label": "Semi-Captive"
                      }
                    ],
                    "taxonomy": "nature_of_fund",
                    "coreTable": "investment_vehicles",
                    "coreField": "nature_of_fund",
                    "dataType": "SingleSelect"
                  },
                  {
                    "key": "fund_status",
                    "path": "funds.vehicles.fund_status",
                    "label": "Fund status",
                    "input": "select",
                    "tab": "funds",
                    "section": "vehicles",
                    "order": 5,
                    "required": "always",
                    "block": "vehicle_identity",
                    "options": [
                      {
                        "value": "active",
                        "label": "Active"
                      },
                      {
                        "value": "closed",
                        "label": "Closed"
                      },
                      {
                        "value": "fully-invested",
                        "label": "Fully Invested"
                      },
                      {
                        "value": "exited",
                        "label": "Exited"
                      }
                    ],
                    "taxonomy": "fund_statuses",
                    "coreTable": "investment_vehicles",
                    "coreField": "fund_status",
                    "dataType": "SingleSelect"
                  },
                  {
                    "key": "datahub.publication_permission",
                    "path": "funds.vehicles.datahub.publication_permission",
                    "label": "Publication permission",
                    "input": "radio",
                    "tab": "funds",
                    "section": "vehicles",
                    "order": 6,
                    "required": "always",
                    "block": "vehicle_identity",
                    "options": [
                      {
                        "value": "Stears may publish",
                        "label": "Stears may publish"
                      },
                      {
                        "value": "Confidential — internal records only",
                        "label": "Confidential — internal records only"
                      }
                    ],
                    "default": "Stears may publish"
                  }
                ]
              },
              {
                "key": "vehicle_capital",
                "label": "Size and deployment",
                "fields": [
                  {
                    "key": "size_target",
                    "path": "funds.vehicles.size_target",
                    "label": "Target size",
                    "input": "money",
                    "tab": "funds",
                    "section": "vehicles",
                    "order": 7,
                    "required": "never",
                    "block": "vehicle_capital",
                    "undisclosed": true,
                    "coreTable": "investment_vehicles",
                    "coreField": "size_target",
                    "dataType": "Currency"
                  },
                  {
                    "key": "size_closed",
                    "path": "funds.vehicles.size_closed",
                    "label": "Amount closed",
                    "input": "money",
                    "tab": "funds",
                    "section": "vehicles",
                    "order": 8,
                    "required": "never",
                    "block": "vehicle_capital",
                    "help": "Total committed by investors at the most recent close.",
                    "undisclosed": true,
                    "coreTable": "investment_vehicles",
                    "coreField": "size_closed",
                    "dataType": "Currency"
                  },
                  {
                    "key": "deployed",
                    "path": "funds.vehicles.deployed",
                    "label": "Amount deployed",
                    "input": "money",
                    "tab": "funds",
                    "section": "vehicles",
                    "order": 9,
                    "required": "never",
                    "block": "vehicle_capital",
                    "undisclosed": true,
                    "coreTable": "investment_vehicles",
                    "coreField": "deployed",
                    "dataType": "Currency"
                  },
                  {
                    "key": "fund_duration",
                    "path": "funds.vehicles.fund_duration",
                    "label": "Fund life in years",
                    "input": "number",
                    "tab": "funds",
                    "section": "vehicles",
                    "order": 10,
                    "required": "never",
                    "block": "vehicle_capital",
                    "step": 0.5,
                    "coreTable": "investment_vehicles",
                    "coreField": "fund_duration",
                    "dataType": "Number"
                  },
                  {
                    "key": "datahub.launch_date",
                    "path": "funds.vehicles.datahub.launch_date",
                    "label": "Fund launch date",
                    "input": "date",
                    "tab": "funds",
                    "section": "vehicles",
                    "order": 11,
                    "required": "never",
                    "block": "vehicle_capital"
                  },
                  {
                    "key": "first_close_date",
                    "path": "funds.vehicles.first_close_date",
                    "label": "First close",
                    "input": "date",
                    "tab": "funds",
                    "section": "vehicles",
                    "order": 12,
                    "required": "never",
                    "block": "vehicle_capital",
                    "coreTable": "investment_vehicles",
                    "coreField": "first_close_date",
                    "dataType": "Date"
                  },
                  {
                    "key": "datahub.first_close_amount",
                    "path": "funds.vehicles.datahub.first_close_amount",
                    "label": "Amount at first close",
                    "input": "money",
                    "tab": "funds",
                    "section": "vehicles",
                    "order": 13,
                    "required": "never",
                    "block": "vehicle_capital",
                    "undisclosed": true
                  },
                  {
                    "key": "datahub.second_close_date",
                    "path": "funds.vehicles.datahub.second_close_date",
                    "label": "Second close",
                    "input": "date",
                    "tab": "funds",
                    "section": "vehicles",
                    "order": 14,
                    "required": "never",
                    "block": "vehicle_capital"
                  },
                  {
                    "key": "datahub.second_close_amount",
                    "path": "funds.vehicles.datahub.second_close_amount",
                    "label": "Amount at second close",
                    "input": "money",
                    "tab": "funds",
                    "section": "vehicles",
                    "order": 15,
                    "required": "never",
                    "block": "vehicle_capital",
                    "undisclosed": true
                  },
                  {
                    "key": "datahub.third_close_date",
                    "path": "funds.vehicles.datahub.third_close_date",
                    "label": "Third close",
                    "input": "date",
                    "tab": "funds",
                    "section": "vehicles",
                    "order": 16,
                    "required": "never",
                    "block": "vehicle_capital"
                  },
                  {
                    "key": "datahub.third_close_amount",
                    "path": "funds.vehicles.datahub.third_close_amount",
                    "label": "Amount at third close",
                    "input": "money",
                    "tab": "funds",
                    "section": "vehicles",
                    "order": 17,
                    "required": "never",
                    "block": "vehicle_capital",
                    "undisclosed": true
                  },
                  {
                    "key": "final_close_date",
                    "path": "funds.vehicles.final_close_date",
                    "label": "Final close",
                    "input": "date",
                    "tab": "funds",
                    "section": "vehicles",
                    "order": 18,
                    "required": "never",
                    "block": "vehicle_capital",
                    "help": "The date the fund stopped raising. Leave empty if the fund is still raising.",
                    "coreTable": "investment_vehicles",
                    "coreField": "final_close_date",
                    "dataType": "Date"
                  }
                ]
              },
              {
                "key": "vehicle_mandate",
                "label": "Fund mandate",
                "fields": [
                  {
                    "key": "fund_regions_of_investment",
                    "path": "funds.vehicles.fund_regions_of_investment",
                    "label": "Regions of investment",
                    "input": "multiselect",
                    "tab": "funds",
                    "section": "vehicles",
                    "order": 19,
                    "required": "never",
                    "block": "vehicle_mandate",
                    "options": [
                      {
                        "value": "global",
                        "label": "Global"
                      },
                      {
                        "value": "pan-african",
                        "label": "Pan-African"
                      },
                      {
                        "value": "sub-saharan-africa",
                        "label": "Sub-Saharan Africa"
                      },
                      {
                        "value": "northern-africa",
                        "label": "Northern Africa"
                      },
                      {
                        "value": "eastern-africa",
                        "label": "Eastern Africa"
                      },
                      {
                        "value": "western-africa",
                        "label": "Western Africa"
                      },
                      {
                        "value": "central-africa",
                        "label": "Central Africa"
                      },
                      {
                        "value": "southern-africa",
                        "label": "Southern Africa"
                      },
                      {
                        "value": "europe",
                        "label": "Europe"
                      },
                      {
                        "value": "asia",
                        "label": "Asia"
                      },
                      {
                        "value": "middle-east",
                        "label": "Middle East"
                      },
                      {
                        "value": "americas",
                        "label": "Americas"
                      },
                      {
                        "value": "southern-america",
                        "label": "Southern America"
                      },
                      {
                        "value": "northern-america",
                        "label": "Northern America"
                      },
                      {
                        "value": "central-america",
                        "label": "Central America"
                      },
                      {
                        "value": "latin-america",
                        "label": "Latin America"
                      },
                      {
                        "value": "australia",
                        "label": "Australia"
                      },
                      {
                        "value": "eurasia",
                        "label": "Eurasia"
                      },
                      {
                        "value": "oceania",
                        "label": "Oceania"
                      }
                    ],
                    "taxonomy": "regions",
                    "coreTable": "investment_vehicles",
                    "coreField": "fund_regions_of_investment",
                    "dataType": "Links"
                  },
                  {
                    "key": "fund_sectors",
                    "path": "funds.vehicles.fund_sectors",
                    "label": "Sector focus",
                    "input": "multiselect",
                    "tab": "funds",
                    "section": "vehicles",
                    "order": 20,
                    "required": "never",
                    "block": "vehicle_mandate",
                    "options": [
                      {
                        "value": "sector-agnostic",
                        "label": "Sector Agnostic"
                      },
                      {
                        "value": "macroeconomy",
                        "label": "Macroeconomy"
                      },
                      {
                        "value": "financial-services",
                        "label": "Financial Services"
                      },
                      {
                        "value": "energy-utilities",
                        "label": "Energy & Utilities"
                      },
                      {
                        "value": "consumer-staples",
                        "label": "Consumer Staples"
                      },
                      {
                        "value": "consumer-discretionary",
                        "label": "Consumer Discretionary"
                      },
                      {
                        "value": "information-technology",
                        "label": "Information Technology"
                      },
                      {
                        "value": "communication-services",
                        "label": "Communication Services"
                      },
                      {
                        "value": "agriculture",
                        "label": "Agriculture"
                      },
                      {
                        "value": "industrials",
                        "label": "Industrials"
                      },
                      {
                        "value": "healthcare",
                        "label": "Healthcare"
                      },
                      {
                        "value": "real-estate",
                        "label": "Real Estate"
                      },
                      {
                        "value": "materials",
                        "label": "Materials"
                      }
                    ],
                    "taxonomy": "fund_sector_focus",
                    "coreTable": "investment_vehicles",
                    "coreField": "fund_sectors",
                    "dataType": "Links"
                  },
                  {
                    "key": "fund_ticket_size",
                    "path": "funds.vehicles.fund_ticket_size",
                    "label": "Ticket size range",
                    "input": "multiselect",
                    "tab": "funds",
                    "section": "vehicles",
                    "order": 21,
                    "required": "never",
                    "block": "vehicle_mandate",
                    "options": [
                      {
                        "value": "lt-100k",
                        "label": "< 100K"
                      },
                      {
                        "value": "100k-500k",
                        "label": "100K - 500K"
                      },
                      {
                        "value": "500k-1m",
                        "label": "500K - 1 Mn"
                      },
                      {
                        "value": "1m-25m",
                        "label": "1 Mn - 25 Mn"
                      },
                      {
                        "value": "25m-50m",
                        "label": "25 Mn - 50 Mn"
                      },
                      {
                        "value": "50m-100m",
                        "label": "50 Mn - 100 Mn"
                      },
                      {
                        "value": "100m-500m",
                        "label": "100 Mn - 500 Mn"
                      },
                      {
                        "value": "gt-500m",
                        "label": "More than 500 Mn"
                      }
                    ],
                    "taxonomy": "fund_ticket_sizes",
                    "coreTable": "investment_vehicles",
                    "coreField": "fund_ticket_size",
                    "dataType": "Links"
                  },
                  {
                    "key": "fund_ticket_size_currency",
                    "path": "funds.vehicles.fund_ticket_size_currency",
                    "label": "Ticket size currency",
                    "input": "select",
                    "tab": "funds",
                    "section": "vehicles",
                    "order": 22,
                    "required": "never",
                    "block": "vehicle_mandate",
                    "options": [
                      {
                        "value": "USD",
                        "label": "USD"
                      },
                      {
                        "value": "NGN",
                        "label": "NGN"
                      },
                      {
                        "value": "ZAR",
                        "label": "ZAR"
                      },
                      {
                        "value": "KES",
                        "label": "KES"
                      },
                      {
                        "value": "GHS",
                        "label": "GHS"
                      },
                      {
                        "value": "EGP",
                        "label": "EGP"
                      },
                      {
                        "value": "MAD",
                        "label": "MAD"
                      },
                      {
                        "value": "TZS",
                        "label": "TZS"
                      },
                      {
                        "value": "UGX",
                        "label": "UGX"
                      },
                      {
                        "value": "RWF",
                        "label": "RWF"
                      },
                      {
                        "value": "XOF",
                        "label": "XOF"
                      },
                      {
                        "value": "XAF",
                        "label": "XAF"
                      },
                      {
                        "value": "ZMW",
                        "label": "ZMW"
                      },
                      {
                        "value": "MUR",
                        "label": "MUR"
                      },
                      {
                        "value": "EUR",
                        "label": "EUR"
                      },
                      {
                        "value": "GBP",
                        "label": "GBP"
                      }
                    ],
                    "taxonomy": "currencies",
                    "coreTable": "investment_vehicles",
                    "coreField": "fund_ticket_size_currency",
                    "dataType": "SingleSelect"
                  },
                  {
                    "key": "fund_location_criteria",
                    "path": "funds.vehicles.fund_location_criteria",
                    "label": "Location criteria",
                    "input": "longtext",
                    "tab": "funds",
                    "section": "vehicles",
                    "order": 23,
                    "required": "never",
                    "block": "vehicle_mandate",
                    "maxLength": 5000,
                    "coreTable": "investment_vehicles",
                    "coreField": "fund_location_criteria",
                    "dataType": "LongText"
                  },
                  {
                    "key": "environmental_criteria",
                    "path": "funds.vehicles.environmental_criteria",
                    "label": "Environmental criteria",
                    "input": "longtext",
                    "tab": "funds",
                    "section": "vehicles",
                    "order": 24,
                    "required": "never",
                    "block": "vehicle_mandate",
                    "maxLength": 5000,
                    "coreTable": "investment_vehicles",
                    "coreField": "environmental_criteria",
                    "dataType": "LongText"
                  },
                  {
                    "key": "social_criteria",
                    "path": "funds.vehicles.social_criteria",
                    "label": "Social criteria",
                    "input": "longtext",
                    "tab": "funds",
                    "section": "vehicles",
                    "order": 25,
                    "required": "never",
                    "block": "vehicle_mandate",
                    "maxLength": 5000,
                    "coreTable": "investment_vehicles",
                    "coreField": "social_criteria",
                    "dataType": "LongText"
                  },
                  {
                    "key": "governance_criteria",
                    "path": "funds.vehicles.governance_criteria",
                    "label": "Governance criteria",
                    "input": "longtext",
                    "tab": "funds",
                    "section": "vehicles",
                    "order": 26,
                    "required": "never",
                    "block": "vehicle_mandate",
                    "maxLength": 5000,
                    "coreTable": "investment_vehicles",
                    "coreField": "governance_criteria",
                    "dataType": "LongText"
                  },
                  {
                    "key": "financial_and_other_criteria",
                    "path": "funds.vehicles.financial_and_other_criteria",
                    "label": "Financial and other criteria",
                    "input": "longtext",
                    "tab": "funds",
                    "section": "vehicles",
                    "order": 27,
                    "required": "never",
                    "block": "vehicle_mandate",
                    "maxLength": 5000,
                    "coreTable": "investment_vehicles",
                    "coreField": "financial_and_other_criteria",
                    "dataType": "LongText"
                  }
                ]
              }
            ]
          },
          {
            "key": "backers",
            "label": "Investors in your funds",
            "kind": "repeatable",
            "tab": "funds",
            "order": 1,
            "fields": [
              {
                "key": "commitment_lp_name",
                "path": "funds.backers.commitment_lp_name",
                "label": "Investor",
                "input": "text",
                "tab": "funds",
                "section": "backers",
                "order": 0,
                "required": "always",
                "coreTable": "fund_commitments",
                "coreField": "commitment_lp_name",
                "dataType": "SingleLineText"
              },
              {
                "key": "commitment_lp_type",
                "path": "funds.backers.commitment_lp_type",
                "label": "Investor type",
                "input": "multiselect",
                "tab": "funds",
                "section": "backers",
                "order": 1,
                "required": "never",
                "options": [
                  {
                    "value": "asset-manager",
                    "label": "Asset Manager"
                  },
                  {
                    "value": "corporate-investor",
                    "label": "Corporate Investor"
                  },
                  {
                    "value": "development-finance-institution",
                    "label": "Development Finance Institution"
                  },
                  {
                    "value": "family-office",
                    "label": "Family Office"
                  },
                  {
                    "value": "foundation-endowment",
                    "label": "Foundation/Endowment"
                  },
                  {
                    "value": "fund-of-funds",
                    "label": "Fund of Funds"
                  },
                  {
                    "value": "insurance-company",
                    "label": "Insurance Company"
                  },
                  {
                    "value": "investment-bank",
                    "label": "Investment Bank"
                  },
                  {
                    "value": "pension-fund",
                    "label": "Pension Fund"
                  },
                  {
                    "value": "sovereign-wealth-fund",
                    "label": "Sovereign Wealth Fund"
                  },
                  {
                    "value": "high-net-worth-individuals",
                    "label": "High Net-Worth Individuals (HNIs)"
                  }
                ],
                "taxonomy": "lp_types",
                "coreTable": "fund_commitments",
                "coreField": "commitment_lp_type",
                "dataType": "MultiSelect"
              },
              {
                "key": "commitment_fund_name",
                "path": "funds.backers.commitment_fund_name",
                "label": "Into fund",
                "input": "text",
                "tab": "funds",
                "section": "backers",
                "order": 2,
                "required": "always",
                "coreTable": "fund_commitments",
                "coreField": "commitment_fund_name",
                "dataType": "SingleLineText"
              },
              {
                "key": "commitment_amount",
                "path": "funds.backers.commitment_amount",
                "label": "Amount committed",
                "input": "money",
                "tab": "funds",
                "section": "backers",
                "order": 3,
                "required": "never",
                "undisclosed": true,
                "coreTable": "fund_commitments",
                "coreField": "commitment_amount",
                "dataType": "Currency"
              },
              {
                "key": "commitment_date",
                "path": "funds.backers.commitment_date",
                "label": "Commitment date",
                "input": "date",
                "tab": "funds",
                "section": "backers",
                "order": 4,
                "required": "never",
                "coreTable": "fund_commitments",
                "coreField": "commitment_date",
                "dataType": "Date"
              },
              {
                "key": "commitment_status",
                "path": "funds.backers.commitment_status",
                "label": "Commitment status",
                "input": "select",
                "tab": "funds",
                "section": "backers",
                "order": 5,
                "required": "never",
                "options": [
                  {
                    "value": "Committed",
                    "label": "Committed"
                  },
                  {
                    "value": "Drawn down in part",
                    "label": "Drawn down in part"
                  },
                  {
                    "value": "Fully drawn",
                    "label": "Fully drawn"
                  },
                  {
                    "value": "Realised",
                    "label": "Realised"
                  },
                  {
                    "value": "Withdrawn",
                    "label": "Withdrawn"
                  }
                ],
                "coreTable": "fund_commitments",
                "coreField": "commitment_status",
                "dataType": "SingleSelect"
              },
              {
                "key": "datahub.publication_permission",
                "path": "funds.backers.datahub.publication_permission",
                "label": "Publication permission",
                "input": "radio",
                "tab": "funds",
                "section": "backers",
                "order": 6,
                "required": "always",
                "options": [
                  {
                    "value": "Stears may publish",
                    "label": "Stears may publish"
                  },
                  {
                    "value": "Confidential — internal records only",
                    "label": "Confidential — internal records only"
                  }
                ],
                "default": "Confidential — internal records only"
              }
            ],
            "help": "The limited partners backing your vehicles. Amounts are held confidentially unless you say otherwise.",
            "rowEntity": "commitment",
            "rowLabel": "{commitment_lp_name} — {commitment_fund_name}",
            "toggle": {
              "key": "nothing_to_add",
              "label": "Nothing to report"
            },
            "confidentiality": "row"
          }
        ],
        "intro": "One row per fund vehicle you have raised or manage, closed or still raising."
      },
      {
        "key": "portfolio",
        "number": 6,
        "label": "Portfolio",
        "shortLabel": "Portfolio",
        "coreTables": [
          "portfolio_investments"
        ],
        "sections": [
          {
            "key": "holdings",
            "label": "Portfolio companies",
            "kind": "repeatable",
            "tab": "portfolio",
            "order": 0,
            "fields": [],
            "layout": "cards",
            "rowEntity": "portfolio_company",
            "rowLabel": "{portfolio_company_name}",
            "toggle": {
              "key": "nothing_to_add",
              "label": "No portfolio companies to report"
            },
            "confidentiality": "row",
            "blocks": [
              {
                "key": "holding_identity",
                "label": "Company",
                "fields": [
                  {
                    "key": "portfolio_company_name",
                    "path": "portfolio.holdings.portfolio_company_name",
                    "label": "Company",
                    "input": "text",
                    "tab": "portfolio",
                    "section": "holdings",
                    "order": 0,
                    "required": "always",
                    "block": "holding_identity",
                    "coreTable": "portfolio_investments",
                    "coreField": "portfolio_company_name",
                    "dataType": "SingleLineText"
                  },
                  {
                    "key": "portfolio_company_country",
                    "path": "portfolio.holdings.portfolio_company_country",
                    "label": "Country",
                    "input": "select",
                    "tab": "portfolio",
                    "section": "holdings",
                    "order": 1,
                    "required": "never",
                    "block": "holding_identity",
                    "options": [
                      {
                        "value": "nigeria",
                        "label": "Nigeria"
                      },
                      {
                        "value": "ghana",
                        "label": "Ghana"
                      },
                      {
                        "value": "senegal",
                        "label": "Senegal"
                      },
                      {
                        "value": "cote-divoire",
                        "label": "Côte d'Ivoire"
                      },
                      {
                        "value": "mali",
                        "label": "Mali"
                      },
                      {
                        "value": "benin",
                        "label": "Benin"
                      },
                      {
                        "value": "togo",
                        "label": "Togo"
                      },
                      {
                        "value": "burkina-faso",
                        "label": "Burkina Faso"
                      },
                      {
                        "value": "sierra-leone",
                        "label": "Sierra Leone"
                      },
                      {
                        "value": "liberia",
                        "label": "Liberia"
                      },
                      {
                        "value": "guinea",
                        "label": "Guinea"
                      },
                      {
                        "value": "kenya",
                        "label": "Kenya"
                      },
                      {
                        "value": "tanzania",
                        "label": "Tanzania"
                      },
                      {
                        "value": "uganda",
                        "label": "Uganda"
                      },
                      {
                        "value": "rwanda",
                        "label": "Rwanda"
                      },
                      {
                        "value": "ethiopia",
                        "label": "Ethiopia"
                      },
                      {
                        "value": "somalia",
                        "label": "Somalia"
                      },
                      {
                        "value": "burundi",
                        "label": "Burundi"
                      },
                      {
                        "value": "south-sudan",
                        "label": "South Sudan"
                      },
                      {
                        "value": "south-africa",
                        "label": "South Africa"
                      },
                      {
                        "value": "botswana",
                        "label": "Botswana"
                      },
                      {
                        "value": "namibia",
                        "label": "Namibia"
                      },
                      {
                        "value": "zambia",
                        "label": "Zambia"
                      },
                      {
                        "value": "zimbabwe",
                        "label": "Zimbabwe"
                      },
                      {
                        "value": "mozambique",
                        "label": "Mozambique"
                      },
                      {
                        "value": "malawi",
                        "label": "Malawi"
                      },
                      {
                        "value": "mauritius",
                        "label": "Mauritius"
                      },
                      {
                        "value": "egypt",
                        "label": "Egypt"
                      },
                      {
                        "value": "morocco",
                        "label": "Morocco"
                      },
                      {
                        "value": "tunisia",
                        "label": "Tunisia"
                      },
                      {
                        "value": "algeria",
                        "label": "Algeria"
                      },
                      {
                        "value": "libya",
                        "label": "Libya"
                      },
                      {
                        "value": "sudan",
                        "label": "Sudan"
                      },
                      {
                        "value": "cameroon",
                        "label": "Cameroon"
                      },
                      {
                        "value": "drc",
                        "label": "Democratic Republic of the Congo"
                      },
                      {
                        "value": "gabon",
                        "label": "Gabon"
                      },
                      {
                        "value": "chad",
                        "label": "Chad"
                      },
                      {
                        "value": "congo",
                        "label": "Republic of the Congo"
                      },
                      {
                        "value": "united-kingdom",
                        "label": "United Kingdom"
                      },
                      {
                        "value": "united-states",
                        "label": "United States"
                      },
                      {
                        "value": "netherlands",
                        "label": "Netherlands"
                      },
                      {
                        "value": "france",
                        "label": "France"
                      },
                      {
                        "value": "united-arab-emirates",
                        "label": "United Arab Emirates"
                      },
                      {
                        "value": "mauritius-ibc",
                        "label": "Mauritius (IBC)"
                      },
                      {
                        "value": "cayman-islands",
                        "label": "Cayman Islands"
                      },
                      {
                        "value": "luxembourg",
                        "label": "Luxembourg"
                      }
                    ],
                    "taxonomy": "countries",
                    "coreTable": "portfolio_investments",
                    "coreField": "portfolio_company_country",
                    "dataType": "Links"
                  },
                  {
                    "key": "portfolio_company_sector",
                    "path": "portfolio.holdings.portfolio_company_sector",
                    "label": "Sector",
                    "input": "select",
                    "tab": "portfolio",
                    "section": "holdings",
                    "order": 2,
                    "required": "never",
                    "block": "holding_identity",
                    "options": [
                      {
                        "value": "financial-services",
                        "label": "Financial Services"
                      },
                      {
                        "value": "technology",
                        "label": "Technology"
                      },
                      {
                        "value": "consumer-goods",
                        "label": "Consumer Goods & Services"
                      },
                      {
                        "value": "healthcare",
                        "label": "Healthcare"
                      },
                      {
                        "value": "energy-utilities",
                        "label": "Energy & Utilities"
                      },
                      {
                        "value": "agriculture",
                        "label": "Agriculture"
                      },
                      {
                        "value": "industrials",
                        "label": "Industrials"
                      },
                      {
                        "value": "telecommunications",
                        "label": "Telecommunications"
                      },
                      {
                        "value": "real-estate",
                        "label": "Real Estate"
                      },
                      {
                        "value": "transport-logistics",
                        "label": "Transport & Logistics"
                      },
                      {
                        "value": "education",
                        "label": "Education"
                      },
                      {
                        "value": "media-entertainment",
                        "label": "Media & Entertainment"
                      },
                      {
                        "value": "mining-natural-resources",
                        "label": "Mining & Natural Resources"
                      },
                      {
                        "value": "construction",
                        "label": "Construction"
                      },
                      {
                        "value": "hospitality-tourism",
                        "label": "Hospitality & Tourism"
                      },
                      {
                        "value": "professional-services",
                        "label": "Professional Services"
                      }
                    ],
                    "taxonomy": "sectors",
                    "coreTable": "portfolio_investments",
                    "coreField": "portfolio_company_sector",
                    "dataType": "Links"
                  },
                  {
                    "key": "portfolio_fund_name",
                    "path": "portfolio.holdings.portfolio_fund_name",
                    "label": "Invested through fund",
                    "input": "select",
                    "tab": "portfolio",
                    "section": "holdings",
                    "order": 3,
                    "required": "never",
                    "block": "holding_identity",
                    "help": "The vehicle this investment sits in.",
                    "optionsFromRows": {
                      "tab": "funds",
                      "section": "vehicles",
                      "field": "fund_name"
                    },
                    "coreTable": "portfolio_investments",
                    "coreField": "portfolio_fund_name",
                    "dataType": "SingleLineText"
                  },
                  {
                    "key": "portfolio_co_investors",
                    "path": "portfolio.holdings.portfolio_co_investors",
                    "label": "Co-investors",
                    "input": "taglist",
                    "tab": "portfolio",
                    "section": "holdings",
                    "order": 4,
                    "required": "never",
                    "block": "holding_identity",
                    "coreTable": "portfolio_investments",
                    "coreField": "portfolio_co_investors",
                    "dataType": "Links"
                  }
                ]
              },
              {
                "key": "holding_terms",
                "label": "Holding",
                "fields": [
                  {
                    "key": "portfolio_instrument",
                    "path": "portfolio.holdings.portfolio_instrument",
                    "label": "Instrument",
                    "input": "multiselect",
                    "tab": "portfolio",
                    "section": "holdings",
                    "order": 5,
                    "required": "never",
                    "block": "holding_terms",
                    "options": [
                      {
                        "value": "equity",
                        "label": "Equity"
                      },
                      {
                        "value": "debt",
                        "label": "Debt"
                      },
                      {
                        "value": "mezzanine",
                        "label": "Mezzanine"
                      },
                      {
                        "value": "safe",
                        "label": "SAFE"
                      }
                    ],
                    "taxonomy": "gp_instruments",
                    "coreTable": "portfolio_investments",
                    "coreField": "portfolio_instrument",
                    "dataType": "Links"
                  },
                  {
                    "key": "portfolio_stage",
                    "path": "portfolio.holdings.portfolio_stage",
                    "label": "Stage at entry",
                    "input": "select",
                    "tab": "portfolio",
                    "section": "holdings",
                    "order": 6,
                    "required": "never",
                    "block": "holding_terms",
                    "options": [
                      {
                        "value": "pre-seed",
                        "label": "Pre-seed"
                      },
                      {
                        "value": "seed",
                        "label": "Seed"
                      },
                      {
                        "value": "series-a",
                        "label": "Series A"
                      },
                      {
                        "value": "series-b",
                        "label": "Series B"
                      },
                      {
                        "value": "series-c",
                        "label": "Series C"
                      },
                      {
                        "value": "series-d+",
                        "label": "Series D+"
                      },
                      {
                        "value": "growth-stage",
                        "label": "Growth Stage"
                      },
                      {
                        "value": "growth-equity",
                        "label": "Growth Equity"
                      },
                      {
                        "value": "buyout",
                        "label": "Buyout"
                      }
                    ],
                    "taxonomy": "investment_stages",
                    "coreTable": "portfolio_investments",
                    "coreField": "portfolio_stage",
                    "dataType": "Links"
                  },
                  {
                    "key": "portfolio_first_investment_date",
                    "path": "portfolio.holdings.portfolio_first_investment_date",
                    "label": "First investment date",
                    "input": "date",
                    "tab": "portfolio",
                    "section": "holdings",
                    "order": 7,
                    "required": "never",
                    "block": "holding_terms",
                    "precision": true,
                    "coreTable": "portfolio_investments",
                    "coreField": "portfolio_first_investment_date",
                    "dataType": "Date"
                  },
                  {
                    "key": "portfolio_amount_invested",
                    "path": "portfolio.holdings.portfolio_amount_invested",
                    "label": "Amount invested",
                    "input": "money",
                    "tab": "portfolio",
                    "section": "holdings",
                    "order": 8,
                    "required": "never",
                    "block": "holding_terms",
                    "undisclosed": true,
                    "coreTable": "portfolio_investments",
                    "coreField": "portfolio_amount_invested",
                    "dataType": "Currency"
                  },
                  {
                    "key": "portfolio_stake",
                    "path": "portfolio.holdings.portfolio_stake",
                    "label": "Stake held (%)",
                    "input": "percent",
                    "tab": "portfolio",
                    "section": "holdings",
                    "order": 9,
                    "required": "never",
                    "block": "holding_terms",
                    "coreTable": "portfolio_investments",
                    "coreField": "portfolio_stake",
                    "dataType": "Decimal"
                  },
                  {
                    "key": "portfolio_board_seat",
                    "path": "portfolio.holdings.portfolio_board_seat",
                    "label": "Board seat",
                    "input": "radio",
                    "tab": "portfolio",
                    "section": "holdings",
                    "order": 10,
                    "required": "never",
                    "block": "holding_terms",
                    "options": [
                      {
                        "value": "Yes",
                        "label": "Yes"
                      },
                      {
                        "value": "No",
                        "label": "No"
                      }
                    ],
                    "coreTable": "portfolio_investments",
                    "coreField": "portfolio_board_seat",
                    "dataType": "SingleSelect"
                  },
                  {
                    "key": "portfolio_status",
                    "path": "portfolio.holdings.portfolio_status",
                    "label": "Holding status",
                    "input": "select",
                    "tab": "portfolio",
                    "section": "holdings",
                    "order": 11,
                    "required": "always",
                    "block": "holding_terms",
                    "options": [
                      {
                        "value": "Current",
                        "label": "Current"
                      },
                      {
                        "value": "Partially exited",
                        "label": "Partially exited"
                      },
                      {
                        "value": "Fully exited",
                        "label": "Fully exited"
                      },
                      {
                        "value": "Written off",
                        "label": "Written off"
                      }
                    ],
                    "coreTable": "portfolio_investments",
                    "coreField": "portfolio_status",
                    "dataType": "SingleSelect"
                  },
                  {
                    "key": "portfolio_exit_date",
                    "path": "portfolio.holdings.portfolio_exit_date",
                    "label": "Exit date",
                    "input": "date",
                    "tab": "portfolio",
                    "section": "holdings",
                    "order": 12,
                    "required": "conditional",
                    "block": "holding_terms",
                    "requiredWhen": {
                      "field": "portfolio_status",
                      "in": [
                        "Partially exited",
                        "Fully exited"
                      ]
                    },
                    "visibleWhen": {
                      "field": "portfolio_status",
                      "in": [
                        "Partially exited",
                        "Fully exited",
                        "Written off"
                      ]
                    },
                    "coreTable": "portfolio_investments",
                    "coreField": "portfolio_exit_date",
                    "dataType": "Date"
                  },
                  {
                    "key": "portfolio_exit_route",
                    "path": "portfolio.holdings.portfolio_exit_route",
                    "label": "Exit route",
                    "input": "select",
                    "tab": "portfolio",
                    "section": "holdings",
                    "order": 13,
                    "required": "never",
                    "block": "holding_terms",
                    "visibleWhen": {
                      "field": "portfolio_status",
                      "in": [
                        "Partially exited",
                        "Fully exited"
                      ]
                    },
                    "options": [
                      {
                        "value": "Trade sale",
                        "label": "Trade sale"
                      },
                      {
                        "value": "Secondary sale",
                        "label": "Secondary sale"
                      },
                      {
                        "value": "Management buyout",
                        "label": "Management buyout"
                      },
                      {
                        "value": "IPO",
                        "label": "IPO"
                      },
                      {
                        "value": "Recapitalisation",
                        "label": "Recapitalisation"
                      },
                      {
                        "value": "Liquidation",
                        "label": "Liquidation"
                      },
                      {
                        "value": "Other",
                        "label": "Other"
                      }
                    ],
                    "coreTable": "portfolio_investments",
                    "coreField": "portfolio_exit_route",
                    "dataType": "SingleSelect"
                  },
                  {
                    "key": "datahub.publication_permission",
                    "path": "portfolio.holdings.datahub.publication_permission",
                    "label": "Publication permission",
                    "input": "radio",
                    "tab": "portfolio",
                    "section": "holdings",
                    "order": 14,
                    "required": "always",
                    "block": "holding_terms",
                    "options": [
                      {
                        "value": "Stears may publish",
                        "label": "Stears may publish"
                      },
                      {
                        "value": "Confidential — internal records only",
                        "label": "Confidential — internal records only"
                      }
                    ],
                    "default": "Stears may publish"
                  }
                ]
              }
            ]
          }
        ],
        "intro": "Companies you hold or have exited."
      },
      {
        "key": "transactions",
        "number": 7,
        "label": "Transactions",
        "shortLabel": "Deals",
        "coreTables": [
          "transactions_general"
        ],
        "sections": [
          {
            "key": "transactions",
            "label": "Transactions in this period",
            "kind": "repeatable",
            "tab": "transactions",
            "order": 0,
            "fields": [],
            "layout": "cards",
            "rowEntity": "transaction",
            "rowLabel": "{transaction_type} — {datahub.counterparty_summary}",
            "toggle": {
              "key": "no_transactions",
              "label": "No transactions in this period"
            },
            "confidentiality": "row",
            "blocks": [
              {
                "key": "basics",
                "label": "Basics",
                "fields": [
                  {
                    "key": "transaction_type",
                    "path": "transactions.transactions.transaction_type",
                    "label": "Transaction type",
                    "input": "select",
                    "tab": "transactions",
                    "section": "transactions",
                    "order": 0,
                    "required": "always",
                    "block": "basics",
                    "options": [
                      {
                        "value": "Investment",
                        "label": "Investment"
                      },
                      {
                        "value": "Merger/Acquisition (M&A)",
                        "label": "Merger/Acquisition (M&A)"
                      },
                      {
                        "value": "Debt Financing",
                        "label": "Debt Financing"
                      },
                      {
                        "value": "Project Financing",
                        "label": "Project Financing"
                      },
                      {
                        "value": "Exit",
                        "label": "Exit"
                      }
                    ],
                    "coreTable": "transactions_general",
                    "coreField": "transaction_type",
                    "dataType": "MultiSelect"
                  },
                  {
                    "key": "deal_status",
                    "path": "transactions.transactions.deal_status",
                    "label": "Deal status",
                    "input": "select",
                    "tab": "transactions",
                    "section": "transactions",
                    "order": 1,
                    "required": "always",
                    "block": "basics",
                    "options": [
                      {
                        "value": "Announced",
                        "label": "Announced"
                      },
                      {
                        "value": "Announced – Pending Regulatory Approval",
                        "label": "Announced – Pending Regulatory Approval"
                      },
                      {
                        "value": "Announced – Pending Investment Committee/Board Approval",
                        "label": "Announced – Pending Investment Committee/Board Approval"
                      },
                      {
                        "value": "Approved",
                        "label": "Approved"
                      },
                      {
                        "value": "Closed",
                        "label": "Closed"
                      },
                      {
                        "value": "Terminated",
                        "label": "Terminated"
                      }
                    ],
                    "coreTable": "transactions_general",
                    "coreField": "deal_status",
                    "dataType": "MultiSelect"
                  },
                  {
                    "key": "announcement_date",
                    "path": "transactions.transactions.announcement_date",
                    "label": "Announcement date",
                    "input": "date",
                    "tab": "transactions",
                    "section": "transactions",
                    "order": 2,
                    "required": "always",
                    "block": "basics",
                    "precision": true,
                    "coreTable": "transactions_general",
                    "coreField": "announcement_date",
                    "dataType": "Date"
                  },
                  {
                    "key": "completion_date",
                    "path": "transactions.transactions.completion_date",
                    "label": "Completion date",
                    "input": "date",
                    "tab": "transactions",
                    "section": "transactions",
                    "order": 3,
                    "required": "conditional",
                    "block": "basics",
                    "requiredWhen": {
                      "field": "deal_status",
                      "eq": "Closed"
                    },
                    "visibleWhen": {
                      "field": "deal_status",
                      "eq": "Closed"
                    },
                    "precision": true,
                    "coreTable": "transactions_general",
                    "coreField": "completion_date",
                    "dataType": "Date"
                  },
                  {
                    "key": "datahub.publication_permission",
                    "path": "transactions.transactions.datahub.publication_permission",
                    "label": "Publication permission",
                    "input": "radio",
                    "tab": "transactions",
                    "section": "transactions",
                    "order": 4,
                    "required": "always",
                    "block": "basics",
                    "options": [
                      {
                        "value": "Stears may publish",
                        "label": "Stears may publish"
                      },
                      {
                        "value": "Confidential — internal records only",
                        "label": "Confidential — internal records only"
                      }
                    ],
                    "default": "Stears may publish"
                  }
                ]
              },
              {
                "key": "parties",
                "label": "Parties",
                "fields": [
                  {
                    "key": "datahub.target_company",
                    "path": "transactions.transactions.datahub.target_company",
                    "label": "Company involved",
                    "input": "text",
                    "tab": "transactions",
                    "section": "transactions",
                    "order": 5,
                    "required": "always",
                    "block": "parties"
                  },
                  {
                    "key": "participating_fund",
                    "path": "transactions.transactions.participating_fund",
                    "label": "Your fund vehicles involved",
                    "input": "multiselect",
                    "tab": "transactions",
                    "section": "transactions",
                    "order": 6,
                    "required": "never",
                    "block": "parties",
                    "help": "Choose from the vehicles on your Funds tab.",
                    "optionsFromRows": {
                      "tab": "funds",
                      "section": "vehicles",
                      "field": "fund_name"
                    },
                    "coreTable": "transactions_general",
                    "coreField": "participating_fund",
                    "dataType": "Links"
                  },
                  {
                    "key": "datahub.investors",
                    "path": "transactions.transactions.datahub.investors",
                    "label": "Other investors, buyers or lenders",
                    "input": "partylist",
                    "tab": "transactions",
                    "section": "transactions",
                    "order": 7,
                    "required": "never",
                    "block": "parties",
                    "roles": [
                      "Lead investor",
                      "Participant",
                      "Acquirer",
                      "Lender",
                      "Sponsor"
                    ]
                  },
                  {
                    "key": "sellers",
                    "path": "transactions.transactions.sellers",
                    "label": "Sellers",
                    "input": "taglist",
                    "tab": "transactions",
                    "section": "transactions",
                    "order": 8,
                    "required": "never",
                    "block": "parties",
                    "visibleWhen": {
                      "field": "transaction_type",
                      "in": [
                        "Merger/Acquisition (M&A)",
                        "Exit"
                      ]
                    },
                    "coreTable": "transactions_general",
                    "coreField": "sellers",
                    "dataType": "Links"
                  }
                ]
              },
              {
                "key": "structure",
                "label": "Structure and value",
                "fields": [
                  {
                    "key": "financing_instrument",
                    "path": "transactions.transactions.financing_instrument",
                    "label": "Financing instruments",
                    "input": "multiselect",
                    "tab": "transactions",
                    "section": "transactions",
                    "order": 9,
                    "required": "always",
                    "block": "structure",
                    "options": [
                      {
                        "value": "Ordinary Shares (Equity)",
                        "label": "Ordinary Shares (Equity)"
                      },
                      {
                        "value": "Preference Shares (Equity)",
                        "label": "Preference Shares (Equity)"
                      },
                      {
                        "value": "Warrants (Equity)",
                        "label": "Warrants (Equity)"
                      },
                      {
                        "value": "Simple Agreement for Future Equity (SAFE) (Equity)",
                        "label": "Simple Agreement for Future Equity (SAFE) (Equity)"
                      },
                      {
                        "value": "Options",
                        "label": "Options"
                      },
                      {
                        "value": "Equity",
                        "label": "Equity"
                      },
                      {
                        "value": "Senior Debt",
                        "label": "Senior Debt"
                      },
                      {
                        "value": "Mezzanine Debt",
                        "label": "Mezzanine Debt"
                      },
                      {
                        "value": "Subordinated Debt",
                        "label": "Subordinated Debt"
                      },
                      {
                        "value": "Junior Debt",
                        "label": "Junior Debt"
                      },
                      {
                        "value": "Shareholder Loans",
                        "label": "Shareholder Loans"
                      },
                      {
                        "value": "Payment-in-Kind (PIK) Note",
                        "label": "Payment-in-Kind (PIK) Note"
                      },
                      {
                        "value": "Convertible Securities (Debt)",
                        "label": "Convertible Securities (Debt)"
                      },
                      {
                        "value": "Term Loan",
                        "label": "Term Loan"
                      },
                      {
                        "value": "Working Capital Loan",
                        "label": "Working Capital Loan"
                      },
                      {
                        "value": "Revolving Credit Facility",
                        "label": "Revolving Credit Facility"
                      },
                      {
                        "value": "Syndicated Loan",
                        "label": "Syndicated Loan"
                      },
                      {
                        "value": "Trade Finance",
                        "label": "Trade Finance"
                      },
                      {
                        "value": "Private Capital (Debt)",
                        "label": "Private Capital (Debt)"
                      },
                      {
                        "value": "Debt",
                        "label": "Debt"
                      },
                      {
                        "value": "Grant",
                        "label": "Grant"
                      },
                      {
                        "value": "Guarantee",
                        "label": "Guarantee"
                      }
                    ],
                    "coreTable": "transactions_general",
                    "coreField": "financing_instrument",
                    "dataType": "MultiSelect"
                  },
                  {
                    "key": "datahub.currency",
                    "path": "transactions.transactions.datahub.currency",
                    "label": "Currency",
                    "input": "select",
                    "tab": "transactions",
                    "section": "transactions",
                    "order": 10,
                    "required": "conditional",
                    "block": "structure",
                    "requiredWhen": {
                      "anyAmountPresent": true
                    },
                    "options": [
                      {
                        "value": "USD",
                        "label": "USD"
                      },
                      {
                        "value": "NGN",
                        "label": "NGN"
                      },
                      {
                        "value": "ZAR",
                        "label": "ZAR"
                      },
                      {
                        "value": "KES",
                        "label": "KES"
                      },
                      {
                        "value": "GHS",
                        "label": "GHS"
                      },
                      {
                        "value": "EGP",
                        "label": "EGP"
                      },
                      {
                        "value": "MAD",
                        "label": "MAD"
                      },
                      {
                        "value": "TZS",
                        "label": "TZS"
                      },
                      {
                        "value": "UGX",
                        "label": "UGX"
                      },
                      {
                        "value": "RWF",
                        "label": "RWF"
                      },
                      {
                        "value": "XOF",
                        "label": "XOF"
                      },
                      {
                        "value": "XAF",
                        "label": "XAF"
                      },
                      {
                        "value": "ZMW",
                        "label": "ZMW"
                      },
                      {
                        "value": "MUR",
                        "label": "MUR"
                      },
                      {
                        "value": "EUR",
                        "label": "EUR"
                      },
                      {
                        "value": "GBP",
                        "label": "GBP"
                      }
                    ],
                    "taxonomy": "currencies"
                  },
                  {
                    "key": "total_deal_amount",
                    "path": "transactions.transactions.total_deal_amount",
                    "label": "Total deal amount",
                    "input": "money",
                    "tab": "transactions",
                    "section": "transactions",
                    "order": 11,
                    "required": "never",
                    "block": "structure",
                    "undisclosed": true,
                    "coreTable": "transactions_general",
                    "coreField": "total_deal_amount",
                    "dataType": "Decimal"
                  },
                  {
                    "key": "equity_stake",
                    "path": "transactions.transactions.equity_stake",
                    "label": "Equity stake acquired",
                    "input": "percent",
                    "tab": "transactions",
                    "section": "transactions",
                    "order": 12,
                    "required": "never",
                    "block": "structure",
                    "undisclosed": true,
                    "coreTable": "transactions_general",
                    "coreField": "equity_stake",
                    "dataType": "Decimal"
                  },
                  {
                    "key": "investment_type_stage",
                    "path": "transactions.transactions.investment_type_stage",
                    "label": "Investment stage",
                    "input": "select",
                    "tab": "transactions",
                    "section": "transactions",
                    "order": 13,
                    "required": "never",
                    "block": "structure",
                    "visibleWhen": {
                      "field": "transaction_type",
                      "eq": "Investment"
                    },
                    "options": [
                      {
                        "value": "Pre-Seed",
                        "label": "Pre-Seed"
                      },
                      {
                        "value": "Seed",
                        "label": "Seed"
                      },
                      {
                        "value": "Seed Extension / Pre-Series A",
                        "label": "Seed Extension / Pre-Series A"
                      },
                      {
                        "value": "Series A",
                        "label": "Series A"
                      },
                      {
                        "value": "Series A Extension / Pre-Series B",
                        "label": "Series A Extension / Pre-Series B"
                      },
                      {
                        "value": "Series B",
                        "label": "Series B"
                      },
                      {
                        "value": "Series B Extension / Pre-Series C",
                        "label": "Series B Extension / Pre-Series C"
                      },
                      {
                        "value": "Series C+",
                        "label": "Series C+"
                      },
                      {
                        "value": "Bridge Round",
                        "label": "Bridge Round"
                      },
                      {
                        "value": "Growth Capital",
                        "label": "Growth Capital"
                      }
                    ],
                    "coreTable": "transactions_general",
                    "coreField": "investment_type_stage",
                    "dataType": "SingleSelect"
                  },
                  {
                    "key": "datahub.was_lead_investor",
                    "path": "transactions.transactions.datahub.was_lead_investor",
                    "label": "Were you the lead investor?",
                    "input": "radio",
                    "tab": "transactions",
                    "section": "transactions",
                    "order": 14,
                    "required": "never",
                    "block": "structure",
                    "options": [
                      {
                        "value": "Yes",
                        "label": "Yes"
                      },
                      {
                        "value": "No",
                        "label": "No"
                      }
                    ]
                  }
                ]
              },
              {
                "key": "exit",
                "label": "Exit details",
                "visibleWhen": {
                  "field": "transaction_type",
                  "eq": "Exit"
                },
                "fields": [
                  {
                    "key": "exit_date",
                    "path": "transactions.transactions.exit_date",
                    "label": "Exit date",
                    "input": "date",
                    "tab": "transactions",
                    "section": "transactions",
                    "order": 15,
                    "required": "always",
                    "block": "exit",
                    "coreTable": "transactions_general",
                    "coreField": "exit_date",
                    "dataType": "Date"
                  },
                  {
                    "key": "exit_strategy",
                    "path": "transactions.transactions.exit_strategy",
                    "label": "Exit strategy",
                    "input": "multiselect",
                    "tab": "transactions",
                    "section": "transactions",
                    "order": 16,
                    "required": "always",
                    "block": "exit",
                    "options": [
                      {
                        "value": "Trade Sale",
                        "label": "Trade Sale"
                      },
                      {
                        "value": "Secondary Sale",
                        "label": "Secondary Sale"
                      },
                      {
                        "value": "Initial Public Offering (IPO)",
                        "label": "Initial Public Offering (IPO)"
                      },
                      {
                        "value": "Buyback",
                        "label": "Buyback"
                      },
                      {
                        "value": "Merger",
                        "label": "Merger"
                      },
                      {
                        "value": "Reverse Merger",
                        "label": "Reverse Merger"
                      },
                      {
                        "value": "Special Purpose Acquisition Company (SPAC)",
                        "label": "Special Purpose Acquisition Company (SPAC)"
                      },
                      {
                        "value": "Management Buyout (MBO) / Employee Buyout",
                        "label": "Management Buyout (MBO) / Employee Buyout"
                      },
                      {
                        "value": "Write-off / Liquidation",
                        "label": "Write-off / Liquidation"
                      },
                      {
                        "value": "Other",
                        "label": "Other"
                      },
                      {
                        "value": "Unspecified",
                        "label": "Unspecified"
                      }
                    ],
                    "coreTable": "transactions_general",
                    "coreField": "exit_strategy",
                    "dataType": "MultiSelect"
                  },
                  {
                    "key": "partial_full_exit",
                    "path": "transactions.transactions.partial_full_exit",
                    "label": "Partial or full exit",
                    "input": "select",
                    "tab": "transactions",
                    "section": "transactions",
                    "order": 17,
                    "required": "always",
                    "block": "exit",
                    "options": [
                      {
                        "value": "Full Exit",
                        "label": "Full Exit"
                      },
                      {
                        "value": "Partial Exit",
                        "label": "Partial Exit"
                      },
                      {
                        "value": "No",
                        "label": "No"
                      },
                      {
                        "value": "Unspecified",
                        "label": "Unspecified"
                      }
                    ],
                    "coreTable": "transactions_general",
                    "coreField": "partial_full_exit",
                    "dataType": "MultiSelect"
                  },
                  {
                    "key": "stake_sold",
                    "path": "transactions.transactions.stake_sold",
                    "label": "Stake sold",
                    "input": "percent",
                    "tab": "transactions",
                    "section": "transactions",
                    "order": 18,
                    "required": "never",
                    "block": "exit",
                    "coreTable": "transactions_general",
                    "coreField": "stake_sold",
                    "dataType": "Percent"
                  },
                  {
                    "key": "exit_proceeds",
                    "path": "transactions.transactions.exit_proceeds",
                    "label": "Exit proceeds",
                    "input": "money",
                    "tab": "transactions",
                    "section": "transactions",
                    "order": 19,
                    "required": "never",
                    "block": "exit",
                    "undisclosed": true,
                    "coreTable": "transactions_general",
                    "coreField": "exit_proceeds",
                    "dataType": "Decimal"
                  },
                  {
                    "key": "initial_investment",
                    "path": "transactions.transactions.initial_investment",
                    "label": "Initial investment amount",
                    "input": "money",
                    "tab": "transactions",
                    "section": "transactions",
                    "order": 20,
                    "required": "never",
                    "block": "exit",
                    "undisclosed": true,
                    "coreTable": "transactions_general",
                    "coreField": "initial_investment",
                    "dataType": "Number"
                  }
                ]
              },
              {
                "key": "narrative",
                "label": "Narrative",
                "fields": [
                  {
                    "key": "transaction_summary",
                    "path": "transactions.transactions.transaction_summary",
                    "label": "Transaction summary",
                    "input": "longtext",
                    "tab": "transactions",
                    "section": "transactions",
                    "order": 21,
                    "required": "never",
                    "block": "narrative",
                    "help": "In your own words. Stears analysts may rewrite this for the platform.",
                    "coreTable": "transactions_general",
                    "coreField": "transaction_summary",
                    "dataType": "LongText"
                  },
                  {
                    "key": "announcement_link",
                    "path": "transactions.transactions.announcement_link",
                    "label": "Announcement link",
                    "input": "url",
                    "tab": "transactions",
                    "section": "transactions",
                    "order": 22,
                    "required": "never",
                    "block": "narrative",
                    "help": "A press release, filing or credible article.",
                    "coreTable": "transactions_general",
                    "coreField": "announcement_link",
                    "dataType": "URL"
                  },
                  {
                    "key": "datahub.notes",
                    "path": "transactions.transactions.datahub.notes",
                    "label": "Notes to Stears",
                    "input": "longtext",
                    "tab": "transactions",
                    "section": "transactions",
                    "order": 23,
                    "required": "never",
                    "block": "narrative",
                    "help": "Never published."
                  }
                ]
              }
            ]
          }
        ],
        "intro": "Investments, exits and other deals your firm took part in. Confirm each one, correct it, or remove it if it is not yours."
      },
      {
        "key": "awards",
        "number": 8,
        "label": "Awards",
        "shortLabel": "Awards",
        "coreTables": [
          "investors_general"
        ],
        "sections": [
          {
            "key": "nomination",
            "label": "Your nomination",
            "kind": "fields",
            "tab": "awards",
            "order": 0,
            "fields": [
              {
                "key": "datahub.nominated_categories",
                "path": "awards.nomination.datahub.nominated_categories",
                "label": "Nominated categories",
                "input": "taglist",
                "tab": "awards",
                "section": "nomination",
                "order": 0,
                "required": "never",
                "readOnlyExisting": true
              },
              {
                "key": "datahub.nominated_region",
                "path": "awards.nomination.datahub.nominated_region",
                "label": "Region we assigned",
                "input": "text",
                "tab": "awards",
                "section": "nomination",
                "order": 1,
                "required": "never",
                "readOnlyExisting": true
              }
            ]
          },
          {
            "key": "firm",
            "label": "Firm facts we use",
            "kind": "fields",
            "tab": "awards",
            "order": 1,
            "fields": [
              {
                "key": "founding_year",
                "path": "awards.firm.founding_year",
                "label": "Year founded",
                "input": "year",
                "tab": "awards",
                "section": "firm",
                "order": 0,
                "required": "always",
                "help": "The year the management company was founded.",
                "coreTable": "investors_general",
                "coreField": "founding_year",
                "dataType": "Number"
              },
              {
                "key": "investor_type",
                "path": "awards.firm.investor_type",
                "label": "Investor type",
                "input": "multiselect",
                "tab": "awards",
                "section": "firm",
                "order": 1,
                "required": "always",
                "options": [
                  {
                    "value": "venture-capital",
                    "label": "Venture Capital"
                  },
                  {
                    "value": "private-equity",
                    "label": "Private Equity"
                  },
                  {
                    "value": "high-net-worth-individuals",
                    "label": "High Net-Worth Individuals (HNIs)"
                  },
                  {
                    "value": "development-finance-institution",
                    "label": "Development Finance Institution"
                  },
                  {
                    "value": "corporate-venture-capital",
                    "label": "Corporate Venture Capital"
                  },
                  {
                    "value": "angel-network",
                    "label": "Angel Network"
                  },
                  {
                    "value": "sovereign-wealth-fund",
                    "label": "Sovereign Wealth Fund"
                  },
                  {
                    "value": "family-office",
                    "label": "Family Office"
                  },
                  {
                    "value": "private-credit",
                    "label": "Private Credit"
                  },
                  {
                    "value": "corporate-strategic-investor",
                    "label": "Corporate Strategic Investor"
                  }
                ],
                "taxonomy": "gp_investor_types",
                "coreTable": "investors_general",
                "coreField": "investor_type",
                "dataType": "MultiSelect"
              }
            ]
          },
          {
            "key": "challenge",
            "label": "Category or region",
            "kind": "fields",
            "tab": "awards",
            "order": 2,
            "fields": [
              {
                "key": "datahub.category_challenge",
                "path": "awards.challenge.datahub.category_challenge",
                "label": "Is each category right?",
                "input": "radio",
                "tab": "awards",
                "section": "challenge",
                "order": 0,
                "required": "always",
                "options": [
                  {
                    "value": "Yes",
                    "label": "Yes"
                  },
                  {
                    "value": "No, I want to challenge a category",
                    "label": "No, I want to challenge a category"
                  }
                ],
                "default": "Yes"
              },
              {
                "key": "datahub.category_challenge_reason",
                "path": "awards.challenge.datahub.category_challenge_reason",
                "label": "Which category and why",
                "input": "longtext",
                "tab": "awards",
                "section": "challenge",
                "order": 1,
                "required": "conditional",
                "requiredWhen": {
                  "field": "datahub.category_challenge",
                  "eq": "No, I want to challenge a category"
                },
                "visibleWhen": {
                  "field": "datahub.category_challenge",
                  "eq": "No, I want to challenge a category"
                },
                "maxLength": 2000
              },
              {
                "key": "datahub.region_challenge",
                "path": "awards.challenge.datahub.region_challenge",
                "label": "Is the region right?",
                "input": "radio",
                "tab": "awards",
                "section": "challenge",
                "order": 2,
                "required": "always",
                "options": [
                  {
                    "value": "Yes",
                    "label": "Yes"
                  },
                  {
                    "value": "No, I want to challenge the region",
                    "label": "No, I want to challenge the region"
                  }
                ],
                "default": "Yes"
              },
              {
                "key": "datahub.region_challenge_reason",
                "path": "awards.challenge.datahub.region_challenge_reason",
                "label": "Which region and why",
                "input": "longtext",
                "tab": "awards",
                "section": "challenge",
                "order": 3,
                "required": "conditional",
                "requiredWhen": {
                  "field": "datahub.region_challenge",
                  "eq": "No, I want to challenge the region"
                },
                "visibleWhen": {
                  "field": "datahub.region_challenge",
                  "eq": "No, I want to challenge the region"
                },
                "maxLength": 2000
              }
            ]
          },
          {
            "key": "contact",
            "label": "Awards contact",
            "kind": "fields",
            "tab": "awards",
            "order": 3,
            "fields": [
              {
                "key": "datahub.full_name",
                "path": "awards.contact.datahub.full_name",
                "label": "Name",
                "input": "text",
                "tab": "awards",
                "section": "contact",
                "order": 0,
                "required": "always"
              },
              {
                "key": "datahub.email",
                "path": "awards.contact.datahub.email",
                "label": "Email",
                "input": "email",
                "tab": "awards",
                "section": "contact",
                "order": 1,
                "required": "always"
              },
              {
                "key": "datahub.role_title",
                "path": "awards.contact.datahub.role_title",
                "label": "Role",
                "input": "text",
                "tab": "awards",
                "section": "contact",
                "order": 2,
                "required": "always"
              }
            ]
          },
          {
            "key": "exit",
            "label": "Exit of the Year",
            "kind": "fields",
            "tab": "awards",
            "order": 4,
            "fields": [
              {
                "key": "datahub.exit_nominee",
                "path": "awards.exit.datahub.exit_nominee",
                "label": "Nominated for Exit of the Year",
                "input": "checkbox",
                "tab": "awards",
                "section": "exit",
                "order": 0,
                "required": "never",
                "help": "Stears ticks this for the firms on the Exit of the Year long list. Leave it unticked if your firm is not one of them."
              },
              {
                "key": "datahub.exit_details",
                "path": "awards.exit.datahub.exit_details",
                "label": "The exit we hold",
                "input": "text",
                "tab": "awards",
                "section": "exit",
                "order": 1,
                "required": "never",
                "visibleWhen": {
                  "field": "datahub.exit_nominee",
                  "eq": true
                },
                "help": "Target, month, buyer and the value as announced. Tell us below if any part is wrong."
              },
              {
                "key": "datahub.exit_sold",
                "path": "awards.exit.datahub.exit_sold",
                "label": "Did your fund sell in this transaction?",
                "input": "radio",
                "tab": "awards",
                "section": "exit",
                "order": 2,
                "required": "conditional",
                "requiredWhen": {
                  "field": "datahub.exit_nominee",
                  "eq": true
                },
                "visibleWhen": {
                  "field": "datahub.exit_nominee",
                  "eq": true
                },
                "options": [
                  {
                    "value": "Yes",
                    "label": "Yes"
                  },
                  {
                    "value": "No",
                    "label": "No"
                  }
                ]
              },
              {
                "key": "datahub.exit_vehicle",
                "path": "awards.exit.datahub.exit_vehicle",
                "label": "Fund vehicle that sold",
                "input": "text",
                "tab": "awards",
                "section": "exit",
                "order": 3,
                "required": "conditional",
                "requiredWhen": {
                  "field": "datahub.exit_sold",
                  "eq": "Yes"
                },
                "visibleWhen": {
                  "field": "datahub.exit_sold",
                  "eq": "Yes"
                }
              },
              {
                "key": "datahub.exit_stake_pct",
                "path": "awards.exit.datahub.exit_stake_pct",
                "label": "Stake sold (%)",
                "input": "percent",
                "tab": "awards",
                "section": "exit",
                "order": 4,
                "required": "conditional",
                "requiredWhen": {
                  "field": "datahub.exit_sold",
                  "eq": "Yes"
                },
                "visibleWhen": {
                  "field": "datahub.exit_sold",
                  "eq": "Yes"
                },
                "help": "The share of the company your fund sold. Not published."
              },
              {
                "key": "datahub.exit_proceeds_usd",
                "path": "awards.exit.datahub.exit_proceeds_usd",
                "label": "Proceeds to your fund (USD)",
                "input": "money",
                "tab": "awards",
                "section": "exit",
                "order": 5,
                "required": "never",
                "visibleWhen": {
                  "field": "datahub.exit_sold",
                  "eq": "Yes"
                },
                "help": "Optional. Used only to assess the award; never published or shown on your profile.",
                "confidential": "always"
              },
              {
                "key": "datahub.exit_moic",
                "path": "awards.exit.datahub.exit_moic",
                "label": "Gross multiple (MOIC)",
                "input": "number",
                "tab": "awards",
                "section": "exit",
                "order": 6,
                "required": "never",
                "visibleWhen": {
                  "field": "datahub.exit_sold",
                  "eq": "Yes"
                },
                "help": "Optional. Used only to assess the award; never published or shown on your profile.",
                "step": 0.1,
                "confidential": "always"
              },
              {
                "key": "datahub.exit_first_investment_year",
                "path": "awards.exit.datahub.exit_first_investment_year",
                "label": "Year of first investment",
                "input": "year",
                "tab": "awards",
                "section": "exit",
                "order": 7,
                "required": "never",
                "visibleWhen": {
                  "field": "datahub.exit_sold",
                  "eq": "Yes"
                }
              },
              {
                "key": "datahub.exit_role",
                "path": "awards.exit.datahub.exit_role",
                "label": "Your role in the exit (lead seller or co-seller, and anything we should know)",
                "input": "longtext",
                "tab": "awards",
                "section": "exit",
                "order": 8,
                "required": "conditional",
                "requiredWhen": {
                  "field": "datahub.exit_nominee",
                  "eq": true
                },
                "visibleWhen": {
                  "field": "datahub.exit_nominee",
                  "eq": true
                },
                "maxLength": 2000
              }
            ]
          },
          {
            "key": "female",
            "label": "Best Female Fund Manager",
            "kind": "fields",
            "tab": "awards",
            "order": 5,
            "fields": [
              {
                "key": "datahub.female_nominee",
                "path": "awards.female.datahub.female_nominee",
                "label": "A member of your team is nominated for Best Female Fund Manager",
                "input": "checkbox",
                "tab": "awards",
                "section": "female",
                "order": 0,
                "required": "never",
                "help": "Stears ticks this and names the nominee for the firms on the Best Female Fund Manager long list. Leave it unticked if nobody at your firm was named."
              },
              {
                "key": "datahub.female_name",
                "path": "awards.female.datahub.female_name",
                "label": "Nominee",
                "input": "text",
                "tab": "awards",
                "section": "female",
                "order": 1,
                "required": "never",
                "visibleWhen": {
                  "field": "datahub.female_nominee",
                  "eq": true
                }
              },
              {
                "key": "datahub.female_title",
                "path": "awards.female.datahub.female_title",
                "label": "Current title",
                "input": "text",
                "tab": "awards",
                "section": "female",
                "order": 2,
                "required": "conditional",
                "requiredWhen": {
                  "field": "datahub.female_nominee",
                  "eq": true
                },
                "visibleWhen": {
                  "field": "datahub.female_nominee",
                  "eq": true
                }
              },
              {
                "key": "datahub.female_start_date",
                "path": "awards.female.datahub.female_start_date",
                "label": "Start date in this role",
                "input": "date",
                "tab": "awards",
                "section": "female",
                "order": 3,
                "required": "conditional",
                "requiredWhen": {
                  "field": "datahub.female_nominee",
                  "eq": true
                },
                "visibleWhen": {
                  "field": "datahub.female_nominee",
                  "eq": true
                },
                "precision": true
              },
              {
                "key": "datahub.female_ic_seat",
                "path": "awards.female.datahub.female_ic_seat",
                "label": "Does the nominee sit on the investment committee?",
                "input": "radio",
                "tab": "awards",
                "section": "female",
                "order": 4,
                "required": "conditional",
                "requiredWhen": {
                  "field": "datahub.female_nominee",
                  "eq": true
                },
                "visibleWhen": {
                  "field": "datahub.female_nominee",
                  "eq": true
                },
                "options": [
                  {
                    "value": "Yes",
                    "label": "Yes"
                  },
                  {
                    "value": "No",
                    "label": "No"
                  }
                ]
              },
              {
                "key": "datahub.female_deals_led",
                "path": "awards.female.datahub.female_deals_led",
                "label": "Deals in the period the nominee led or sits on the board for",
                "input": "longtext",
                "tab": "awards",
                "section": "female",
                "order": 5,
                "required": "conditional",
                "requiredWhen": {
                  "field": "datahub.female_nominee",
                  "eq": true
                },
                "visibleWhen": {
                  "field": "datahub.female_nominee",
                  "eq": true
                },
                "help": "We listed the firm's deals in the period. Keep the ones she led or where she holds the board seat, and remove the rest.",
                "maxLength": 4000
              },
              {
                "key": "datahub.female_funds_raised",
                "path": "awards.female.datahub.female_funds_raised",
                "label": "Funds raised or co-led in the period",
                "input": "longtext",
                "tab": "awards",
                "section": "female",
                "order": 6,
                "required": "never",
                "visibleWhen": {
                  "field": "datahub.female_nominee",
                  "eq": true
                },
                "maxLength": 2000
              },
              {
                "key": "datahub.female_bio",
                "path": "awards.female.datahub.female_bio",
                "label": "Short bio (up to 100 words)",
                "input": "longtext",
                "tab": "awards",
                "section": "female",
                "order": 7,
                "required": "never",
                "visibleWhen": {
                  "field": "datahub.female_nominee",
                  "eq": true
                },
                "maxLength": 800
              },
              {
                "key": "datahub.female_consent",
                "path": "awards.female.datahub.female_consent",
                "label": "May we name the nominee publicly as a nominee?",
                "input": "radio",
                "tab": "awards",
                "section": "female",
                "order": 8,
                "required": "conditional",
                "requiredWhen": {
                  "field": "datahub.female_nominee",
                  "eq": true
                },
                "visibleWhen": {
                  "field": "datahub.female_nominee",
                  "eq": true
                },
                "options": [
                  {
                    "value": "Yes",
                    "label": "Yes"
                  },
                  {
                    "value": "No",
                    "label": "No"
                  }
                ]
              }
            ]
          }
        ],
        "intro": "Stears is the data partner for the SuperReturn Africa Awards 2026. This tab shows the categories your firm is nominated for. Confirm the two firm facts we use, and tell us if you think a category or region is wrong. If your firm is nominated for Exit of the Year, or a member of your team for Best Female Fund Manager, the sections below ask about that.",
        "onlyWhenRequested": true
      },
      {
        "key": "documents",
        "number": 9,
        "label": "Documents",
        "shortLabel": "Documents",
        "coreTables": [],
        "sections": [
          {
            "key": "documents",
            "label": "Supporting documents",
            "kind": "uploads",
            "tab": "documents",
            "order": 0,
            "fields": [],
            "toggle": {
              "key": "nothing_to_add",
              "label": "No documents to upload"
            }
          }
        ],
        "intro": "Optional. Fund factsheets, impact reports, tear sheets or anything that supports your submission. Files are private to Stears."
      },
      {
        "key": "review",
        "number": 10,
        "label": "Review and submit",
        "shortLabel": "Review",
        "coreTables": [],
        "sections": [
          {
            "key": "review",
            "label": "Review",
            "kind": "review",
            "tab": "review",
            "order": 0,
            "fields": []
          }
        ]
      }
    ]
  },
  {
    "key": "lp",
    "label": "Limited partner (LP)",
    "entityType": "lp",
    "tabs": [
      {
        "key": "general",
        "number": 1,
        "label": "Institution profile",
        "shortLabel": "Profile",
        "coreTables": [
          "limited_partners_general"
        ],
        "sections": [
          {
            "key": "identity",
            "label": "Corporate Data",
            "kind": "fields",
            "tab": "general",
            "order": 0,
            "fields": [
              {
                "key": "lp_name",
                "path": "general.identity.lp_name",
                "label": "Institution name",
                "input": "text",
                "tab": "general",
                "section": "identity",
                "order": 0,
                "required": "always",
                "help": "The registered name",
                "coreTable": "limited_partners_general",
                "coreField": "lp_name",
                "dataType": "SingleLineText"
              },
              {
                "key": "datahub.brand_names",
                "path": "general.identity.datahub.brand_names",
                "label": "Brand or trading names",
                "input": "taglist",
                "tab": "general",
                "section": "identity",
                "order": 1,
                "required": "never"
              },
              {
                "key": "alias_former_names",
                "path": "general.identity.alias_former_names",
                "label": "Former names",
                "input": "taglist",
                "tab": "general",
                "section": "identity",
                "order": 2,
                "required": "never",
                "help": "Previous registered or trading names.",
                "coreTable": "limited_partners_general",
                "coreField": "alias_former_names",
                "dataType": "Links"
              },
              {
                "key": "description",
                "path": "general.identity.description",
                "label": "Description",
                "input": "longtext",
                "tab": "general",
                "section": "identity",
                "order": 3,
                "required": "always",
                "help": "Who you are, the capital you deploy and the role you play as an investor. Neutral and factual, present tense.",
                "maxLength": 2000,
                "coreTable": "limited_partners_general",
                "coreField": "description",
                "dataType": "LongText"
              },
              {
                "key": "website_url",
                "path": "general.identity.website_url",
                "label": "Website",
                "input": "url",
                "tab": "general",
                "section": "identity",
                "order": 4,
                "required": "always",
                "coreTable": "limited_partners_general",
                "coreField": "website_url",
                "dataType": "URL"
              },
              {
                "key": "founding_year",
                "path": "general.identity.founding_year",
                "label": "Year founded",
                "input": "year",
                "tab": "general",
                "section": "identity",
                "order": 5,
                "required": "never",
                "coreTable": "limited_partners_general",
                "coreField": "founding_year",
                "dataType": "Number"
              },
              {
                "key": "lp_type",
                "path": "general.identity.lp_type",
                "label": "LP type",
                "input": "multiselect",
                "tab": "general",
                "section": "identity",
                "order": 6,
                "required": "always",
                "help": "Select every type that describes your institution.",
                "options": [
                  {
                    "value": "asset-manager",
                    "label": "Asset Manager"
                  },
                  {
                    "value": "corporate-investor",
                    "label": "Corporate Investor"
                  },
                  {
                    "value": "development-finance-institution",
                    "label": "Development Finance Institution"
                  },
                  {
                    "value": "family-office",
                    "label": "Family Office"
                  },
                  {
                    "value": "foundation-endowment",
                    "label": "Foundation/Endowment"
                  },
                  {
                    "value": "fund-of-funds",
                    "label": "Fund of Funds"
                  },
                  {
                    "value": "insurance-company",
                    "label": "Insurance Company"
                  },
                  {
                    "value": "investment-bank",
                    "label": "Investment Bank"
                  },
                  {
                    "value": "pension-fund",
                    "label": "Pension Fund"
                  },
                  {
                    "value": "sovereign-wealth-fund",
                    "label": "Sovereign Wealth Fund"
                  },
                  {
                    "value": "high-net-worth-individuals",
                    "label": "High Net-Worth Individuals (HNIs)"
                  }
                ],
                "taxonomy": "lp_types",
                "coreTable": "limited_partners_general",
                "coreField": "lp_type",
                "dataType": "MultiSelect"
              },
              {
                "key": "legal_structure",
                "path": "general.identity.legal_structure",
                "label": "Legal structure",
                "input": "select",
                "tab": "general",
                "section": "identity",
                "order": 7,
                "required": "never",
                "options": [
                  {
                    "value": "private",
                    "label": "Private"
                  },
                  {
                    "value": "public",
                    "label": "Public"
                  },
                  {
                    "value": "statutory",
                    "label": "Statutory"
                  },
                  {
                    "value": "trust",
                    "label": "Trust"
                  },
                  {
                    "value": "other",
                    "label": "Other"
                  }
                ],
                "taxonomy": "lp_legal_structures",
                "coreTable": "limited_partners_general",
                "coreField": "legal_structure",
                "dataType": "SingleSelect"
              }
            ]
          },
          {
            "key": "hq_location",
            "label": "Headquarters",
            "kind": "fields",
            "tab": "general",
            "order": 1,
            "fields": [
              {
                "key": "hq_country",
                "path": "general.hq_location.hq_country",
                "label": "Headquarters country",
                "input": "select",
                "tab": "general",
                "section": "hq_location",
                "order": 0,
                "required": "always",
                "options": [
                  {
                    "value": "nigeria",
                    "label": "Nigeria"
                  },
                  {
                    "value": "ghana",
                    "label": "Ghana"
                  },
                  {
                    "value": "senegal",
                    "label": "Senegal"
                  },
                  {
                    "value": "cote-divoire",
                    "label": "Côte d'Ivoire"
                  },
                  {
                    "value": "mali",
                    "label": "Mali"
                  },
                  {
                    "value": "benin",
                    "label": "Benin"
                  },
                  {
                    "value": "togo",
                    "label": "Togo"
                  },
                  {
                    "value": "burkina-faso",
                    "label": "Burkina Faso"
                  },
                  {
                    "value": "sierra-leone",
                    "label": "Sierra Leone"
                  },
                  {
                    "value": "liberia",
                    "label": "Liberia"
                  },
                  {
                    "value": "guinea",
                    "label": "Guinea"
                  },
                  {
                    "value": "kenya",
                    "label": "Kenya"
                  },
                  {
                    "value": "tanzania",
                    "label": "Tanzania"
                  },
                  {
                    "value": "uganda",
                    "label": "Uganda"
                  },
                  {
                    "value": "rwanda",
                    "label": "Rwanda"
                  },
                  {
                    "value": "ethiopia",
                    "label": "Ethiopia"
                  },
                  {
                    "value": "somalia",
                    "label": "Somalia"
                  },
                  {
                    "value": "burundi",
                    "label": "Burundi"
                  },
                  {
                    "value": "south-sudan",
                    "label": "South Sudan"
                  },
                  {
                    "value": "south-africa",
                    "label": "South Africa"
                  },
                  {
                    "value": "botswana",
                    "label": "Botswana"
                  },
                  {
                    "value": "namibia",
                    "label": "Namibia"
                  },
                  {
                    "value": "zambia",
                    "label": "Zambia"
                  },
                  {
                    "value": "zimbabwe",
                    "label": "Zimbabwe"
                  },
                  {
                    "value": "mozambique",
                    "label": "Mozambique"
                  },
                  {
                    "value": "malawi",
                    "label": "Malawi"
                  },
                  {
                    "value": "mauritius",
                    "label": "Mauritius"
                  },
                  {
                    "value": "egypt",
                    "label": "Egypt"
                  },
                  {
                    "value": "morocco",
                    "label": "Morocco"
                  },
                  {
                    "value": "tunisia",
                    "label": "Tunisia"
                  },
                  {
                    "value": "algeria",
                    "label": "Algeria"
                  },
                  {
                    "value": "libya",
                    "label": "Libya"
                  },
                  {
                    "value": "sudan",
                    "label": "Sudan"
                  },
                  {
                    "value": "cameroon",
                    "label": "Cameroon"
                  },
                  {
                    "value": "drc",
                    "label": "Democratic Republic of the Congo"
                  },
                  {
                    "value": "gabon",
                    "label": "Gabon"
                  },
                  {
                    "value": "chad",
                    "label": "Chad"
                  },
                  {
                    "value": "congo",
                    "label": "Republic of the Congo"
                  },
                  {
                    "value": "united-kingdom",
                    "label": "United Kingdom"
                  },
                  {
                    "value": "united-states",
                    "label": "United States"
                  },
                  {
                    "value": "netherlands",
                    "label": "Netherlands"
                  },
                  {
                    "value": "france",
                    "label": "France"
                  },
                  {
                    "value": "united-arab-emirates",
                    "label": "United Arab Emirates"
                  },
                  {
                    "value": "mauritius-ibc",
                    "label": "Mauritius (IBC)"
                  },
                  {
                    "value": "cayman-islands",
                    "label": "Cayman Islands"
                  },
                  {
                    "value": "luxembourg",
                    "label": "Luxembourg"
                  }
                ],
                "taxonomy": "countries",
                "coreTable": "limited_partners_general",
                "coreField": "hq_country",
                "dataType": "Links"
              },
              {
                "key": "regions_of_hq",
                "path": "general.hq_location.regions_of_hq",
                "label": "Headquarters region",
                "input": "multiselect",
                "tab": "general",
                "section": "hq_location",
                "order": 1,
                "required": "never",
                "options": [
                  {
                    "value": "western-africa",
                    "label": "Western Africa"
                  },
                  {
                    "value": "eastern-africa",
                    "label": "Eastern Africa"
                  },
                  {
                    "value": "southern-africa",
                    "label": "Southern Africa"
                  },
                  {
                    "value": "northern-africa",
                    "label": "Northern Africa"
                  },
                  {
                    "value": "central-africa",
                    "label": "Central Africa"
                  },
                  {
                    "value": "europe",
                    "label": "Europe"
                  },
                  {
                    "value": "northern-america",
                    "label": "Northern America"
                  },
                  {
                    "value": "central-america",
                    "label": "Central America"
                  },
                  {
                    "value": "southern-america",
                    "label": "Southern America"
                  },
                  {
                    "value": "middle-east",
                    "label": "Middle East"
                  },
                  {
                    "value": "asia",
                    "label": "Asia"
                  },
                  {
                    "value": "australia",
                    "label": "Australia"
                  }
                ],
                "taxonomy": "hq_regions",
                "coreTable": "limited_partners_general",
                "coreField": "regions_of_hq",
                "dataType": "Links"
              }
            ]
          },
          {
            "key": "capital",
            "label": "Capital",
            "kind": "fields",
            "tab": "general",
            "order": 2,
            "fields": [
              {
                "key": "aum",
                "path": "general.capital.aum",
                "label": "Assets under management",
                "input": "money",
                "tab": "general",
                "section": "capital",
                "order": 0,
                "required": "never",
                "undisclosed": true,
                "coreTable": "limited_partners_general",
                "coreField": "aum",
                "dataType": "Currency"
              },
              {
                "key": "total_funds_committed",
                "path": "general.capital.total_funds_committed",
                "label": "Total funds committed",
                "input": "money",
                "tab": "general",
                "section": "capital",
                "order": 1,
                "required": "never",
                "help": "Total committed to funds and direct investments since inception.",
                "undisclosed": true,
                "coreTable": "limited_partners_general",
                "coreField": "total_funds_committed",
                "dataType": "Currency"
              },
              {
                "key": "total_funds_committed_disclosed_usd",
                "path": "general.capital.total_funds_committed_disclosed_usd",
                "label": "Total committed that may be published (USD)",
                "input": "money",
                "tab": "general",
                "section": "capital",
                "order": 2,
                "required": "never",
                "help": "The portion of the figure above Stears may publish. Leave blank if none.",
                "undisclosed": true,
                "coreTable": "limited_partners_general",
                "coreField": "total_funds_committed_disclosed_usd",
                "dataType": "Currency"
              }
            ]
          },
          {
            "key": "publications",
            "label": "Publications",
            "kind": "fields",
            "tab": "general",
            "order": 3,
            "fields": [
              {
                "key": "reports",
                "path": "general.publications.reports",
                "label": "Published reports",
                "input": "url",
                "tab": "general",
                "section": "publications",
                "order": 0,
                "required": "never",
                "help": "A link to your most recent annual or impact report.",
                "coreTable": "limited_partners_general",
                "coreField": "reports",
                "dataType": "URL"
              }
            ],
            "collapsed": true
          }
        ],
        "intro": "Confirm the details Stears holds about your institution. Fields marked required must be completed."
      },
      {
        "key": "contacts",
        "number": 2,
        "label": "Contacts and locations",
        "shortLabel": "Contacts",
        "coreTables": [
          "limited_partners_general"
        ],
        "sections": [
          {
            "key": "hq",
            "label": "Headquarters address",
            "kind": "fields",
            "tab": "contacts",
            "order": 0,
            "fields": [
              {
                "key": "datahub.hq_street",
                "path": "contacts.hq.datahub.hq_street",
                "label": "Street address",
                "input": "text",
                "tab": "contacts",
                "section": "hq",
                "order": 0,
                "required": "never"
              },
              {
                "key": "datahub.hq_city",
                "path": "contacts.hq.datahub.hq_city",
                "label": "City",
                "input": "text",
                "tab": "contacts",
                "section": "hq",
                "order": 1,
                "required": "always"
              },
              {
                "key": "datahub.hq_state",
                "path": "contacts.hq.datahub.hq_state",
                "label": "State or region",
                "input": "text",
                "tab": "contacts",
                "section": "hq",
                "order": 2,
                "required": "never"
              },
              {
                "key": "datahub.hq_postcode",
                "path": "contacts.hq.datahub.hq_postcode",
                "label": "Postcode",
                "input": "text",
                "tab": "contacts",
                "section": "hq",
                "order": 3,
                "required": "never"
              },
              {
                "key": "datahub.general_phone",
                "path": "contacts.hq.datahub.general_phone",
                "label": "General phone",
                "input": "tel",
                "tab": "contacts",
                "section": "hq",
                "order": 4,
                "required": "never"
              },
              {
                "key": "datahub.general_email",
                "path": "contacts.hq.datahub.general_email",
                "label": "General email",
                "input": "email",
                "tab": "contacts",
                "section": "hq",
                "order": 5,
                "required": "never"
              }
            ]
          },
          {
            "key": "online",
            "label": "Online",
            "kind": "fields",
            "tab": "contacts",
            "order": 1,
            "fields": [
              {
                "key": "datahub.linkedin_url",
                "path": "contacts.online.datahub.linkedin_url",
                "label": "LinkedIn",
                "input": "url",
                "tab": "contacts",
                "section": "online",
                "order": 0,
                "required": "never"
              },
              {
                "key": "datahub.x_url",
                "path": "contacts.online.datahub.x_url",
                "label": "X (Twitter)",
                "input": "url",
                "tab": "contacts",
                "section": "online",
                "order": 1,
                "required": "never"
              }
            ]
          },
          {
            "key": "offices",
            "label": "Other offices",
            "kind": "repeatable",
            "tab": "contacts",
            "order": 2,
            "fields": [
              {
                "key": "datahub.office_type",
                "path": "contacts.offices.datahub.office_type",
                "label": "Office type",
                "input": "select",
                "tab": "contacts",
                "section": "offices",
                "order": 0,
                "required": "always",
                "options": [
                  {
                    "value": "Registered office",
                    "label": "Registered office"
                  },
                  {
                    "value": "Regional office",
                    "label": "Regional office"
                  },
                  {
                    "value": "Representative office",
                    "label": "Representative office"
                  },
                  {
                    "value": "Other",
                    "label": "Other"
                  }
                ]
              },
              {
                "key": "datahub.city",
                "path": "contacts.offices.datahub.city",
                "label": "City",
                "input": "text",
                "tab": "contacts",
                "section": "offices",
                "order": 1,
                "required": "always"
              },
              {
                "key": "datahub.country",
                "path": "contacts.offices.datahub.country",
                "label": "Country",
                "input": "select",
                "tab": "contacts",
                "section": "offices",
                "order": 2,
                "required": "always",
                "options": [
                  {
                    "value": "nigeria",
                    "label": "Nigeria"
                  },
                  {
                    "value": "ghana",
                    "label": "Ghana"
                  },
                  {
                    "value": "senegal",
                    "label": "Senegal"
                  },
                  {
                    "value": "cote-divoire",
                    "label": "Côte d'Ivoire"
                  },
                  {
                    "value": "mali",
                    "label": "Mali"
                  },
                  {
                    "value": "benin",
                    "label": "Benin"
                  },
                  {
                    "value": "togo",
                    "label": "Togo"
                  },
                  {
                    "value": "burkina-faso",
                    "label": "Burkina Faso"
                  },
                  {
                    "value": "sierra-leone",
                    "label": "Sierra Leone"
                  },
                  {
                    "value": "liberia",
                    "label": "Liberia"
                  },
                  {
                    "value": "guinea",
                    "label": "Guinea"
                  },
                  {
                    "value": "kenya",
                    "label": "Kenya"
                  },
                  {
                    "value": "tanzania",
                    "label": "Tanzania"
                  },
                  {
                    "value": "uganda",
                    "label": "Uganda"
                  },
                  {
                    "value": "rwanda",
                    "label": "Rwanda"
                  },
                  {
                    "value": "ethiopia",
                    "label": "Ethiopia"
                  },
                  {
                    "value": "somalia",
                    "label": "Somalia"
                  },
                  {
                    "value": "burundi",
                    "label": "Burundi"
                  },
                  {
                    "value": "south-sudan",
                    "label": "South Sudan"
                  },
                  {
                    "value": "south-africa",
                    "label": "South Africa"
                  },
                  {
                    "value": "botswana",
                    "label": "Botswana"
                  },
                  {
                    "value": "namibia",
                    "label": "Namibia"
                  },
                  {
                    "value": "zambia",
                    "label": "Zambia"
                  },
                  {
                    "value": "zimbabwe",
                    "label": "Zimbabwe"
                  },
                  {
                    "value": "mozambique",
                    "label": "Mozambique"
                  },
                  {
                    "value": "malawi",
                    "label": "Malawi"
                  },
                  {
                    "value": "mauritius",
                    "label": "Mauritius"
                  },
                  {
                    "value": "egypt",
                    "label": "Egypt"
                  },
                  {
                    "value": "morocco",
                    "label": "Morocco"
                  },
                  {
                    "value": "tunisia",
                    "label": "Tunisia"
                  },
                  {
                    "value": "algeria",
                    "label": "Algeria"
                  },
                  {
                    "value": "libya",
                    "label": "Libya"
                  },
                  {
                    "value": "sudan",
                    "label": "Sudan"
                  },
                  {
                    "value": "cameroon",
                    "label": "Cameroon"
                  },
                  {
                    "value": "drc",
                    "label": "Democratic Republic of the Congo"
                  },
                  {
                    "value": "gabon",
                    "label": "Gabon"
                  },
                  {
                    "value": "chad",
                    "label": "Chad"
                  },
                  {
                    "value": "congo",
                    "label": "Republic of the Congo"
                  },
                  {
                    "value": "united-kingdom",
                    "label": "United Kingdom"
                  },
                  {
                    "value": "united-states",
                    "label": "United States"
                  },
                  {
                    "value": "netherlands",
                    "label": "Netherlands"
                  },
                  {
                    "value": "france",
                    "label": "France"
                  },
                  {
                    "value": "united-arab-emirates",
                    "label": "United Arab Emirates"
                  },
                  {
                    "value": "mauritius-ibc",
                    "label": "Mauritius (IBC)"
                  },
                  {
                    "value": "cayman-islands",
                    "label": "Cayman Islands"
                  },
                  {
                    "value": "luxembourg",
                    "label": "Luxembourg"
                  }
                ],
                "taxonomy": "countries"
              },
              {
                "key": "datahub.address",
                "path": "contacts.offices.datahub.address",
                "label": "Address",
                "input": "text",
                "tab": "contacts",
                "section": "offices",
                "order": 3,
                "required": "never"
              }
            ],
            "rowEntity": "location",
            "rowLabel": "{city}, {country}",
            "toggle": {
              "key": "nothing_to_add",
              "label": "No other offices to report"
            }
          },
          {
            "key": "datahub_contacts",
            "label": "People who receive this link",
            "kind": "repeatable",
            "tab": "contacts",
            "order": 3,
            "fields": [
              {
                "key": "datahub.full_name",
                "path": "contacts.datahub_contacts.datahub.full_name",
                "label": "Name",
                "input": "text",
                "tab": "contacts",
                "section": "datahub_contacts",
                "order": 0,
                "required": "always"
              },
              {
                "key": "datahub.role_title",
                "path": "contacts.datahub_contacts.datahub.role_title",
                "label": "Role",
                "input": "text",
                "tab": "contacts",
                "section": "datahub_contacts",
                "order": 1,
                "required": "never"
              },
              {
                "key": "datahub.email",
                "path": "contacts.datahub_contacts.datahub.email",
                "label": "Email",
                "input": "email",
                "tab": "contacts",
                "section": "datahub_contacts",
                "order": 2,
                "required": "always"
              }
            ],
            "help": "Stears sends the update link to these people. Add a colleague to have them included from the next cycle.",
            "rowEntity": "contact",
            "rowLabel": "{full_name}",
            "minRowsForComplete": 1,
            "readOnlyExisting": true
          }
        ]
      },
      {
        "key": "people",
        "number": 3,
        "label": "Management team",
        "shortLabel": "Team",
        "coreTables": [
          "people_general",
          "people_role_engagements"
        ],
        "sections": [
          {
            "key": "people",
            "label": "Investment team, executives and board",
            "kind": "repeatable",
            "tab": "people",
            "order": 0,
            "fields": [
              {
                "key": "first_name",
                "path": "people.people.first_name",
                "label": "First name",
                "input": "text",
                "tab": "people",
                "section": "people",
                "order": 0,
                "required": "always",
                "coreTable": "people_general",
                "coreField": "first_name",
                "dataType": "SingleLineText"
              },
              {
                "key": "last_name",
                "path": "people.people.last_name",
                "label": "Last name",
                "input": "text",
                "tab": "people",
                "section": "people",
                "order": 1,
                "required": "always",
                "coreTable": "people_general",
                "coreField": "last_name",
                "dataType": "SingleLineText"
              },
              {
                "key": "role_title",
                "path": "people.people.role_title",
                "label": "Role title",
                "input": "text",
                "tab": "people",
                "section": "people",
                "order": 2,
                "required": "always",
                "help": "The exact title, for example Chief Investment Officer or Head of Private Markets.",
                "coreTable": "people_role_engagements",
                "coreField": "role_title",
                "dataType": "SingleLineText"
              },
              {
                "key": "role_category",
                "path": "people.people.role_category",
                "label": "Role category",
                "input": "select",
                "tab": "people",
                "section": "people",
                "order": 3,
                "required": "always",
                "options": [
                  {
                    "value": "C-Suite / Executive",
                    "label": "C-Suite / Executive"
                  },
                  {
                    "value": "Senior Management",
                    "label": "Senior Management"
                  },
                  {
                    "value": "Executive Director",
                    "label": "Executive Director"
                  },
                  {
                    "value": "Non-Executive Director",
                    "label": "Non-Executive Director"
                  },
                  {
                    "value": "Board Chair / Vice-Chair",
                    "label": "Board Chair / Vice-Chair"
                  },
                  {
                    "value": "Board Committee Chair / Member",
                    "label": "Board Committee Chair / Member"
                  },
                  {
                    "value": "Founder / Co-Founder",
                    "label": "Founder / Co-Founder"
                  },
                  {
                    "value": "General Partner (GP)",
                    "label": "General Partner (GP)"
                  },
                  {
                    "value": "Limited Partner (LP)",
                    "label": "Limited Partner (LP)"
                  },
                  {
                    "value": "Partner",
                    "label": "Partner"
                  },
                  {
                    "value": "Board Observer",
                    "label": "Board Observer"
                  },
                  {
                    "value": "Senior Advisor / Consultant",
                    "label": "Senior Advisor / Consultant"
                  },
                  {
                    "value": "IC Chairperson",
                    "label": "IC Chairperson"
                  },
                  {
                    "value": "Internal IC Members",
                    "label": "Internal IC Members"
                  },
                  {
                    "value": "External IC Members",
                    "label": "External IC Members"
                  },
                  {
                    "value": "Board of Governor",
                    "label": "Board of Governor"
                  }
                ],
                "grouped": true,
                "coreTable": "people_role_engagements",
                "coreField": "role_category",
                "dataType": "SingleSelect"
              },
              {
                "key": "datahub.management_status",
                "path": "people.people.datahub.management_status",
                "label": "Management status",
                "input": "radio",
                "tab": "people",
                "section": "people",
                "order": 4,
                "required": "always",
                "options": [
                  {
                    "value": "Team member",
                    "label": "Team member"
                  },
                  {
                    "value": "Board member",
                    "label": "Board member"
                  },
                  {
                    "value": "Investment committee",
                    "label": "Investment committee"
                  }
                ]
              },
              {
                "key": "start_date",
                "path": "people.people.start_date",
                "label": "Start date",
                "input": "date",
                "tab": "people",
                "section": "people",
                "order": 5,
                "required": "never",
                "precision": true,
                "coreTable": "people_role_engagements",
                "coreField": "start_date",
                "dataType": "Date"
              },
              {
                "key": "role_status",
                "path": "people.people.role_status",
                "label": "Status",
                "input": "radio",
                "tab": "people",
                "section": "people",
                "order": 6,
                "required": "always",
                "options": [
                  {
                    "value": "Current",
                    "label": "Current"
                  },
                  {
                    "value": "Former",
                    "label": "Former"
                  }
                ],
                "coreTable": "people_role_engagements",
                "coreField": "role_status",
                "dataType": "SingleSelect"
              },
              {
                "key": "end_date",
                "path": "people.people.end_date",
                "label": "End date",
                "input": "date",
                "tab": "people",
                "section": "people",
                "order": 7,
                "required": "conditional",
                "requiredWhen": {
                  "field": "role_status",
                  "eq": "Former"
                },
                "visibleWhen": {
                  "field": "role_status",
                  "eq": "Former"
                },
                "coreTable": "people_role_engagements",
                "coreField": "end_date",
                "dataType": "Date"
              },
              {
                "key": "datahub.location_city",
                "path": "people.people.datahub.location_city",
                "label": "City",
                "input": "text",
                "tab": "people",
                "section": "people",
                "order": 8,
                "required": "never"
              },
              {
                "key": "datahub.location_country",
                "path": "people.people.datahub.location_country",
                "label": "Country of primary residence",
                "input": "select",
                "tab": "people",
                "section": "people",
                "order": 9,
                "required": "never",
                "options": [
                  {
                    "value": "nigeria",
                    "label": "Nigeria"
                  },
                  {
                    "value": "ghana",
                    "label": "Ghana"
                  },
                  {
                    "value": "senegal",
                    "label": "Senegal"
                  },
                  {
                    "value": "cote-divoire",
                    "label": "Côte d'Ivoire"
                  },
                  {
                    "value": "mali",
                    "label": "Mali"
                  },
                  {
                    "value": "benin",
                    "label": "Benin"
                  },
                  {
                    "value": "togo",
                    "label": "Togo"
                  },
                  {
                    "value": "burkina-faso",
                    "label": "Burkina Faso"
                  },
                  {
                    "value": "sierra-leone",
                    "label": "Sierra Leone"
                  },
                  {
                    "value": "liberia",
                    "label": "Liberia"
                  },
                  {
                    "value": "guinea",
                    "label": "Guinea"
                  },
                  {
                    "value": "kenya",
                    "label": "Kenya"
                  },
                  {
                    "value": "tanzania",
                    "label": "Tanzania"
                  },
                  {
                    "value": "uganda",
                    "label": "Uganda"
                  },
                  {
                    "value": "rwanda",
                    "label": "Rwanda"
                  },
                  {
                    "value": "ethiopia",
                    "label": "Ethiopia"
                  },
                  {
                    "value": "somalia",
                    "label": "Somalia"
                  },
                  {
                    "value": "burundi",
                    "label": "Burundi"
                  },
                  {
                    "value": "south-sudan",
                    "label": "South Sudan"
                  },
                  {
                    "value": "south-africa",
                    "label": "South Africa"
                  },
                  {
                    "value": "botswana",
                    "label": "Botswana"
                  },
                  {
                    "value": "namibia",
                    "label": "Namibia"
                  },
                  {
                    "value": "zambia",
                    "label": "Zambia"
                  },
                  {
                    "value": "zimbabwe",
                    "label": "Zimbabwe"
                  },
                  {
                    "value": "mozambique",
                    "label": "Mozambique"
                  },
                  {
                    "value": "malawi",
                    "label": "Malawi"
                  },
                  {
                    "value": "mauritius",
                    "label": "Mauritius"
                  },
                  {
                    "value": "egypt",
                    "label": "Egypt"
                  },
                  {
                    "value": "morocco",
                    "label": "Morocco"
                  },
                  {
                    "value": "tunisia",
                    "label": "Tunisia"
                  },
                  {
                    "value": "algeria",
                    "label": "Algeria"
                  },
                  {
                    "value": "libya",
                    "label": "Libya"
                  },
                  {
                    "value": "sudan",
                    "label": "Sudan"
                  },
                  {
                    "value": "cameroon",
                    "label": "Cameroon"
                  },
                  {
                    "value": "drc",
                    "label": "Democratic Republic of the Congo"
                  },
                  {
                    "value": "gabon",
                    "label": "Gabon"
                  },
                  {
                    "value": "chad",
                    "label": "Chad"
                  },
                  {
                    "value": "congo",
                    "label": "Republic of the Congo"
                  },
                  {
                    "value": "united-kingdom",
                    "label": "United Kingdom"
                  },
                  {
                    "value": "united-states",
                    "label": "United States"
                  },
                  {
                    "value": "netherlands",
                    "label": "Netherlands"
                  },
                  {
                    "value": "france",
                    "label": "France"
                  },
                  {
                    "value": "united-arab-emirates",
                    "label": "United Arab Emirates"
                  },
                  {
                    "value": "mauritius-ibc",
                    "label": "Mauritius (IBC)"
                  },
                  {
                    "value": "cayman-islands",
                    "label": "Cayman Islands"
                  },
                  {
                    "value": "luxembourg",
                    "label": "Luxembourg"
                  }
                ],
                "taxonomy": "countries"
              },
              {
                "key": "linkedin_url",
                "path": "people.people.linkedin_url",
                "label": "LinkedIn",
                "input": "url",
                "tab": "people",
                "section": "people",
                "order": 10,
                "required": "never",
                "coreTable": "people_general",
                "coreField": "linkedin_url",
                "dataType": "URL"
              },
              {
                "key": "email",
                "path": "people.people.email",
                "label": "Professional email",
                "input": "email",
                "tab": "people",
                "section": "people",
                "order": 11,
                "required": "never",
                "help": "Held in Stears internal records only, never published.",
                "confidential": "always",
                "coreTable": "people_general",
                "coreField": "email",
                "dataType": "Email"
              },
              {
                "key": "phone_number",
                "path": "people.people.phone_number",
                "label": "Phone",
                "input": "tel",
                "tab": "people",
                "section": "people",
                "order": 12,
                "required": "never",
                "help": "Held in Stears internal records only, never published.",
                "confidential": "always",
                "coreTable": "people_general",
                "coreField": "phone_number",
                "dataType": "PhoneNumber"
              },
              {
                "key": "biography",
                "path": "people.people.biography",
                "label": "Biography",
                "input": "longtext",
                "tab": "people",
                "section": "people",
                "order": 13,
                "required": "never",
                "maxLength": 1500,
                "coreTable": "people_general",
                "coreField": "biography",
                "dataType": "LongText"
              },
              {
                "key": "gender",
                "path": "people.people.gender",
                "label": "Gender",
                "input": "select",
                "tab": "people",
                "section": "people",
                "order": 14,
                "required": "never",
                "help": "Optional. Used only for aggregate diversity reporting.",
                "options": [
                  {
                    "value": "Male",
                    "label": "Male"
                  },
                  {
                    "value": "Female",
                    "label": "Female"
                  },
                  {
                    "value": "Other",
                    "label": "Other"
                  },
                  {
                    "value": "Undisclosed",
                    "label": "Undisclosed"
                  }
                ],
                "coreTable": "people_general",
                "coreField": "gender",
                "dataType": "SingleSelect"
              },
              {
                "key": "nationality",
                "path": "people.people.nationality",
                "label": "Nationality",
                "input": "multiselect",
                "tab": "people",
                "section": "people",
                "order": 15,
                "required": "never",
                "help": "Optional.",
                "options": [
                  {
                    "value": "nigeria",
                    "label": "Nigeria"
                  },
                  {
                    "value": "ghana",
                    "label": "Ghana"
                  },
                  {
                    "value": "senegal",
                    "label": "Senegal"
                  },
                  {
                    "value": "cote-divoire",
                    "label": "Côte d'Ivoire"
                  },
                  {
                    "value": "mali",
                    "label": "Mali"
                  },
                  {
                    "value": "benin",
                    "label": "Benin"
                  },
                  {
                    "value": "togo",
                    "label": "Togo"
                  },
                  {
                    "value": "burkina-faso",
                    "label": "Burkina Faso"
                  },
                  {
                    "value": "sierra-leone",
                    "label": "Sierra Leone"
                  },
                  {
                    "value": "liberia",
                    "label": "Liberia"
                  },
                  {
                    "value": "guinea",
                    "label": "Guinea"
                  },
                  {
                    "value": "kenya",
                    "label": "Kenya"
                  },
                  {
                    "value": "tanzania",
                    "label": "Tanzania"
                  },
                  {
                    "value": "uganda",
                    "label": "Uganda"
                  },
                  {
                    "value": "rwanda",
                    "label": "Rwanda"
                  },
                  {
                    "value": "ethiopia",
                    "label": "Ethiopia"
                  },
                  {
                    "value": "somalia",
                    "label": "Somalia"
                  },
                  {
                    "value": "burundi",
                    "label": "Burundi"
                  },
                  {
                    "value": "south-sudan",
                    "label": "South Sudan"
                  },
                  {
                    "value": "south-africa",
                    "label": "South Africa"
                  },
                  {
                    "value": "botswana",
                    "label": "Botswana"
                  },
                  {
                    "value": "namibia",
                    "label": "Namibia"
                  },
                  {
                    "value": "zambia",
                    "label": "Zambia"
                  },
                  {
                    "value": "zimbabwe",
                    "label": "Zimbabwe"
                  },
                  {
                    "value": "mozambique",
                    "label": "Mozambique"
                  },
                  {
                    "value": "malawi",
                    "label": "Malawi"
                  },
                  {
                    "value": "mauritius",
                    "label": "Mauritius"
                  },
                  {
                    "value": "egypt",
                    "label": "Egypt"
                  },
                  {
                    "value": "morocco",
                    "label": "Morocco"
                  },
                  {
                    "value": "tunisia",
                    "label": "Tunisia"
                  },
                  {
                    "value": "algeria",
                    "label": "Algeria"
                  },
                  {
                    "value": "libya",
                    "label": "Libya"
                  },
                  {
                    "value": "sudan",
                    "label": "Sudan"
                  },
                  {
                    "value": "cameroon",
                    "label": "Cameroon"
                  },
                  {
                    "value": "drc",
                    "label": "Democratic Republic of the Congo"
                  },
                  {
                    "value": "gabon",
                    "label": "Gabon"
                  },
                  {
                    "value": "chad",
                    "label": "Chad"
                  },
                  {
                    "value": "congo",
                    "label": "Republic of the Congo"
                  },
                  {
                    "value": "united-kingdom",
                    "label": "United Kingdom"
                  },
                  {
                    "value": "united-states",
                    "label": "United States"
                  },
                  {
                    "value": "netherlands",
                    "label": "Netherlands"
                  },
                  {
                    "value": "france",
                    "label": "France"
                  },
                  {
                    "value": "united-arab-emirates",
                    "label": "United Arab Emirates"
                  },
                  {
                    "value": "mauritius-ibc",
                    "label": "Mauritius (IBC)"
                  },
                  {
                    "value": "cayman-islands",
                    "label": "Cayman Islands"
                  },
                  {
                    "value": "luxembourg",
                    "label": "Luxembourg"
                  }
                ],
                "taxonomy": "countries",
                "coreTable": "people_general",
                "coreField": "nationality",
                "dataType": "Links"
              }
            ],
            "rowEntity": "person_role",
            "rowLabel": "{first_name} {last_name} — {role_title}",
            "toggle": {
              "key": "no_changes",
              "label": "No changes to the team"
            }
          }
        ],
        "intro": "One row per role. Someone who sits on both the investment committee and the board has two rows."
      },
      {
        "key": "mandate",
        "number": 4,
        "label": "Investment mandate",
        "shortLabel": "Mandate",
        "coreTables": [
          "limited_partners_general"
        ],
        "sections": [
          {
            "key": "geography",
            "label": "Geography",
            "kind": "fields",
            "tab": "mandate",
            "order": 0,
            "fields": [
              {
                "key": "regions_of_investment",
                "path": "mandate.geography.regions_of_investment",
                "label": "Regions of investment",
                "input": "multiselect",
                "tab": "mandate",
                "section": "geography",
                "order": 0,
                "required": "always",
                "options": [
                  {
                    "value": "global",
                    "label": "Global"
                  },
                  {
                    "value": "pan-african",
                    "label": "Pan-African"
                  },
                  {
                    "value": "sub-saharan-africa",
                    "label": "Sub-Saharan Africa"
                  },
                  {
                    "value": "northern-africa",
                    "label": "Northern Africa"
                  },
                  {
                    "value": "eastern-africa",
                    "label": "Eastern Africa"
                  },
                  {
                    "value": "western-africa",
                    "label": "Western Africa"
                  },
                  {
                    "value": "central-africa",
                    "label": "Central Africa"
                  },
                  {
                    "value": "southern-africa",
                    "label": "Southern Africa"
                  },
                  {
                    "value": "europe",
                    "label": "Europe"
                  },
                  {
                    "value": "asia",
                    "label": "Asia"
                  },
                  {
                    "value": "middle-east",
                    "label": "Middle East"
                  },
                  {
                    "value": "americas",
                    "label": "Americas"
                  },
                  {
                    "value": "southern-america",
                    "label": "Southern America"
                  },
                  {
                    "value": "northern-america",
                    "label": "Northern America"
                  },
                  {
                    "value": "central-america",
                    "label": "Central America"
                  },
                  {
                    "value": "latin-america",
                    "label": "Latin America"
                  },
                  {
                    "value": "australia",
                    "label": "Australia"
                  },
                  {
                    "value": "eurasia",
                    "label": "Eurasia"
                  },
                  {
                    "value": "oceania",
                    "label": "Oceania"
                  }
                ],
                "taxonomy": "regions",
                "coreTable": "limited_partners_general",
                "coreField": "regions_of_investment",
                "dataType": "Links"
              }
            ]
          },
          {
            "key": "focus",
            "label": "Sector, stage and fund type",
            "kind": "fields",
            "tab": "mandate",
            "order": 1,
            "fields": [
              {
                "key": "sectors_of_investment",
                "path": "mandate.focus.sectors_of_investment",
                "label": "Sectors of investment",
                "input": "multiselect",
                "tab": "mandate",
                "section": "focus",
                "order": 0,
                "required": "always",
                "options": [
                  {
                    "value": "sector-agnostic",
                    "label": "Sector Agnostic"
                  },
                  {
                    "value": "financial-services",
                    "label": "Financial Services"
                  },
                  {
                    "value": "energy-utilities",
                    "label": "Energy & Utilities"
                  },
                  {
                    "value": "consumer-staples",
                    "label": "Consumer Staples"
                  },
                  {
                    "value": "consumer-discretionary",
                    "label": "Consumer Discretionary"
                  },
                  {
                    "value": "information-technology",
                    "label": "Information Technology"
                  },
                  {
                    "value": "communication-services",
                    "label": "Communication Services"
                  },
                  {
                    "value": "agriculture",
                    "label": "Agriculture"
                  },
                  {
                    "value": "industrials",
                    "label": "Industrials"
                  },
                  {
                    "value": "healthcare",
                    "label": "Healthcare"
                  },
                  {
                    "value": "real-estate",
                    "label": "Real Estate"
                  },
                  {
                    "value": "materials",
                    "label": "Materials"
                  }
                ],
                "taxonomy": "investment_sectors",
                "coreTable": "limited_partners_general",
                "coreField": "sectors_of_investment",
                "dataType": "Links"
              },
              {
                "key": "stage_preference",
                "path": "mandate.focus.stage_preference",
                "label": "Stage preferences",
                "input": "multiselect",
                "tab": "mandate",
                "section": "focus",
                "order": 1,
                "required": "never",
                "options": [
                  {
                    "value": "pre-seed",
                    "label": "Pre-seed"
                  },
                  {
                    "value": "seed",
                    "label": "Seed"
                  },
                  {
                    "value": "series-a",
                    "label": "Series A"
                  },
                  {
                    "value": "series-b",
                    "label": "Series B"
                  },
                  {
                    "value": "series-c",
                    "label": "Series C"
                  },
                  {
                    "value": "series-d+",
                    "label": "Series D+"
                  },
                  {
                    "value": "growth-stage",
                    "label": "Growth Stage"
                  },
                  {
                    "value": "growth-equity",
                    "label": "Growth Equity"
                  },
                  {
                    "value": "buyout",
                    "label": "Buyout"
                  }
                ],
                "taxonomy": "investment_stages",
                "coreTable": "limited_partners_general",
                "coreField": "stage_preference",
                "dataType": "Links"
              },
              {
                "key": "thematic_focus",
                "path": "mandate.focus.thematic_focus",
                "label": "Thematic focus",
                "input": "multiselect",
                "tab": "mandate",
                "section": "focus",
                "order": 2,
                "required": "never",
                "options": [
                  {
                    "value": "circular-economy",
                    "label": "Circular Economy"
                  },
                  {
                    "value": "climate---energy-transition",
                    "label": "Climate / Energy Transition"
                  },
                  {
                    "value": "food-systems---sustainable-agriculture",
                    "label": "Food Systems / Sustainable Agriculture"
                  },
                  {
                    "value": "gender---inclusive-finance",
                    "label": "Gender / Inclusive Finance"
                  },
                  {
                    "value": "healthcare-access",
                    "label": "Healthcare Access"
                  },
                  {
                    "value": "impact-first---commercial-plus",
                    "label": "Impact-first / Commercial-plus"
                  },
                  {
                    "value": "infrastructure",
                    "label": "Infrastructure"
                  },
                  {
                    "value": "real-estate---affordable-housing",
                    "label": "Real Estate / Affordable Housing"
                  },
                  {
                    "value": "smes---msmes",
                    "label": "SMEs / MSMEs"
                  }
                ],
                "taxonomy": "thematic_focuses",
                "coreTable": "limited_partners_general",
                "coreField": "thematic_focus",
                "dataType": "Links"
              },
              {
                "key": "preferred_fund_type",
                "path": "mandate.focus.preferred_fund_type",
                "label": "Preferred fund types",
                "input": "multiselect",
                "tab": "mandate",
                "section": "focus",
                "order": 3,
                "required": "never",
                "options": [
                  {
                    "value": "buyout",
                    "label": "Buyout"
                  },
                  {
                    "value": "fund-of-funds-(fof)",
                    "label": "Fund of Funds (FoF)"
                  },
                  {
                    "value": "growth-private-equity",
                    "label": "Growth Private Equity"
                  },
                  {
                    "value": "infrastructure",
                    "label": "Infrastructure"
                  },
                  {
                    "value": "private-credit",
                    "label": "Private Credit"
                  },
                  {
                    "value": "real-estate",
                    "label": "Real Estate"
                  },
                  {
                    "value": "venture-capital",
                    "label": "Venture Capital"
                  }
                ],
                "taxonomy": "preferred_fund_types",
                "coreTable": "limited_partners_general",
                "coreField": "preferred_fund_type",
                "dataType": "Links"
              },
              {
                "key": "ticket_type",
                "path": "mandate.focus.ticket_type",
                "label": "Ticket type",
                "input": "select",
                "tab": "mandate",
                "section": "focus",
                "order": 4,
                "required": "never",
                "help": "Whether you typically anchor a fund or come in alongside others.",
                "options": [
                  {
                    "value": "anchor-lp",
                    "label": "Anchor LP"
                  },
                  {
                    "value": "passive-lp",
                    "label": "Passive LP"
                  }
                ],
                "taxonomy": "lp_ticket_types",
                "coreTable": "limited_partners_general",
                "coreField": "ticket_type",
                "dataType": "SingleSelect"
              }
            ]
          },
          {
            "key": "strategy",
            "label": "Strategy and mandate",
            "kind": "fields",
            "tab": "mandate",
            "order": 2,
            "fields": [
              {
                "key": "investment_strategy",
                "path": "mandate.strategy.investment_strategy",
                "label": "Investment strategy",
                "input": "multiselect",
                "tab": "mandate",
                "section": "strategy",
                "order": 0,
                "required": "always",
                "help": "How you deploy — into funds",
                "options": [
                  {
                    "value": "co-investment",
                    "label": "Co-investment"
                  },
                  {
                    "value": "direct-investment",
                    "label": "Direct Investment"
                  },
                  {
                    "value": "fund-investment",
                    "label": "Fund Investment"
                  }
                ],
                "taxonomy": "fund_investment_strategies",
                "coreTable": "limited_partners_general",
                "coreField": "investment_strategy",
                "dataType": "Links"
              },
              {
                "key": "investment_mandate",
                "path": "mandate.strategy.investment_mandate",
                "label": "Investment mandate",
                "input": "longtext",
                "tab": "mandate",
                "section": "strategy",
                "order": 1,
                "required": "never",
                "help": "The mandate you invest under",
                "maxLength": 2000,
                "coreTable": "limited_partners_general",
                "coreField": "investment_mandate",
                "dataType": "LongText"
              }
            ]
          },
          {
            "key": "criteria",
            "label": "Selection criteria",
            "kind": "fields",
            "tab": "mandate",
            "order": 3,
            "fields": [
              {
                "key": "location_criteria",
                "path": "mandate.criteria.location_criteria",
                "label": "Location criteria",
                "input": "longtext",
                "tab": "mandate",
                "section": "criteria",
                "order": 0,
                "required": "never",
                "maxLength": 1000,
                "coreTable": "limited_partners_general",
                "coreField": "location_criteria",
                "dataType": "LongText"
              },
              {
                "key": "environmental_criteria",
                "path": "mandate.criteria.environmental_criteria",
                "label": "Environmental criteria",
                "input": "longtext",
                "tab": "mandate",
                "section": "criteria",
                "order": 1,
                "required": "never",
                "maxLength": 1000,
                "coreTable": "limited_partners_general",
                "coreField": "environmental_criteria",
                "dataType": "LongText"
              },
              {
                "key": "social_criteria",
                "path": "mandate.criteria.social_criteria",
                "label": "Social criteria",
                "input": "longtext",
                "tab": "mandate",
                "section": "criteria",
                "order": 2,
                "required": "never",
                "maxLength": 1000,
                "coreTable": "limited_partners_general",
                "coreField": "social_criteria",
                "dataType": "LongText"
              },
              {
                "key": "governance_criteria",
                "path": "mandate.criteria.governance_criteria",
                "label": "Governance criteria",
                "input": "longtext",
                "tab": "mandate",
                "section": "criteria",
                "order": 3,
                "required": "never",
                "maxLength": 1000,
                "coreTable": "limited_partners_general",
                "coreField": "governance_criteria",
                "dataType": "LongText"
              },
              {
                "key": "financial_and_other_criteria",
                "path": "mandate.criteria.financial_and_other_criteria",
                "label": "Financial and other criteria",
                "input": "longtext",
                "tab": "mandate",
                "section": "criteria",
                "order": 4,
                "required": "never",
                "maxLength": 1000,
                "coreTable": "limited_partners_general",
                "coreField": "financial_and_other_criteria",
                "dataType": "LongText"
              }
            ],
            "help": "What a fund or a company has to satisfy before you commit. Leave any of these blank if you have no formal criterion."
          }
        ],
        "intro": "What you look for in a fund or a direct investment, and the criteria a manager has to meet."
      },
      {
        "key": "commitments",
        "number": 5,
        "label": "Commitments and funds",
        "shortLabel": "Commitments",
        "coreTables": [
          "fund_commitments",
          "investment_vehicles"
        ],
        "sections": [
          {
            "key": "commitments",
            "label": "Commitments to funds",
            "kind": "repeatable",
            "tab": "commitments",
            "order": 0,
            "fields": [
              {
                "key": "commitment_fund_name",
                "path": "commitments.commitments.commitment_fund_name",
                "label": "Fund",
                "input": "text",
                "tab": "commitments",
                "section": "commitments",
                "order": 0,
                "required": "always",
                "coreTable": "fund_commitments",
                "coreField": "commitment_fund_name",
                "dataType": "SingleLineText"
              },
              {
                "key": "commitment_gp_name",
                "path": "commitments.commitments.commitment_gp_name",
                "label": "Fund manager (GP)",
                "input": "text",
                "tab": "commitments",
                "section": "commitments",
                "order": 1,
                "required": "always",
                "coreTable": "fund_commitments",
                "coreField": "commitment_gp_name",
                "dataType": "SingleLineText"
              },
              {
                "key": "commitment_vintage_year",
                "path": "commitments.commitments.commitment_vintage_year",
                "label": "Fund vintage year",
                "input": "year",
                "tab": "commitments",
                "section": "commitments",
                "order": 2,
                "required": "never",
                "coreTable": "fund_commitments",
                "coreField": "commitment_vintage_year",
                "dataType": "Number"
              },
              {
                "key": "commitment_fund_type",
                "path": "commitments.commitments.commitment_fund_type",
                "label": "Fund type",
                "input": "multiselect",
                "tab": "commitments",
                "section": "commitments",
                "order": 3,
                "required": "never",
                "options": [
                  {
                    "value": "private-equity",
                    "label": "Private Equity"
                  },
                  {
                    "value": "venture-capital",
                    "label": "Venture Capital"
                  },
                  {
                    "value": "private-credit",
                    "label": "Private Credit"
                  },
                  {
                    "value": "infrastructure",
                    "label": "Infrastructure"
                  },
                  {
                    "value": "real-estate",
                    "label": "Real Estate"
                  },
                  {
                    "value": "impact-fund",
                    "label": "Impact Fund"
                  }
                ],
                "taxonomy": "fund_types",
                "coreTable": "fund_commitments",
                "coreField": "commitment_fund_type",
                "dataType": "Links"
              },
              {
                "key": "commitment_amount",
                "path": "commitments.commitments.commitment_amount",
                "label": "Amount committed",
                "input": "money",
                "tab": "commitments",
                "section": "commitments",
                "order": 4,
                "required": "never",
                "undisclosed": true,
                "coreTable": "fund_commitments",
                "coreField": "commitment_amount",
                "dataType": "Currency"
              },
              {
                "key": "commitment_date",
                "path": "commitments.commitments.commitment_date",
                "label": "Commitment date",
                "input": "date",
                "tab": "commitments",
                "section": "commitments",
                "order": 5,
                "required": "never",
                "coreTable": "fund_commitments",
                "coreField": "commitment_date",
                "dataType": "Date"
              },
              {
                "key": "commitment_status",
                "path": "commitments.commitments.commitment_status",
                "label": "Commitment status",
                "input": "select",
                "tab": "commitments",
                "section": "commitments",
                "order": 6,
                "required": "never",
                "options": [
                  {
                    "value": "Committed",
                    "label": "Committed"
                  },
                  {
                    "value": "Drawn down in part",
                    "label": "Drawn down in part"
                  },
                  {
                    "value": "Fully drawn",
                    "label": "Fully drawn"
                  },
                  {
                    "value": "Realised",
                    "label": "Realised"
                  },
                  {
                    "value": "Withdrawn",
                    "label": "Withdrawn"
                  }
                ],
                "coreTable": "fund_commitments",
                "coreField": "commitment_status",
                "dataType": "SingleSelect"
              },
              {
                "key": "datahub.publication_permission",
                "path": "commitments.commitments.datahub.publication_permission",
                "label": "Publication permission",
                "input": "radio",
                "tab": "commitments",
                "section": "commitments",
                "order": 7,
                "required": "always",
                "options": [
                  {
                    "value": "Stears may publish",
                    "label": "Stears may publish"
                  },
                  {
                    "value": "Confidential — internal records only",
                    "label": "Confidential — internal records only"
                  }
                ],
                "default": "Confidential — internal records only"
              }
            ],
            "help": "Amounts are held confidentially unless you say otherwise on the row.",
            "layout": "cards",
            "rowEntity": "commitment",
            "rowLabel": "{commitment_fund_name} — {commitment_gp_name}",
            "toggle": {
              "key": "nothing_to_add",
              "label": "No commitments to report"
            },
            "confidentiality": "row"
          },
          {
            "key": "vehicles",
            "label": "Vehicles you manage",
            "kind": "repeatable",
            "tab": "commitments",
            "order": 1,
            "fields": [],
            "help": "Only vehicles your institution runs itself, not funds you have committed to.",
            "layout": "cards",
            "rowEntity": "fund_vehicle",
            "rowLabel": "{fund_name} ({vintage_year})",
            "toggle": {
              "key": "nothing_to_add",
              "label": "We do not manage our own vehicles"
            },
            "confidentiality": "row",
            "blocks": [
              {
                "key": "vehicle_identity",
                "label": "Fund",
                "fields": [
                  {
                    "key": "fund_name",
                    "path": "commitments.vehicles.fund_name",
                    "label": "Fund name",
                    "input": "text",
                    "tab": "commitments",
                    "section": "vehicles",
                    "order": 0,
                    "required": "always",
                    "block": "vehicle_identity",
                    "coreTable": "investment_vehicles",
                    "coreField": "fund_name",
                    "dataType": "SingleLineText"
                  },
                  {
                    "key": "vintage_year",
                    "path": "commitments.vehicles.vintage_year",
                    "label": "Vintage year",
                    "input": "year",
                    "tab": "commitments",
                    "section": "vehicles",
                    "order": 1,
                    "required": "never",
                    "block": "vehicle_identity",
                    "coreTable": "investment_vehicles",
                    "coreField": "vintage_year",
                    "dataType": "Number"
                  },
                  {
                    "key": "fund_type",
                    "path": "commitments.vehicles.fund_type",
                    "label": "Fund type",
                    "input": "multiselect",
                    "tab": "commitments",
                    "section": "vehicles",
                    "order": 2,
                    "required": "never",
                    "block": "vehicle_identity",
                    "options": [
                      {
                        "value": "private-equity",
                        "label": "Private Equity"
                      },
                      {
                        "value": "venture-capital",
                        "label": "Venture Capital"
                      },
                      {
                        "value": "private-credit",
                        "label": "Private Credit"
                      },
                      {
                        "value": "infrastructure",
                        "label": "Infrastructure"
                      },
                      {
                        "value": "real-estate",
                        "label": "Real Estate"
                      },
                      {
                        "value": "impact-fund",
                        "label": "Impact Fund"
                      }
                    ],
                    "taxonomy": "fund_types",
                    "coreTable": "investment_vehicles",
                    "coreField": "fund_type",
                    "dataType": "Links"
                  },
                  {
                    "key": "fund_strategy",
                    "path": "commitments.vehicles.fund_strategy",
                    "label": "Fund strategy",
                    "input": "multiselect",
                    "tab": "commitments",
                    "section": "vehicles",
                    "order": 3,
                    "required": "never",
                    "block": "vehicle_identity",
                    "options": [
                      {
                        "value": "seed-&-early-stage",
                        "label": "Seed & Early-stage"
                      },
                      {
                        "value": "expansion-/-late-stage",
                        "label": "Expansion / Late-stage"
                      },
                      {
                        "value": "growth-equity",
                        "label": "Growth Equity"
                      },
                      {
                        "value": "buyout",
                        "label": "Buyout"
                      },
                      {
                        "value": "mezzanine",
                        "label": "Mezzanine"
                      },
                      {
                        "value": "direct-lending",
                        "label": "Direct Lending"
                      },
                      {
                        "value": "venture-debt",
                        "label": "Venture Debt"
                      },
                      {
                        "value": "distressed-/-special-situations",
                        "label": "Distressed / Special Situations"
                      },
                      {
                        "value": "fund-of-funds",
                        "label": "Fund of Funds"
                      },
                      {
                        "value": "secondaries-(lp-led-&-gp-led/continuation-vehicles)",
                        "label": "Secondaries (LP-led & GP-led/continuation vehicles)"
                      }
                    ],
                    "taxonomy": "fund_strategies",
                    "coreTable": "investment_vehicles",
                    "coreField": "fund_strategy",
                    "dataType": "Links"
                  },
                  {
                    "key": "nature_of_fund",
                    "path": "commitments.vehicles.nature_of_fund",
                    "label": "Nature of fund",
                    "input": "select",
                    "tab": "commitments",
                    "section": "vehicles",
                    "order": 4,
                    "required": "never",
                    "block": "vehicle_identity",
                    "options": [
                      {
                        "value": "independent",
                        "label": "Independent"
                      },
                      {
                        "value": "captive",
                        "label": "Captive"
                      },
                      {
                        "value": "semi-captive",
                        "label": "Semi-Captive"
                      }
                    ],
                    "taxonomy": "nature_of_fund",
                    "coreTable": "investment_vehicles",
                    "coreField": "nature_of_fund",
                    "dataType": "SingleSelect"
                  },
                  {
                    "key": "fund_status",
                    "path": "commitments.vehicles.fund_status",
                    "label": "Fund status",
                    "input": "select",
                    "tab": "commitments",
                    "section": "vehicles",
                    "order": 5,
                    "required": "always",
                    "block": "vehicle_identity",
                    "options": [
                      {
                        "value": "active",
                        "label": "Active"
                      },
                      {
                        "value": "closed",
                        "label": "Closed"
                      },
                      {
                        "value": "fully-invested",
                        "label": "Fully Invested"
                      },
                      {
                        "value": "exited",
                        "label": "Exited"
                      }
                    ],
                    "taxonomy": "fund_statuses",
                    "coreTable": "investment_vehicles",
                    "coreField": "fund_status",
                    "dataType": "SingleSelect"
                  },
                  {
                    "key": "datahub.publication_permission",
                    "path": "commitments.vehicles.datahub.publication_permission",
                    "label": "Publication permission",
                    "input": "radio",
                    "tab": "commitments",
                    "section": "vehicles",
                    "order": 6,
                    "required": "always",
                    "block": "vehicle_identity",
                    "options": [
                      {
                        "value": "Stears may publish",
                        "label": "Stears may publish"
                      },
                      {
                        "value": "Confidential — internal records only",
                        "label": "Confidential — internal records only"
                      }
                    ],
                    "default": "Stears may publish"
                  }
                ]
              },
              {
                "key": "vehicle_capital",
                "label": "Size and deployment",
                "fields": [
                  {
                    "key": "size_target",
                    "path": "commitments.vehicles.size_target",
                    "label": "Target size",
                    "input": "money",
                    "tab": "commitments",
                    "section": "vehicles",
                    "order": 7,
                    "required": "never",
                    "block": "vehicle_capital",
                    "undisclosed": true,
                    "coreTable": "investment_vehicles",
                    "coreField": "size_target",
                    "dataType": "Currency"
                  },
                  {
                    "key": "size_closed",
                    "path": "commitments.vehicles.size_closed",
                    "label": "Amount closed",
                    "input": "money",
                    "tab": "commitments",
                    "section": "vehicles",
                    "order": 8,
                    "required": "never",
                    "block": "vehicle_capital",
                    "undisclosed": true,
                    "coreTable": "investment_vehicles",
                    "coreField": "size_closed",
                    "dataType": "Currency"
                  },
                  {
                    "key": "deployed",
                    "path": "commitments.vehicles.deployed",
                    "label": "Amount deployed",
                    "input": "money",
                    "tab": "commitments",
                    "section": "vehicles",
                    "order": 9,
                    "required": "never",
                    "block": "vehicle_capital",
                    "undisclosed": true,
                    "coreTable": "investment_vehicles",
                    "coreField": "deployed",
                    "dataType": "Currency"
                  },
                  {
                    "key": "fund_duration",
                    "path": "commitments.vehicles.fund_duration",
                    "label": "Fund life in years",
                    "input": "number",
                    "tab": "commitments",
                    "section": "vehicles",
                    "order": 10,
                    "required": "never",
                    "block": "vehicle_capital",
                    "step": 0.5,
                    "coreTable": "investment_vehicles",
                    "coreField": "fund_duration",
                    "dataType": "Number"
                  },
                  {
                    "key": "datahub.launch_date",
                    "path": "commitments.vehicles.datahub.launch_date",
                    "label": "Fund launch date",
                    "input": "date",
                    "tab": "commitments",
                    "section": "vehicles",
                    "order": 11,
                    "required": "never",
                    "block": "vehicle_capital"
                  },
                  {
                    "key": "first_close_date",
                    "path": "commitments.vehicles.first_close_date",
                    "label": "First close",
                    "input": "date",
                    "tab": "commitments",
                    "section": "vehicles",
                    "order": 12,
                    "required": "never",
                    "block": "vehicle_capital",
                    "coreTable": "investment_vehicles",
                    "coreField": "first_close_date",
                    "dataType": "Date"
                  },
                  {
                    "key": "datahub.first_close_amount",
                    "path": "commitments.vehicles.datahub.first_close_amount",
                    "label": "Amount at first close",
                    "input": "money",
                    "tab": "commitments",
                    "section": "vehicles",
                    "order": 13,
                    "required": "never",
                    "block": "vehicle_capital",
                    "undisclosed": true
                  },
                  {
                    "key": "datahub.second_close_date",
                    "path": "commitments.vehicles.datahub.second_close_date",
                    "label": "Second close",
                    "input": "date",
                    "tab": "commitments",
                    "section": "vehicles",
                    "order": 14,
                    "required": "never",
                    "block": "vehicle_capital"
                  },
                  {
                    "key": "datahub.second_close_amount",
                    "path": "commitments.vehicles.datahub.second_close_amount",
                    "label": "Amount at second close",
                    "input": "money",
                    "tab": "commitments",
                    "section": "vehicles",
                    "order": 15,
                    "required": "never",
                    "block": "vehicle_capital",
                    "undisclosed": true
                  },
                  {
                    "key": "datahub.third_close_date",
                    "path": "commitments.vehicles.datahub.third_close_date",
                    "label": "Third close",
                    "input": "date",
                    "tab": "commitments",
                    "section": "vehicles",
                    "order": 16,
                    "required": "never",
                    "block": "vehicle_capital"
                  },
                  {
                    "key": "datahub.third_close_amount",
                    "path": "commitments.vehicles.datahub.third_close_amount",
                    "label": "Amount at third close",
                    "input": "money",
                    "tab": "commitments",
                    "section": "vehicles",
                    "order": 17,
                    "required": "never",
                    "block": "vehicle_capital",
                    "undisclosed": true
                  },
                  {
                    "key": "final_close_date",
                    "path": "commitments.vehicles.final_close_date",
                    "label": "Final close",
                    "input": "date",
                    "tab": "commitments",
                    "section": "vehicles",
                    "order": 18,
                    "required": "never",
                    "block": "vehicle_capital",
                    "visibleWhen": {
                      "field": "fund_status",
                      "in": [
                        "closed",
                        "fully-invested",
                        "exited"
                      ]
                    },
                    "coreTable": "investment_vehicles",
                    "coreField": "final_close_date",
                    "dataType": "Date"
                  }
                ]
              },
              {
                "key": "vehicle_mandate",
                "label": "Fund mandate",
                "fields": [
                  {
                    "key": "fund_regions_of_investment",
                    "path": "commitments.vehicles.fund_regions_of_investment",
                    "label": "Regions of investment",
                    "input": "multiselect",
                    "tab": "commitments",
                    "section": "vehicles",
                    "order": 19,
                    "required": "never",
                    "block": "vehicle_mandate",
                    "options": [
                      {
                        "value": "global",
                        "label": "Global"
                      },
                      {
                        "value": "pan-african",
                        "label": "Pan-African"
                      },
                      {
                        "value": "sub-saharan-africa",
                        "label": "Sub-Saharan Africa"
                      },
                      {
                        "value": "northern-africa",
                        "label": "Northern Africa"
                      },
                      {
                        "value": "eastern-africa",
                        "label": "Eastern Africa"
                      },
                      {
                        "value": "western-africa",
                        "label": "Western Africa"
                      },
                      {
                        "value": "central-africa",
                        "label": "Central Africa"
                      },
                      {
                        "value": "southern-africa",
                        "label": "Southern Africa"
                      },
                      {
                        "value": "europe",
                        "label": "Europe"
                      },
                      {
                        "value": "asia",
                        "label": "Asia"
                      },
                      {
                        "value": "middle-east",
                        "label": "Middle East"
                      },
                      {
                        "value": "americas",
                        "label": "Americas"
                      },
                      {
                        "value": "southern-america",
                        "label": "Southern America"
                      },
                      {
                        "value": "northern-america",
                        "label": "Northern America"
                      },
                      {
                        "value": "central-america",
                        "label": "Central America"
                      },
                      {
                        "value": "latin-america",
                        "label": "Latin America"
                      },
                      {
                        "value": "australia",
                        "label": "Australia"
                      },
                      {
                        "value": "eurasia",
                        "label": "Eurasia"
                      },
                      {
                        "value": "oceania",
                        "label": "Oceania"
                      }
                    ],
                    "taxonomy": "regions",
                    "coreTable": "investment_vehicles",
                    "coreField": "fund_regions_of_investment",
                    "dataType": "Links"
                  },
                  {
                    "key": "fund_sectors",
                    "path": "commitments.vehicles.fund_sectors",
                    "label": "Sector focus",
                    "input": "multiselect",
                    "tab": "commitments",
                    "section": "vehicles",
                    "order": 20,
                    "required": "never",
                    "block": "vehicle_mandate",
                    "options": [
                      {
                        "value": "sector-agnostic",
                        "label": "Sector Agnostic"
                      },
                      {
                        "value": "macroeconomy",
                        "label": "Macroeconomy"
                      },
                      {
                        "value": "financial-services",
                        "label": "Financial Services"
                      },
                      {
                        "value": "energy-utilities",
                        "label": "Energy & Utilities"
                      },
                      {
                        "value": "consumer-staples",
                        "label": "Consumer Staples"
                      },
                      {
                        "value": "consumer-discretionary",
                        "label": "Consumer Discretionary"
                      },
                      {
                        "value": "information-technology",
                        "label": "Information Technology"
                      },
                      {
                        "value": "communication-services",
                        "label": "Communication Services"
                      },
                      {
                        "value": "agriculture",
                        "label": "Agriculture"
                      },
                      {
                        "value": "industrials",
                        "label": "Industrials"
                      },
                      {
                        "value": "healthcare",
                        "label": "Healthcare"
                      },
                      {
                        "value": "real-estate",
                        "label": "Real Estate"
                      },
                      {
                        "value": "materials",
                        "label": "Materials"
                      }
                    ],
                    "taxonomy": "fund_sector_focus",
                    "coreTable": "investment_vehicles",
                    "coreField": "fund_sectors",
                    "dataType": "Links"
                  },
                  {
                    "key": "fund_ticket_size",
                    "path": "commitments.vehicles.fund_ticket_size",
                    "label": "Ticket size range",
                    "input": "multiselect",
                    "tab": "commitments",
                    "section": "vehicles",
                    "order": 21,
                    "required": "never",
                    "block": "vehicle_mandate",
                    "options": [
                      {
                        "value": "lt-100k",
                        "label": "< 100K"
                      },
                      {
                        "value": "100k-500k",
                        "label": "100K - 500K"
                      },
                      {
                        "value": "500k-1m",
                        "label": "500K - 1 Mn"
                      },
                      {
                        "value": "1m-25m",
                        "label": "1 Mn - 25 Mn"
                      },
                      {
                        "value": "25m-50m",
                        "label": "25 Mn - 50 Mn"
                      },
                      {
                        "value": "50m-100m",
                        "label": "50 Mn - 100 Mn"
                      },
                      {
                        "value": "100m-500m",
                        "label": "100 Mn - 500 Mn"
                      },
                      {
                        "value": "gt-500m",
                        "label": "More than 500 Mn"
                      }
                    ],
                    "taxonomy": "fund_ticket_sizes",
                    "coreTable": "investment_vehicles",
                    "coreField": "fund_ticket_size",
                    "dataType": "Links"
                  },
                  {
                    "key": "fund_ticket_size_currency",
                    "path": "commitments.vehicles.fund_ticket_size_currency",
                    "label": "Ticket size currency",
                    "input": "select",
                    "tab": "commitments",
                    "section": "vehicles",
                    "order": 22,
                    "required": "never",
                    "block": "vehicle_mandate",
                    "options": [
                      {
                        "value": "USD",
                        "label": "USD"
                      },
                      {
                        "value": "NGN",
                        "label": "NGN"
                      },
                      {
                        "value": "ZAR",
                        "label": "ZAR"
                      },
                      {
                        "value": "KES",
                        "label": "KES"
                      },
                      {
                        "value": "GHS",
                        "label": "GHS"
                      },
                      {
                        "value": "EGP",
                        "label": "EGP"
                      },
                      {
                        "value": "MAD",
                        "label": "MAD"
                      },
                      {
                        "value": "TZS",
                        "label": "TZS"
                      },
                      {
                        "value": "UGX",
                        "label": "UGX"
                      },
                      {
                        "value": "RWF",
                        "label": "RWF"
                      },
                      {
                        "value": "XOF",
                        "label": "XOF"
                      },
                      {
                        "value": "XAF",
                        "label": "XAF"
                      },
                      {
                        "value": "ZMW",
                        "label": "ZMW"
                      },
                      {
                        "value": "MUR",
                        "label": "MUR"
                      },
                      {
                        "value": "EUR",
                        "label": "EUR"
                      },
                      {
                        "value": "GBP",
                        "label": "GBP"
                      }
                    ],
                    "taxonomy": "currencies",
                    "coreTable": "investment_vehicles",
                    "coreField": "fund_ticket_size_currency",
                    "dataType": "SingleSelect"
                  },
                  {
                    "key": "fund_location_criteria",
                    "path": "commitments.vehicles.fund_location_criteria",
                    "label": "Location criteria",
                    "input": "longtext",
                    "tab": "commitments",
                    "section": "vehicles",
                    "order": 23,
                    "required": "never",
                    "block": "vehicle_mandate",
                    "maxLength": 5000,
                    "coreTable": "investment_vehicles",
                    "coreField": "fund_location_criteria",
                    "dataType": "LongText"
                  },
                  {
                    "key": "environmental_criteria",
                    "path": "commitments.vehicles.environmental_criteria",
                    "label": "Environmental criteria",
                    "input": "longtext",
                    "tab": "commitments",
                    "section": "vehicles",
                    "order": 24,
                    "required": "never",
                    "block": "vehicle_mandate",
                    "maxLength": 5000,
                    "coreTable": "investment_vehicles",
                    "coreField": "environmental_criteria",
                    "dataType": "LongText"
                  },
                  {
                    "key": "social_criteria",
                    "path": "commitments.vehicles.social_criteria",
                    "label": "Social criteria",
                    "input": "longtext",
                    "tab": "commitments",
                    "section": "vehicles",
                    "order": 25,
                    "required": "never",
                    "block": "vehicle_mandate",
                    "maxLength": 5000,
                    "coreTable": "investment_vehicles",
                    "coreField": "social_criteria",
                    "dataType": "LongText"
                  },
                  {
                    "key": "governance_criteria",
                    "path": "commitments.vehicles.governance_criteria",
                    "label": "Governance criteria",
                    "input": "longtext",
                    "tab": "commitments",
                    "section": "vehicles",
                    "order": 26,
                    "required": "never",
                    "block": "vehicle_mandate",
                    "maxLength": 5000,
                    "coreTable": "investment_vehicles",
                    "coreField": "governance_criteria",
                    "dataType": "LongText"
                  },
                  {
                    "key": "financial_and_other_criteria",
                    "path": "commitments.vehicles.financial_and_other_criteria",
                    "label": "Financial and other criteria",
                    "input": "longtext",
                    "tab": "commitments",
                    "section": "vehicles",
                    "order": 27,
                    "required": "never",
                    "block": "vehicle_mandate",
                    "maxLength": 5000,
                    "coreTable": "investment_vehicles",
                    "coreField": "financial_and_other_criteria",
                    "dataType": "LongText"
                  }
                ]
              }
            ]
          }
        ],
        "intro": "The funds you have committed capital to, and any vehicle you run yourself."
      },
      {
        "key": "portfolio",
        "number": 6,
        "label": "Portfolio and co-investments",
        "shortLabel": "Portfolio",
        "coreTables": [
          "portfolio_investments"
        ],
        "sections": [
          {
            "key": "holdings",
            "label": "Direct and co-investments",
            "kind": "repeatable",
            "tab": "portfolio",
            "order": 0,
            "fields": [],
            "layout": "cards",
            "rowEntity": "co_investment",
            "rowLabel": "{portfolio_company_name}",
            "toggle": {
              "key": "nothing_to_add",
              "label": "No direct or co-investments to report"
            },
            "confidentiality": "row",
            "blocks": [
              {
                "key": "holding_identity",
                "label": "Company",
                "fields": [
                  {
                    "key": "portfolio_company_name",
                    "path": "portfolio.holdings.portfolio_company_name",
                    "label": "Company",
                    "input": "text",
                    "tab": "portfolio",
                    "section": "holdings",
                    "order": 0,
                    "required": "always",
                    "block": "holding_identity",
                    "coreTable": "portfolio_investments",
                    "coreField": "portfolio_company_name",
                    "dataType": "SingleLineText"
                  },
                  {
                    "key": "portfolio_company_country",
                    "path": "portfolio.holdings.portfolio_company_country",
                    "label": "Country",
                    "input": "select",
                    "tab": "portfolio",
                    "section": "holdings",
                    "order": 1,
                    "required": "never",
                    "block": "holding_identity",
                    "options": [
                      {
                        "value": "nigeria",
                        "label": "Nigeria"
                      },
                      {
                        "value": "ghana",
                        "label": "Ghana"
                      },
                      {
                        "value": "senegal",
                        "label": "Senegal"
                      },
                      {
                        "value": "cote-divoire",
                        "label": "Côte d'Ivoire"
                      },
                      {
                        "value": "mali",
                        "label": "Mali"
                      },
                      {
                        "value": "benin",
                        "label": "Benin"
                      },
                      {
                        "value": "togo",
                        "label": "Togo"
                      },
                      {
                        "value": "burkina-faso",
                        "label": "Burkina Faso"
                      },
                      {
                        "value": "sierra-leone",
                        "label": "Sierra Leone"
                      },
                      {
                        "value": "liberia",
                        "label": "Liberia"
                      },
                      {
                        "value": "guinea",
                        "label": "Guinea"
                      },
                      {
                        "value": "kenya",
                        "label": "Kenya"
                      },
                      {
                        "value": "tanzania",
                        "label": "Tanzania"
                      },
                      {
                        "value": "uganda",
                        "label": "Uganda"
                      },
                      {
                        "value": "rwanda",
                        "label": "Rwanda"
                      },
                      {
                        "value": "ethiopia",
                        "label": "Ethiopia"
                      },
                      {
                        "value": "somalia",
                        "label": "Somalia"
                      },
                      {
                        "value": "burundi",
                        "label": "Burundi"
                      },
                      {
                        "value": "south-sudan",
                        "label": "South Sudan"
                      },
                      {
                        "value": "south-africa",
                        "label": "South Africa"
                      },
                      {
                        "value": "botswana",
                        "label": "Botswana"
                      },
                      {
                        "value": "namibia",
                        "label": "Namibia"
                      },
                      {
                        "value": "zambia",
                        "label": "Zambia"
                      },
                      {
                        "value": "zimbabwe",
                        "label": "Zimbabwe"
                      },
                      {
                        "value": "mozambique",
                        "label": "Mozambique"
                      },
                      {
                        "value": "malawi",
                        "label": "Malawi"
                      },
                      {
                        "value": "mauritius",
                        "label": "Mauritius"
                      },
                      {
                        "value": "egypt",
                        "label": "Egypt"
                      },
                      {
                        "value": "morocco",
                        "label": "Morocco"
                      },
                      {
                        "value": "tunisia",
                        "label": "Tunisia"
                      },
                      {
                        "value": "algeria",
                        "label": "Algeria"
                      },
                      {
                        "value": "libya",
                        "label": "Libya"
                      },
                      {
                        "value": "sudan",
                        "label": "Sudan"
                      },
                      {
                        "value": "cameroon",
                        "label": "Cameroon"
                      },
                      {
                        "value": "drc",
                        "label": "Democratic Republic of the Congo"
                      },
                      {
                        "value": "gabon",
                        "label": "Gabon"
                      },
                      {
                        "value": "chad",
                        "label": "Chad"
                      },
                      {
                        "value": "congo",
                        "label": "Republic of the Congo"
                      },
                      {
                        "value": "united-kingdom",
                        "label": "United Kingdom"
                      },
                      {
                        "value": "united-states",
                        "label": "United States"
                      },
                      {
                        "value": "netherlands",
                        "label": "Netherlands"
                      },
                      {
                        "value": "france",
                        "label": "France"
                      },
                      {
                        "value": "united-arab-emirates",
                        "label": "United Arab Emirates"
                      },
                      {
                        "value": "mauritius-ibc",
                        "label": "Mauritius (IBC)"
                      },
                      {
                        "value": "cayman-islands",
                        "label": "Cayman Islands"
                      },
                      {
                        "value": "luxembourg",
                        "label": "Luxembourg"
                      }
                    ],
                    "taxonomy": "countries",
                    "coreTable": "portfolio_investments",
                    "coreField": "portfolio_company_country",
                    "dataType": "Links"
                  },
                  {
                    "key": "portfolio_company_sector",
                    "path": "portfolio.holdings.portfolio_company_sector",
                    "label": "Sector",
                    "input": "select",
                    "tab": "portfolio",
                    "section": "holdings",
                    "order": 2,
                    "required": "never",
                    "block": "holding_identity",
                    "options": [
                      {
                        "value": "financial-services",
                        "label": "Financial Services"
                      },
                      {
                        "value": "technology",
                        "label": "Technology"
                      },
                      {
                        "value": "consumer-goods",
                        "label": "Consumer Goods & Services"
                      },
                      {
                        "value": "healthcare",
                        "label": "Healthcare"
                      },
                      {
                        "value": "energy-utilities",
                        "label": "Energy & Utilities"
                      },
                      {
                        "value": "agriculture",
                        "label": "Agriculture"
                      },
                      {
                        "value": "industrials",
                        "label": "Industrials"
                      },
                      {
                        "value": "telecommunications",
                        "label": "Telecommunications"
                      },
                      {
                        "value": "real-estate",
                        "label": "Real Estate"
                      },
                      {
                        "value": "transport-logistics",
                        "label": "Transport & Logistics"
                      },
                      {
                        "value": "education",
                        "label": "Education"
                      },
                      {
                        "value": "media-entertainment",
                        "label": "Media & Entertainment"
                      },
                      {
                        "value": "mining-natural-resources",
                        "label": "Mining & Natural Resources"
                      },
                      {
                        "value": "construction",
                        "label": "Construction"
                      },
                      {
                        "value": "hospitality-tourism",
                        "label": "Hospitality & Tourism"
                      },
                      {
                        "value": "professional-services",
                        "label": "Professional Services"
                      }
                    ],
                    "taxonomy": "sectors",
                    "coreTable": "portfolio_investments",
                    "coreField": "portfolio_company_sector",
                    "dataType": "Links"
                  },
                  {
                    "key": "portfolio_fund_name",
                    "path": "portfolio.holdings.portfolio_fund_name",
                    "label": "Alongside fund or manager",
                    "input": "select",
                    "tab": "portfolio",
                    "section": "holdings",
                    "order": 3,
                    "required": "never",
                    "block": "holding_identity",
                    "help": "Leave blank for a wholly direct investment.",
                    "optionsFromRows": {
                      "tab": "commitments",
                      "section": "vehicles",
                      "field": "fund_name"
                    },
                    "coreTable": "portfolio_investments",
                    "coreField": "portfolio_fund_name",
                    "dataType": "SingleLineText"
                  },
                  {
                    "key": "portfolio_co_investors",
                    "path": "portfolio.holdings.portfolio_co_investors",
                    "label": "Co-investors",
                    "input": "taglist",
                    "tab": "portfolio",
                    "section": "holdings",
                    "order": 4,
                    "required": "never",
                    "block": "holding_identity",
                    "coreTable": "portfolio_investments",
                    "coreField": "portfolio_co_investors",
                    "dataType": "Links"
                  }
                ]
              },
              {
                "key": "holding_terms",
                "label": "Holding",
                "fields": [
                  {
                    "key": "portfolio_instrument",
                    "path": "portfolio.holdings.portfolio_instrument",
                    "label": "Instrument",
                    "input": "multiselect",
                    "tab": "portfolio",
                    "section": "holdings",
                    "order": 5,
                    "required": "never",
                    "block": "holding_terms",
                    "options": [
                      {
                        "value": "equity",
                        "label": "Equity"
                      },
                      {
                        "value": "debt",
                        "label": "Debt"
                      },
                      {
                        "value": "mezzanine",
                        "label": "Mezzanine"
                      },
                      {
                        "value": "safe",
                        "label": "SAFE"
                      }
                    ],
                    "taxonomy": "gp_instruments",
                    "coreTable": "portfolio_investments",
                    "coreField": "portfolio_instrument",
                    "dataType": "Links"
                  },
                  {
                    "key": "portfolio_stage",
                    "path": "portfolio.holdings.portfolio_stage",
                    "label": "Stage at entry",
                    "input": "select",
                    "tab": "portfolio",
                    "section": "holdings",
                    "order": 6,
                    "required": "never",
                    "block": "holding_terms",
                    "options": [
                      {
                        "value": "pre-seed",
                        "label": "Pre-seed"
                      },
                      {
                        "value": "seed",
                        "label": "Seed"
                      },
                      {
                        "value": "series-a",
                        "label": "Series A"
                      },
                      {
                        "value": "series-b",
                        "label": "Series B"
                      },
                      {
                        "value": "series-c",
                        "label": "Series C"
                      },
                      {
                        "value": "series-d+",
                        "label": "Series D+"
                      },
                      {
                        "value": "growth-stage",
                        "label": "Growth Stage"
                      },
                      {
                        "value": "growth-equity",
                        "label": "Growth Equity"
                      },
                      {
                        "value": "buyout",
                        "label": "Buyout"
                      }
                    ],
                    "taxonomy": "investment_stages",
                    "coreTable": "portfolio_investments",
                    "coreField": "portfolio_stage",
                    "dataType": "Links"
                  },
                  {
                    "key": "portfolio_first_investment_date",
                    "path": "portfolio.holdings.portfolio_first_investment_date",
                    "label": "First investment date",
                    "input": "date",
                    "tab": "portfolio",
                    "section": "holdings",
                    "order": 7,
                    "required": "never",
                    "block": "holding_terms",
                    "precision": true,
                    "coreTable": "portfolio_investments",
                    "coreField": "portfolio_first_investment_date",
                    "dataType": "Date"
                  },
                  {
                    "key": "portfolio_amount_invested",
                    "path": "portfolio.holdings.portfolio_amount_invested",
                    "label": "Amount invested",
                    "input": "money",
                    "tab": "portfolio",
                    "section": "holdings",
                    "order": 8,
                    "required": "never",
                    "block": "holding_terms",
                    "undisclosed": true,
                    "coreTable": "portfolio_investments",
                    "coreField": "portfolio_amount_invested",
                    "dataType": "Currency"
                  },
                  {
                    "key": "portfolio_stake",
                    "path": "portfolio.holdings.portfolio_stake",
                    "label": "Stake held (%)",
                    "input": "percent",
                    "tab": "portfolio",
                    "section": "holdings",
                    "order": 9,
                    "required": "never",
                    "block": "holding_terms",
                    "coreTable": "portfolio_investments",
                    "coreField": "portfolio_stake",
                    "dataType": "Decimal"
                  },
                  {
                    "key": "portfolio_board_seat",
                    "path": "portfolio.holdings.portfolio_board_seat",
                    "label": "Board seat",
                    "input": "radio",
                    "tab": "portfolio",
                    "section": "holdings",
                    "order": 10,
                    "required": "never",
                    "block": "holding_terms",
                    "options": [
                      {
                        "value": "Yes",
                        "label": "Yes"
                      },
                      {
                        "value": "No",
                        "label": "No"
                      }
                    ],
                    "coreTable": "portfolio_investments",
                    "coreField": "portfolio_board_seat",
                    "dataType": "SingleSelect"
                  },
                  {
                    "key": "portfolio_status",
                    "path": "portfolio.holdings.portfolio_status",
                    "label": "Holding status",
                    "input": "select",
                    "tab": "portfolio",
                    "section": "holdings",
                    "order": 11,
                    "required": "always",
                    "block": "holding_terms",
                    "options": [
                      {
                        "value": "Current",
                        "label": "Current"
                      },
                      {
                        "value": "Partially exited",
                        "label": "Partially exited"
                      },
                      {
                        "value": "Fully exited",
                        "label": "Fully exited"
                      },
                      {
                        "value": "Written off",
                        "label": "Written off"
                      }
                    ],
                    "coreTable": "portfolio_investments",
                    "coreField": "portfolio_status",
                    "dataType": "SingleSelect"
                  },
                  {
                    "key": "portfolio_exit_date",
                    "path": "portfolio.holdings.portfolio_exit_date",
                    "label": "Exit date",
                    "input": "date",
                    "tab": "portfolio",
                    "section": "holdings",
                    "order": 12,
                    "required": "conditional",
                    "block": "holding_terms",
                    "requiredWhen": {
                      "field": "portfolio_status",
                      "in": [
                        "Partially exited",
                        "Fully exited"
                      ]
                    },
                    "visibleWhen": {
                      "field": "portfolio_status",
                      "in": [
                        "Partially exited",
                        "Fully exited",
                        "Written off"
                      ]
                    },
                    "coreTable": "portfolio_investments",
                    "coreField": "portfolio_exit_date",
                    "dataType": "Date"
                  },
                  {
                    "key": "portfolio_exit_route",
                    "path": "portfolio.holdings.portfolio_exit_route",
                    "label": "Exit route",
                    "input": "select",
                    "tab": "portfolio",
                    "section": "holdings",
                    "order": 13,
                    "required": "never",
                    "block": "holding_terms",
                    "visibleWhen": {
                      "field": "portfolio_status",
                      "in": [
                        "Partially exited",
                        "Fully exited"
                      ]
                    },
                    "options": [
                      {
                        "value": "Trade sale",
                        "label": "Trade sale"
                      },
                      {
                        "value": "Secondary sale",
                        "label": "Secondary sale"
                      },
                      {
                        "value": "Management buyout",
                        "label": "Management buyout"
                      },
                      {
                        "value": "IPO",
                        "label": "IPO"
                      },
                      {
                        "value": "Recapitalisation",
                        "label": "Recapitalisation"
                      },
                      {
                        "value": "Liquidation",
                        "label": "Liquidation"
                      },
                      {
                        "value": "Other",
                        "label": "Other"
                      }
                    ],
                    "coreTable": "portfolio_investments",
                    "coreField": "portfolio_exit_route",
                    "dataType": "SingleSelect"
                  },
                  {
                    "key": "datahub.publication_permission",
                    "path": "portfolio.holdings.datahub.publication_permission",
                    "label": "Publication permission",
                    "input": "radio",
                    "tab": "portfolio",
                    "section": "holdings",
                    "order": 14,
                    "required": "always",
                    "block": "holding_terms",
                    "options": [
                      {
                        "value": "Stears may publish",
                        "label": "Stears may publish"
                      },
                      {
                        "value": "Confidential — internal records only",
                        "label": "Confidential — internal records only"
                      }
                    ],
                    "default": "Stears may publish"
                  }
                ]
              }
            ]
          }
        ],
        "intro": "Companies you hold directly or alongside a manager."
      },
      {
        "key": "documents",
        "number": 7,
        "label": "Documents",
        "shortLabel": "Documents",
        "coreTables": [],
        "sections": [
          {
            "key": "documents",
            "label": "Supporting documents",
            "kind": "uploads",
            "tab": "documents",
            "order": 0,
            "fields": [],
            "toggle": {
              "key": "nothing_to_add",
              "label": "No documents to upload"
            }
          }
        ],
        "intro": "Optional. Annual reports, investment policy statements or anything that supports your submission. Files are private to Stears."
      },
      {
        "key": "review",
        "number": 8,
        "label": "Review and submit",
        "shortLabel": "Review",
        "coreTables": [],
        "sections": [
          {
            "key": "review",
            "label": "Review",
            "kind": "review",
            "tab": "review",
            "order": 0,
            "fields": []
          }
        ]
      }
    ]
  }
] as const satisfies FormDef[]

export const formByKey = Object.fromEntries(forms.map((f) => [f.key, f])) as Record<string, FormDef>
export const formKeys = forms.map((f) => f.key)

export const tabsByForm: Record<string, TabDef[]> = Object.fromEntries(forms.map((f) => [f.key, f.tabs]))

/** The company form, for the call sites that predate the fund forms. */
export const tabs: TabDef[] = tabsByForm['company']!
export const tabByKey = Object.fromEntries(tabs.map((t) => [t.key, t])) as Record<string, TabDef>
export const tabKeys = tabs.map((t) => t.key)
